const pageT = {
  ko: {
    // ── HomePage ──
    home_seoTitle: '복사기 복합기 렌탈·판매 전문 | 일광오피스 - 가격비교·토너·무상유지보수',
    home_seoDesc:
      '복사기, 복합기 전문 일광오피스. 사무용 복사기 렌탈 월 3만원부터, 컬러·흑백 복합기 판매, 토너 소모품 최저가 비교. 삼성·캐논·후지필름·교세라·신도리코·HP 복사기 AI 맞춤 추천. 전국 무상 출장 유지보수.',
    home_heroTitle: '스토어.',
    home_heroSub: '사무실에 꼭 맞는 복합기를 선택하는 가장 좋은 방법.',
    home_askAi: 'AI에게 물어보기',
    home_askAiDesc: '용도에 맞는 장비를 AI가 찾아드립니다.',
    home_callConsult: '전화 상담 연결',
    home_callConsultDesc: '담당자와 바로 통화하세요.',
    home_catColor: '컬러복합기',
    home_catMono: '흑백복합기',
    home_catPrinter: '프린터',
    home_catToner: '토너·소모품',
    home_catConsult: '상담',
    home_catOwnMall: '자사몰',
    home_catAi: 'AI 추천',
    home_catDigital: '고속인쇄기',
    home_catDigitalDesc: '고속 인쇄기',
    home_catLarge: '대형 복합기',
    home_catLargeDesc: 'A3 대형 복합기',
    home_catSmall: '소형복합기',
    home_catSmallDesc: 'A4 데스크톱 복합기',
    home_catPrinterDesc: '레이저·잉크젯 프린터',
    home_catTonerDesc: '정품·호환·재생 토너',
    home_searchTitle: '제품 검색',
    home_searchDesc: '모델명, 브랜드, 토너번호 검색',
    home_noResults: '검색 결과가 없습니다',
    home_searchHint2: '검색해보세요',
    home_newProducts: '신제품',
    home_newProductsDesc: '새롭게 등록된 제품을 만나보세요',
    home_rental: '렌탈',
    home_monthlyPrice: '월 {price}원~',
    home_priceInquiry: '가격문의',
    home_quickLinks: '빠른 링크.',
    home_quickLinksDesc: '자주 찾는 페이지에 바로 접근하세요.',
    home_productStore: '제품 스토어',
    home_aiRecommend: 'AI 추천',
    home_productCompare: '제품비교',
    home_cart: '장바구니',
    home_wishlist: '관심목록',
    home_myErp: '마이 ERP',
    home_nationalRental: '전국 렌탈',
    home_consult: '상담',
    home_sitemapLink: '사이트맵',
    home_phoneConsult: '전화 상담',
    home_consultSection: '상담',
    home_consultDesc: '렌탈 견적, 제품 문의, 실시간 상담까지 한 곳에서 해결하세요.',
    home_rentalQuote: '렌탈 견적',
    home_rentalQuoteDesc: '자동 견적 계산기로 월 렌탈료를 즉시 확인하세요.',
    home_getQuote: '견적 받기 >',
    home_generalConsult: '일반 상담',
    home_generalConsultDesc: '구매, 토너, A/S 등 모든 문의를 접수하세요.',
    home_inquireNow: '문의하기 >',
    home_liveConsult: '실시간 상담',
    home_liveConsultDesc: '카카오톡, 채팅, 전화로 바로 상담하세요.',
    home_consultNow: '상담하기 >',
    home_globalInquiry: '해외 문의',
    home_rentalMall: '전국 렌탈몰.',
    home_rentalMallDesc1:
      '서울·부산·대구·인천·광주·대전·울산·세종·경기 등 전국 어디서나',
    home_rentalMallDesc2:
      '복합기·프린터 렌탈 서비스를 이용하세요. 무료 설치 & 정기 점검.',
    home_seoul: '서울',
    home_gwanghwamun: '광화문',
    home_busan: '부산',
    home_jagalchi: '자갈치시장',
    home_daegu: '대구',
    home_daeguSub: '사과·약령시',
    home_incheon: '인천',
    home_chinatown: '차이나타운',
    home_gyeonggi: '경기',
    home_suwon: '수원화성',
    home_gwangju: '광주',
    home_gwangjuSub: '무등산·비빔밥',
    home_daejeon: '대전',
    home_daejeonSub: '성심당·빵',
    home_jeju: '제주',
    home_jejuSub: '한라봉·감귤',
    home_viewAllRegions: '전국 260+ 지역 보기 >',
    home_nationalRentalMall: '전국 렌탈몰',
    home_regionsCount: '260+ 지역',
    home_goTo: '바로가기 >',
    home_aiConsult: 'AI 상담',
    home_productSearch: '제품 검색',
    home_searchPlaceholder: '복합기 모델명이나 토너 번호를 검색하세요.',
    home_searchBtn: '검색',
    home_searchHint: '예. "삼성 SL-XA225" 또는 "CLT-K3080S"',
    home_shortcuts: '바로가기',
    home_rentalInquiry: '렌탈 문의',
    home_ownMall: '자사몰',
    home_latestProducts: '최신 제품.',
    home_latestProductsDesc: '일광오피스 판매 제품.',
    home_viewAll: '모두 보기 >',
    home_rentalProducts: '렌탈 제품.',
    home_rentalProductsDesc: '합리적인 렌탈 복합기.',
    home_myErpSection: '마이 ERP.',
    home_myErpDesc: '내 사무실을 위한 맞춤형 관리 도구.',
    home_erpAi: 'AI 상담',
    home_erpAiDesc: 'AI에게 무엇이든 물어보세요. 복합기 추천부터 견적까지.',
    home_erpUsage: '사용량 분석',
    home_erpUsageDesc: '리포트 촬영 한 장이면 AI가 자동으로 분석합니다.',
    home_erpQuote: '견적서 작성',
    home_erpQuoteDesc: '맞춤 견적을 요청하고 관리하세요.',
    home_erpInquiry: '빠른 문의',
    home_erpInquiryDesc: '1분 만에 문의를 완료하세요.',
    home_erpBulk: '대량 구매',
    home_erpBulkDesc: '회사 구매담당자를 위한 전용 도구.',
    home_erpCart: '장바구니',
    home_erpCartDesc: '담은 제품을 확인하고 주문하세요.',
    home_services: '서비스.',
    home_servicesDesc: '일광오피스의 전문 서비스를 경험해보세요.',
    home_svcAi: 'AI 복합기 추천',
    home_svcAiDesc:
      '사무환경에 맞는 최적의 복합기를 AI가 분석해 추천해드립니다.',
    home_svcAiCta: '시작하기 >',
    home_svcRental: '렌탈 서비스',
    home_svcRentalDesc:
      '합리적인 월 렌탈 요금으로 복합기를 이용하세요. 유지보수까지 원스톱.',
    home_svcRentalCta: '렌탈 제품 보기 >',
    home_svcToner: '토너·소모품 구매',
    home_svcTonerDesc:
      '정품·호환·재생 토너를 합리적인 가격에 바로 구매하세요.',
    home_svcTonerCta: '토너 제품 보기 >',
    home_convenienceServices: '편의 서비스.',
    home_convenienceDesc: '사무기기 관리에 필요한 모든 도구, 한 곳에서.',
    home_usageAnalysis: '사용량 분석',
    home_usageAnalysisDesc:
      '리포트 촬영 한 장이면 AI가 자동으로 복합기 사용량을 분석합니다.',
    home_analyzeNow: '분석하기 >',
    home_orderTracking: '주문·배송 조회',
    home_orderTrackingDesc:
      '주문 내역을 확인하고 배송 상태를 실시간으로 추적하세요.',
    home_trackNow: '조회하기 >',
    home_quoteManage: '견적·문의 관리',
    home_quoteManageDesc:
      '요청한 견적서와 문의 내역을 한 번에 확인하고 관리하세요.',
    home_checkNow: '확인하기 >',
    home_guideTitle: '복합기·복사기·인쇄 가이드.',
    home_guideDesc:
      '사무실에 꼭 맞는 복합기를 선택하는 방법을 알아보세요.',
    home_guideQ1: '복합기란 무엇인가요?',
    home_guideA1:
      '복합기(MFP)는 프린터, 복사기, 스캐너, 팩스 기능을 하나로 결합한 사무기기입니다. 복사기와 달리 인쇄·스캔·팩스를 한 대에서 처리할 수 있어 사무실 공간 효율을 극대화합니다. 최신 복합기는 클라우드 연동, 모바일 인쇄, 자동 양면 인쇄까지 지원합니다.',
    home_guideQ2: '복사기와 복합기의 차이',
    home_guideA2:
      '복사기는 문서 복사에 특화된 기기이고, 복합기는 인쇄+복사+스캔+팩스 기능을 하나에 결합한 올인원 사무기기입니다. 현재 시장에서는 대부분 복합기가 표준이며, "복사기"라 하면 실질적으로 복합기를 의미합니다. 비용 면에서도 복합기가 더 경제적입니다.',
    home_guideQ3: '사무실 인쇄 비용 절감 방법',
    home_guideA3:
      '인쇄 비용 절감의 핵심은 ①렌탈 도입(초기비용↓), ②사용량 분석(IT 자동 리포트), ③호환/재생 토너 활용(비용 30-60% 절감), ④양면 인쇄 기본 설정입니다. 일광오피스의 AI 사용량 분석과 맞춤 렌탈 서비스로 인쇄 비용을 최적화하세요.',
    home_guideQ4: '복합기 렌탈 vs 구매',
    home_guideA4:
      '렌탈은 초기 비용이 낮고 유지보수·토너가 포함되어 관리가 편리합니다. 구매는 장기적으로 비용이 절감되지만 수리·소모품 비용을 별도로 부담해야 합니다. 5대 이상 대량 도입 시 렌탈이, 소량·단기 사용 시 구매가 유리합니다.',
    home_guideQ5: '정품 토너 vs 호환 토너 vs 재생 토너',
    home_tonerCompareTitle: '토너 종류별 비교',
    home_tonerCompare: '구분',
    home_tonerGenuine: '정품 토너',
    home_tonerCompatible: '호환 토너',
    home_tonerRemanufactured: '재생 토너',
    home_tonerPrice: '가격',
    home_tonerPriceGenuine: '높음 (기준가)',
    home_tonerPriceCompatible: '30~50% 수준',
    home_tonerPriceReman: '20~40% 수준',
    home_tonerQuality: '품질',
    home_tonerQualityGenuine: '최상',
    home_tonerQualityCompatible: '우수',
    home_tonerQualityReman: '보통~양호',
    home_tonerWarranty: 'AS 보증',
    home_tonerWarrantyGenuine: '제조사 보증',
    home_tonerWarrantyCompatible: '판매처 보증',
    home_tonerWarrantyReman: '제한적',
    home_tonerRecommend: '추천 대상',
    home_tonerRecommendGenuine: '고품질 인쇄 필요',
    home_tonerRecommendCompatible: '비용 절감 + 품질',
    home_tonerRecommendReman: '최저가 추구',
    home_tonerNote:
      '일광오피스에서는 삼성, 캐논, 후지제록스, 교세라, 신도리코, HP, 브라더 등 모든 브랜드의 정품·호환·재생 토너를 취급합니다.',
    home_brandTitle: '브랜드별 복합기·복사기',
    home_brandSamsung: '삼성 복합기',
    home_brandCanon: '캐논 복합기',
    home_brandFuji: '후지제록스 복합기',
    home_brandKyocera: '교세라 복합기',
    home_brandSindoh: '신도리코 복합기',
    home_brandHp: 'HP 복합기',
    home_brandBrother: '브라더 복합기',
    home_brandColor: '컬러 복합기',
    home_faqTitle: '자주 묻는 질문',
    home_faqQ1: '복합기 렌탈 가격은 얼마인가요?',
    home_faqA1:
      '복합기 렌탈 가격은 모델과 조건에 따라 월 3만원~30만원 수준입니다. 일광오피스 렌탈 계산기에서 즉시 확인하세요.',
    home_faqQ2: '복사기 렌탈도 가능한가요?',
    home_faqA2:
      '네, 복사기(복합기) 렌탈이 가능합니다. 컬러·흑백 복합기부터 프린터까지 전국 무료 설치·정기 점검 서비스를 제공합니다.',
    home_faqQ3: '사무실 인쇄 환경 최적화가 가능한가요?',
    home_faqA3:
      '네, AI 사용량 분석과 전문 컨설팅으로 사무실 인쇄 환경을 최적화해드립니다. 맞춤 견적과 비용 절감 방안을 제안합니다.',
    home_faqQ4: '토너는 어떤 종류가 있나요?',
    home_faqA4:
      '정품, 호환, 재생 토너 3종류가 있습니다. 사용 목적과 예산에 맞는 토너를 AI가 추천해드립니다.',
    home_faqQ5: '복합기 유지보수는 어떻게 진행되나요?',
    home_faqA5:
      '렌탈 시 월 1회 정기 점검, A/S 무상 출장, 토너·드럼 무상 교체가 포함됩니다. 구매 시에도 유지보수 계약이 가능합니다.',

    // ── StorePage ──
    store_seoTitle: '스토어 | 복합기·프린터·토너 통합 - 일광오피스',
    store_seoDesc: '고속인쇄기, 대형·소형 복합기, 프린터, 토너·소모품까지 한 곳에서. 렌탈·판매 가격비교.',
    store_heroTitle: '스토어',
    store_heroSub: '복합기·프린터·토너, 원하는 제품을 찾아보세요.',
    store_searchPlaceholder: '제품명, 브랜드, 모델명 검색',
    store_loading: '제품을 불러오는 중...',
    store_searchResults: '검색 결과',
    store_productUnit: '개 제품',
    store_noResults: '검색 결과가 없습니다.',
    store_tryOther: '다른 키워드로 검색해보세요.',
    store_shopByCategory: '카테고리별로 쇼핑하기',
    store_shopByCategorySub: '원하는 카테고리를 선택하세요.',
    store_viewAll: '전체보기',
    store_noProducts: '이 카테고리에 제품이 없습니다.',
    store_sortLatest: '추천·진열순',
    store_sortName: '이름순',
    store_sortPriceAsc: '가격 낮은순',
    store_sortPriceDesc: '가격 높은순',
    store_sortRental: '렌탈료 낮은순',
    store_saleRental: '렌탈',
    store_saleBoth: '판매+렌탈',
    store_salePurchase: '판매',
    store_inquiry: '문의하기',
    store_details: '상세보기',
    store_subAll: '전체',
    store_subToner: '토너',
    store_subDrum: '드럼',
    store_subDeveloper: '현상기',
    store_subFuser: '정착기',
    store_subParts: '부품',
    store_subPaper: '종이',

    // ── ProductsPage ──
    products_seoTitle:
      '복합기 복사기 전체 제품 | 렌탈·판매 가격비교 - 일광오피스',
    products_seoDesc:
      '삼성, 캐논, 후지제록스, 교세라, 신도리코 복합기·복사기 전 제품 비교. 컬러복합기, 흑백복합기, 프린터, 토너 가격비교. 렌탈 월 3만원부터.',
    products_heading: '스토어',
    products_subtitle: '제품을 클릭하면 상세 정보를 확인할 수 있습니다.',
    products_searchPlaceholder: '제품명 검색',
    products_loading: '로딩 중...',
    products_itemCount: '개',
    products_noResults: '검색 결과가 없습니다.',
    products_noResultsSub: '다른 분류나 키워드로 검색해보세요.',
    products_all: '전체',
    products_digitalPress: '고속인쇄기',
    products_largeMFP: '대형 복합기',
    products_smallMFP: '소형복합기',
    products_printer: '프린터',
    products_tonerSupplies: '토너와 소모품',
    products_colorCopier: '컬러복합기',
    products_monoCopier: '흑백복합기',
    products_copierRental: '복합기 렌탈',
    products_specialEquip: '특수장비',
    products_copierSales: '복합기 판매',
    products_sktecMall: '스토어',
    products_ikofficesRental: '렌탈',
    products_saleRental: '판매+렌탈',
    products_sale: '판매',
    products_rental: '렌탈',
    products_monthly: '월',
    products_won: '원',
    products_wonTilde: '원~',
    products_priceInquiry: '가격문의',
    products_prev: '이전',
    products_next: '다음',

    // ── SearchPage ──
    search_seoTitle:
      '복합기 AI 추천 검색 | 복사기·토너 찾기 - 일광오피스',
    search_seoDesc:
      'AI가 사무환경에 맞는 최적의 복합기·복사기를 추천해드립니다. 모델명·토너번호 검색.',
    search_heading: 'AI 검색',
    search_subtitle:
      'AI에게 질문하거나, 모델명으로 직접 검색하세요. 추천 제품은 자사몰 또는 렌탈몰로 바로 연결됩니다.',
    search_aiConsult: 'AI 상담',
    search_productSearch: '제품 검색',
    search_placeholder: '모델명, 브랜드, 토너번호 검색...',
    search_searching: '검색 중...',
    search_searchBtn: '검색',
    search_copiers: '복합기',
    search_count: '건',
    search_tonerSupplies: '토너·소모품',
    search_noResults: '검색 결과가 없습니다',
    search_initialHint: '복합기 모델명이나 토너 번호를 검색하세요.',
    search_exampleHint: '예. "삼성 SL-X4225" 또는 "CLT-K808S"',
    search_shortcuts: '바로가기',
    search_rentalInquiry: '렌탈 문의',
    search_ownMall: '자사몰',

    // ── ConsultationPage ──
    consult_seoTitle:
      '상담 - 렌탈 견적 · 실시간 상담 · 해외 문의 | 일광오피스',
    consult_seoDesc:
      '복합기, 프린터, 토너 렌탈 견적 및 상담 문의. 카카오톡·실시간 채팅·전화 상담. 해외 문의도 가능합니다.',
    consult_heading: '상담',
    consult_subtitle: '렌탈 견적, 제품 문의, 실시간 상담까지 한 곳에서.',
    consult_tabRental: '렌탈 견적',
    consult_tabGeneral: '일반 상담',
    consult_tabLive: '실시간 상담',
    consult_tabGlobal: '해외 문의',
    consult_calcTitle: '렌탈 요금 계산기',
    consult_planSelect: '요금제 선택',
    consult_monthly: '월',
    consult_won: '원',
    consult_bwPages: '흑백 {n}매',
    consult_colorPages: '컬러 {n}매',
    consult_adjustPages: '출력 매수 조정',
    consult_bwCount: '흑백 매수',
    consult_colorCount: '컬러 매수',
    consult_pages: '매',
    consult_default: '기본',
    consult_geoNotSupported: '이 브라우저는 위치 서비스를 지원하지 않습니다.',
    consult_geoError: '위치 정보를 가져올 수 없습니다.',
    consult_uploadError:
      '파일 업로드에 실패했습니다. (최대 10MB, jpg/png/pdf/doc/hwp)',
    consult_nameRequired: '이름을 입력해주세요.',
    consult_phoneRequired: '연락처를 입력해주세요.',
    consult_submitError: '문의 접수에 실패했습니다.',
    consult_successTitle: '문의가 접수되었습니다',
    consult_successDesc: '담당자가 빠르게 연락드리겠습니다.',
    consult_quoteSummary: '견적 요약',
    consult_monthlyRental: '월 렌탈료:',
    consult_autoQuoteNote:
      '견적서가 자동 생성되었습니다. 담당자 검토 후 발송됩니다.',
    consult_urgent: '급하신 경우',
    consult_callUs: '로 전화주세요.',
    consult_nationalRental: '전국 렌탈몰',
    consult_goHome: '홈으로',
    consult_selectProduct: '제품 선택',
    consult_selectProductPlaceholder: '렌탈 제품을 선택하세요',
    consult_searchProductPlaceholder: '제품명, 브랜드 검색...',
    consult_inquiryProduct: '문의 상품',
    consult_autoFilled: '회원 정보가 자동 입력되었습니다.',
    consult_name: '이름',
    consult_company: '회사명',
    consult_namePlaceholder: '홍길동',
    consult_companyPlaceholder: '(주) 회사명',
    consult_phone: '전화번호',
    consult_email: '이메일',
    consult_installRegion: '설치 지역',
    consult_locating: '위치 확인 중...',
    consult_myLocation: '현재위치',
    consult_additionalRequest: '추가 요청사항',
    consult_inquiryContent: '문의 내용',
    consult_contentPlaceholder:
      '문의하실 내용을 입력해주세요.\n(제품명, 수량, 설치 장소, 원하시는 조건 등)',
    consult_attachment: '첨부파일',
    consult_uploading: '업로드 중...',
    consult_uploadPrompt: '클릭하여 파일 첨부 (이미지, PDF, 문서)',
    consult_remove: '삭제',
    consult_estimatedMonthly: '예상 월 렌탈료 (VAT 포함)',
    consult_submitting: '접수 중...',
    consult_requestQuote: '견적서 요청',
    consult_sendInquiry: '문의 보내기',
    consult_responseNote: '접수 후 영업일 기준 1일 이내 연락드립니다.',
    consult_contentRequired: '문의 내용을 입력해주세요.',
    consult_generalTitle: '일반 상담',
    consult_generalDesc:
      '복합기, 프린터, 토너 등 사무기기에 관한 모든 궁금한 점을 문의해주세요. 전문 상담사가 친절하게 안내드립니다.',
    consult_sampleService: '샘플 출력 서비스',
    consult_sampleDesc:
      '원하시는 이미지를 첨부해 주시면 실제 복합기로 샘플 출력 후 우편 발송해 드립니다.',
    consult_inquiryType: '문의 유형',
    consult_typePurchase: '구매 문의',
    consult_typeToner: '토너/소모품 문의',
    consult_typeService: 'A/S · 유지보수',
    consult_typeOther: '기타 문의',
    consult_generalPlaceholder: '궁금한 점을 자유롭게 작성해주세요.',
    consult_liveIntro: '가장 빠르고 편리한 상담 방법을 선택하세요.',
    consult_recommended: '추천',
    consult_kakaoTitle: '카카오톡 상담',
    consult_kakaoDesc: '가장 빠른 응답을 받으실 수 있습니다',
    consult_kakaoCta: '카카오톡으로 연결 >',
    consult_liveChatTitle: '실시간 채팅',
    consult_liveChatDescLogin: '상담원과 바로 대화하세요',
    consult_liveChatDescNoLogin: '로그인 후 이용 가능합니다',
    consult_liveChatCtaLogin: '채팅 시작 >',
    consult_liveChatCtaNoLogin: '로그인 필요',
    consult_phoneTitle: '전화 상담',
    consult_businessHours: '평일 10:00 ~ 18:00',
    consult_chatHeader: '1:1 실시간 채팅',
    consult_chatGreeting: '안녕하세요! 일광오피스입니다',
    consult_chatSubtext: '궁금한 점을 물어보세요',
    consult_adminLabel: '상담원',
    consult_chatPlaceholder: '메시지를 입력하세요...',
    consult_allFieldsRequired: '모든 필수 항목을 입력해주세요.',
    consult_phoneConsult: '전화 상담',
    consult_consultHours: '상담 시간',

    // ── LoginPage ──
    login_error: '로그인에 실패했습니다',
    login_heading: '일광오피스 로그인',
    login_subtitle: '로그인하면 상담내역 저장, 견적서 작성, 빠른 문의가 가능합니다',
    login_email: '이메일',
    login_password: '비밀번호',
    login_pwPlaceholder: '6자 이상',
    login_submitting: '로그인 중...',
    login_emailLogin: '이메일로 로그인',
    login_noAccount: '아직 계정이 없으신가요?',
    login_signup: '회원가입',

    // ── SignupPage ──
    signup_pwError: '비밀번호는 6자 이상이어야 합니다',
    signup_error: '회원가입에 실패했습니다',
    signup_heading: '회원가입',
    signup_subtitle: '가입하면 견적서 작성, 상담 내역 저장, 빠른 문의가 가능합니다',
    signup_name: '이름 *',
    signup_namePlaceholder: '홍길동',
    signup_email: '이메일 *',
    signup_password: '비밀번호 *',
    signup_pwPlaceholder: '6자 이상',
    signup_company: '회사명',
    signup_companyPlaceholder: '(선택) 회사/기관명',
    signup_phone: '연락처',
    signup_phonePlaceholder: '(선택) 010-1234-5678',
    signup_submitting: '가입 중...',
    signup_emailSignup: '이메일로 가입하기',
    signup_hasAccount: '이미 계정이 있으신가요?',
    signup_login: '로그인',

    // ── CartPage ──
    cart_product: '제품',
    cart_heading: '장바구니',
    cart_loginRequired: '로그인 후 이용할 수 있습니다',
    cart_loginBtn: '로그인하기',
    cart_empty: '장바구니가 비어있습니다',
    cart_emptySub: '관심 있는 상품을 담아보세요',
    cart_browse: '제품 둘러보기',
    cart_sktec: '자사몰',
    cart_rental: '렌탈',
    cart_copier: '복합기',
    cart_toner: '토너',
    cart_won: '원',
    cart_remove: '삭제',
    cart_orderSummary: '주문 요약',
    cart_itemCount: '상품 수',
    cart_count: '개',
    cart_totalQty: '총 수량',
    cart_estimatedTotal: '예상 금액',
    cart_checkout: '주문하기',
    cart_inquiryBtn: '견적 문의하기',
    cart_phoneNote: '전화 상담: 사무기기 전문 일광오피스',

    // ── WishlistPage ──
    wish_product: '제품',
    wish_heading: '관심목록',
    wish_loginRequired: '로그인 후 이용할 수 있습니다',
    wish_loginBtn: '로그인하기',
    wish_empty: '관심목록이 비어있습니다',
    wish_emptySub: '마음에 드는 상품의 ♥ 버튼을 눌러보세요',
    wish_browse: '제품 둘러보기',
    wish_sktec: '자사몰',
    wish_rental: '렌탈',
    wish_copier: '복합기',
    wish_toner: '토너',
    wish_won: '원',
    wish_added: '담김',
    wish_addToCart: '장바구니 담기',

    // ── ComparePage ──
    compare_product: '제품',
    compare_specType: '유형',
    compare_specPrice: '가격',
    compare_specBrand: '브랜드',
    compare_specColor: '컬러/흑백',
    compare_specSpeed: '인쇄속도',
    compare_specVolume: '월출력량',
    compare_specPaper: '용지크기',
    compare_specDuplex: '양면인쇄',
    compare_specScan: '스캔',
    compare_specFax: '팩스',
    compare_specNetwork: '네트워크',
    compare_specDesc: '설명',
    compare_sktec: '자사몰',
    compare_rental: '렌탈',
    compare_copier: '복합기',
    compare_toner: '토너',
    compare_won: '원',
    compare_addProduct: '제품 추가',
    compare_searchPlaceholder: '제품명, 브랜드 검색...',
    compare_noSearchResults: '검색 결과가 없습니다',
    compare_loginRequired: '로그인이 필요합니다',
    compare_addedToCart: '장바구니에 추가되었습니다',
    compare_addedToWishlist: '관심목록에 추가',
    compare_removedFromWishlist: '관심목록에서 제거',
    compare_heading: '제품 비교',
    compare_subtitle: '제품의 사양을 한눈에 비교하세요.',
    compare_comparing: '개 제품 비교 중',
    compare_clearAll: '전체 삭제',
    compare_priceInquiry: '가격문의',
    compare_cart: '장바구니',
    compare_detail: '자세히 보기',
    compare_emptyTitle: '비교할 제품을 선택하세요',
    compare_emptyDesc: '위의 "제품 추가" 버튼을 눌러 비교할 제품을 선택하거나, 제품 목록에서 비교 버튼을 누르세요.',
    compare_browseProd: '제품 둘러보기',

    // ── CheckoutPage ──
    checkout_product: '제품',
    checkout_heading: '주문하기',
    checkout_loginRequired: '로그인이 필요합니다',
    checkout_loginBtn: '로그인',
    checkout_emptyCart: '장바구니가 비어있습니다',
    checkout_browse: '제품 둘러보기',
    checkout_validation: '수령인, 연락처, 배송주소를 입력해주세요.',
    checkout_error: '주문 처리 중 오류가 발생했습니다.',
    checkout_delivery: '배송 정보',
    checkout_recipient: '수령인 *',
    checkout_recipientPh: '이름',
    checkout_phone: '연락처 *',
    checkout_company: '회사명',
    checkout_companyPh: '회사명 (선택)',
    checkout_zip: '우편번호',
    checkout_address: '배송주소 *',
    checkout_addressPh: '주소',
    checkout_detailAddr: '상세주소',
    checkout_detailAddrPh: '동/호수',
    checkout_memo: '배송 메모',
    checkout_memoPh: '배송 시 요청사항 (선택)',
    checkout_payMethod: '결제 방법',
    checkout_bankTransfer: '무통장 입금',
    checkout_bankInfo: '우리은행 1005-xxx-xxxxxx',
    checkout_cardPay: '카드 결제',
    checkout_cardDesc: '전화 상담 후 진행',
    checkout_postPay: '후불 결제',
    checkout_postPayDesc: '납품 후 청구서 발행',
    checkout_orderItems: '주문 상품',
    checkout_qty: '수량:',
    checkout_won: '원',
    checkout_itemCount: '상품 수',
    checkout_count: '개',
    checkout_shipping: '배송비',
    checkout_free: '무료',
    checkout_total: '총 결제 금액',
    checkout_quoteGuide: '견적 후 안내',
    checkout_processing: '주문 처리 중...',
    checkout_placeOrder: '주문 완료하기',
    checkout_backToCart: '← 장바구니로 돌아가기',

    // ── OrderConfirmPage ──
    order_seoTitle: '주문 완료',
    order_notFound: '주문 정보를 찾을 수 없습니다',
    order_browse: '제품 둘러보기',
    order_success: '주문이 완료되었습니다',
    order_successSub: '담당자가 확인 후 연락드리겠습니다',
    order_orderNo: '주문번호',
    order_amount: '결제 금액',
    order_won: '원',
    order_guideTitle: '주문 진행 안내',
    order_step1: '주문 접수',
    order_step1Desc: '주문이 정상적으로 접수되었습니다',
    order_step2: '주문 확인',
    order_step2Desc: '담당자가 주문을 확인합니다',
    order_step3: '상품 준비',
    order_step3Desc: '상품을 준비 및 검수합니다',
    order_step4: '배송/설치',
    order_step4Desc: '제품 배송 또는 설치 일정을 조율합니다',
    order_viewHistory: '주문 내역 확인',
    order_continueShopping: '쇼핑 계속하기',

    // ── SitemapPage ──
    sitemap_seoTitle: '사이트맵 - 일광오피스 | 전국 복합기 렌탈',
    sitemap_seoDesc: '일광오피스 사이트맵. 전국 지역별 복합기 렌탈 페이지, 제품 쇼핑몰, 견적 문의 등 모든 페이지를 한눈에 확인하세요.',
    sitemap_heading: '사이트맵',
    sitemap_subtitle: '일광오피스의 모든 페이지를 한눈에 확인하세요',
    sitemap_shopping: '쇼핑몰',
    sitemap_allProducts: '전체 제품',
    sitemap_productSearch: '제품 검색',
    sitemap_cartLink: '장바구니',
    sitemap_wishlistLink: '위시리스트',
    sitemap_compareLink: '비교하기',
    sitemap_rentalSection: '렌탈',
    sitemap_nationalRental: '전국 렌탈',
    sitemap_rentalConsult: '렌탈 상담',
    sitemap_support: '고객지원',
    sitemap_quoteInquiry: '견적 문의',
    sitemap_phoneConsult: '전화 상담 1600-7542',
    sitemap_account: '계정',
    sitemap_loginLink: '로그인',
    sitemap_signupLink: '회원가입',
    sitemap_mypage: '마이페이지',
    sitemap_regionalTitle: '전국 지역별 렌탈',
    sitemap_regionalDesc: '전국 {count}개 지역에서 복합기 렌탈 서비스를 제공합니다',
    sitemap_districtCount: '개 지역',
    sitemap_viewAll: '전체 보기 →',
    sitemap_ctaTitle: '찾으시는 페이지가 없으신가요?',
    sitemap_ctaSub: '전문 상담사에게 문의하시면 빠르게 안내해드립니다',
    sitemap_ctaBtn: '문의하기',

    // ── ProductCard ──
    card_wishlist: '관심목록',
    card_cart: '장바구니',
    card_compare: '비교',
    card_black: '검정',
    card_cyan: '시안',
    card_magenta: '마젠타',
    card_yellow: '노랑',
    card_set: '세트',
    card_genuine: '정품',
    card_compatible: '호환',
    card_remanufactured: '재생',
    card_yield: '수율',
    card_pages: '매',
    card_won: '원',
    card_purchase: '구매',
    card_color: '컬러',
    card_mono: '흑백',
    card_detail: '상세보기',
    card_rentalBtn: '렌탈',

    // ── AiChat ──
    ai_errorMsg: '죄송합니다, 오류가 발생했습니다. 다시 시도해주세요.\n\n직접 문의: 일광오피스 1600-7542',
    ai_q1: '10명 사무실에 적합한 컬러 복합기 추천해주세요',
    ai_q2: '렌탈 vs 구매 비교해주세요',
    ai_q3: '흑백 복합기 중 경제적인 모델은?',
    ai_q4: '호환 토너 가격 알려주세요',
    ai_header: 'AI 도우미',
    ai_subtitle: '복합기, 프린터, 토너에 대해 무엇이든 물어보세요',
    ai_emptyTitle: '무엇을 도와드릴까요?',
    ai_emptyDesc: '사무환경에 맞는 복합기 추천, 토너 호환 검색, 가격 비교 등',
    ai_recCopier: '추천 복합기',
    ai_recToner: '추천 토너',
    ai_inputPlaceholder: '메시지를 입력하세요...',

    // ── InlineAiChat ──
    inlineAi_error: '죄송합니다, 오류가 발생했습니다. 다시 시도해주세요.',
    inlineAi_q1: '이 제품 렌탈 조건이 궁금합니다',
    inlineAi_q2: '비슷한 가격대 다른 모델 추천',
    inlineAi_q3: '호환 토너 가격 알려주세요',
    inlineAi_q4: '10명 사무실 컬러 복합기 추천',
    inlineAi_q5: '렌탈 vs 구매 비교',
    inlineAi_q6: '경제적인 흑백 복합기',
    inlineAi_emptyText: '무엇이든 물어보세요',
    inlineAi_placeholder: '메시지를 입력하세요...',
    inlineAi_product: '상품',

    // ── InlineInquiryForm ──
    inqForm_rental: '렌탈',
    inqForm_rentalMsg: '렌탈 문의합니다.',
    inqForm_error: '문의 접수 중 오류가 발생했습니다. 다시 시도해주세요.',
    inqForm_successTitle: '문의가 접수되었습니다',
    inqForm_successDesc: '빠른 시간 내에 연락드리겠습니다.',
    inqForm_name: '이름 *',
    inqForm_company: '회사명',
    inqForm_phone: '연락처 *',
    inqForm_email: '이메일',
    inqForm_inquiryType: '문의 유형',
    inqForm_purchase: '구매',
    inqForm_tonerSupplies: '토너·소모품',
    inqForm_maintenance: '유지보수',
    inqForm_other: '기타',
    inqForm_content: '문의 내용',
    inqForm_submitting: '접수 중...',
    inqForm_submitBtn: '문의 접수하기',
    inqForm_monthly: '월',
    inqForm_won: '원',

    // ── Footer ──
    footer_desc1: '복합기, 프린터, 토너 소모품 전문',
    footer_desc2: '렌탈 · 판매 · 유지보수',
    footer_hours: '평일 오전 10:00 ~ 오후 06:00',
    footer_lunch: '점심 오후 12:00 ~ 오후 01:00',
    footer_holidays: '토 / 일 / 공휴일은 휴무',
    footer_quickLinks: '바로가기',
    footer_rentalLink: '렌탈 제품',
    footer_mallLink: '토너 제품',
    footer_servicesTitle: '서비스',
    footer_svcAi: 'AI 복합기 추천',
    footer_svcSearch: '토너 호환 검색',
    footer_svcCompare: '정품·호환 가격 비교',
    footer_svcConsult: '렌탈 견적 상담',

    // ── Common ──
    common_won: '원',
    common_count: '개',
    common_monthly: '월',
    common_pages: '매',
    common_rental: '렌탈',
    common_sale: '판매',
    common_copier: '복합기',
    common_toner: '토너',
    common_sktec: '자사몰',
    common_priceInquiry: '가격문의',
    common_color: '컬러',
    common_mono: '흑백',
    common_supported: '지원',
    common_notSupported: '미지원',
    common_goTo: '바로가기 >',

    // ── ProductDetailPage ──
    detail_reviewError: '리뷰 등록에 실패했습니다',
    detail_loading: '로딩 중...',
    detail_notFound: '상품을 찾을 수 없습니다.',
    detail_backToStore: '← 스토어로 돌아가기',
    detail_copier: '복합기',
    detail_rental: '렌탈',
    detail_priceInquiry: '가격문의',
    detail_ilkwangOffice: '일광오피스',
    detail_sktec: '자사몰',
    detail_sale: '판매',
    detail_seoul: '서울',
    detail_overview: '개요',
    detail_specs: '사양',
    detail_reviews: '후기',
    detail_store: '스토어',
    detail_freeDelivery: '전국 배송',
    detail_expertConsult: '전문 상담',
    detail_genuineWarranty: '정품 보증',
    detail_monthlyRental: '월 렌탈료',
    detail_wonMonth: '원/월',
    detail_salePrice: '판매가',
    detail_price: '가격',
    detail_won: '원',
    detail_category: '카테고리:',
    detail_contract: '계약기간:',
    detail_brand: '브랜드',
    detail_model: '모델명',
    detail_categorySpec: '카테고리',
    detail_bwSpeed: '흑백 속도',
    detail_colorSpeed: '컬러 속도',
    detail_paperSize: '용지 크기',
    detail_fax: '팩스',
    detail_supported: '지원',
    detail_notSupported: '미지원',
    detail_duplex: '양면 인쇄',
    detail_monthlyVolume: '월 권장 출력량',
    detail_contractPeriod: '계약기간',
    detail_addedToCart: '✓ 장바구니에 담김',
    detail_addToCart: '장바구니 담기',
    detail_loginToCart: '로그인 후 장바구니 담기',
    detail_rentalInquiry: '렌탈 상담 문의',
    detail_addedToWishlist: '관심목록에 추가됨',
    detail_addToWishlist: '관심목록 추가',
    detail_aiConsult: 'AI 상담하기',
    detail_phoneConsult: '전화 상담 1600-7542',
    detail_helpText: '제품 구입에 필요한 도움을 받아보세요.',
    detail_chatNow: '지금 채팅하기',
    detail_orCall: '또는 1600-7542번으로 문의하세요.',
    detail_tabDetail: '상품상세정보',
    detail_tabDelivery: '배송안내',
    detail_tabReturn: '교환 및 반품안내',
    detail_tabReview: '상품후기',
    detail_noDetail: '상품 상세정보가 없습니다.',
    detail_productImages: '상품 이미지',
    detail_deliveryGuide: '배송 안내',
    detail_deliveryMethod: '배송 방법: 택배 / 직배송 (대형 복합기의 경우)',
    detail_deliveryArea: '배송 지역: 전국 (도서산간 제외)',
    detail_deliveryTime: '배송 소요: 택배 2~3일 / 대형장비 설치배송 별도 협의',
    detail_deliveryFee: '배송비: 무료 (일부 도서산간 지역 추가비용 발생 가능)',
    detail_deliveryInquiry: '배송 관련 문의:',
    detail_returnGuide: '교환 및 반품 안내',
    detail_returnPeriod: '교환/반품 기간',
    detail_returnPeriodDesc: '상품 수령 후 7일 이내 교환/반품 신청 가능',
    detail_returnExclude: '교환/반품 불가 사유',
    detail_returnExclude1: '고객 사유로 인한 포장 훼손 또는 상품 손상',
    detail_returnExclude2: '사용 흔적이 있는 토너 또는 소모품',
    detail_returnExclude3: '주문 제작 상품',
    detail_returnExclude4: '수령 후 7일 초과',
    detail_returnCost: '교환/반품 비용',
    detail_returnCostDesc: '불량 및 오배송의 경우 무료, 고객 사유의 경우 왕복 배송비 부담',
    detail_returnInquiry: '교환/반품 문의:',
    detail_reviewCount: '개 리뷰',
    detail_noReviews: '아직 등록된 리뷰가 없습니다.',
    detail_reviewer: '구매자',
    detail_writeReview: '리뷰 작성',
    detail_rating: '평점',
    detail_reviewTitlePh: '리뷰 제목 (선택)',
    detail_reviewContentPh: '제품 사용 후기를 작성해 주세요...',
    detail_submittingReview: '등록 중...',
    detail_submitReview: '리뷰 등록',
    detail_ctaTitle: '도입이 필요하신가요?',
    detail_ctaDesc: '일광오피스의 전문가와 최적의 솔루션을 설계해 보세요.',
    detail_ctaBtn: '전문가 상담',
    detail_aiConsultPanel: 'AI 상담',
    detail_rentalPanel: '렌탈 상담 문의',

    // ── CopierDetailPage ──
    copier_loading: '로딩 중...',
    copier_notFound: '제품을 찾을 수 없습니다',
    copier_backToList: '← 제품 목록으로 돌아가기',
    copier_seoSuffix: '복합기 상세정보 - 일광오피스',
    copier_seoDesc: '복합기 상세 정보. 사양, 가격, 렌탈 조건, 호환 토너 정보. 일광오피스에서 복합기 비교하세요.',
    copier_catalog: '제품 카탈로그',
    copier_color: '컬러',
    copier_mono: '흑백',
    copier_speed: '출력 속도',
    copier_paperSize: '용지 크기',
    copier_monthlyVolume: '월 권장 출력량',
    copier_priceRange: '가격대',
    copier_addedToCart: '✓ 담김',
    copier_cart: '장바구니',
    copier_wishlistOn: '♥ 관심',
    copier_wishlistOff: '♡ 관심',
    copier_compare: '⚖️ 비교',
    copier_buyAtMall: '자사몰에서 구매하기',
    copier_rentalInquiry: '📞 렌탈 문의하기',
    copier_askAi: '🤖 AI에게 더 물어보기',
    copier_compatToner: '🔵 호환 토너 / 소모품',
    copier_tonerCount: '종',
    copier_priceCompare: '💰 정품 vs 호환 가격 비교',
    copier_thToner: '토너',
    copier_thColor: '색상',
    copier_thGenuine: '정품 가격',
    copier_thCompatible: '호환 가격',
    copier_thSaving: '절약',
    copier_thYield: '수율',
    copier_black: '검정',
    copier_cyan: '시안',
    copier_magenta: '마젠타',
    copier_yellow: '노랑',
    copier_set: '세트',
    copier_won: '원',
    copier_pages: '매',
    copier_noToner: '등록된 호환 토너 정보가 없습니다. 일광오피스(1600-7542)에 문의해주세요.',
    copier_aiPanel: 'AI 상담',
    // ── RegionalRentalPage ──
    rental_locationTitle: '내 위치 기반 추천',
    rental_locationDesc: '현재 위치를 공유하면 가까운 지역의 복합기 렌탈 서비스를 추천해드립니다.',
    rental_later: '나중에',
    rental_allowLocation: '위치 허용',
    rental_myLocation: '내 위치',
    rental_all: '전체',
    rental_copierRental: '복합기 렌탈',
    rental_regionCopierRental: '지역 복합기 렌탈',
    rental_nationwideCopierRental: '전국 지역별 복합기 렌탈',
    rental_districtDesc: '지역 복합기·프린터 렌탈. 무료 설치·정기 점검·토너 지원.',
    rental_regionDesc: '전 지역 복합기 렌탈 서비스. 구/군을 선택하세요.',
    rental_nationwideDesc: '전국 어디서나 복합기 렌탈. 시/도를 선택해 시작하세요.',
    rental_nationwide: '전국',
    rental_districts: '개 지역',
    rental_products: '제품',
    rental_selectRegion: '지역 선택',
    rental_findByLocation: '내 위치로 찾기',
    rental_searchPlaceholder: '복합기 검색...',
    rental_region: '지역',
    rental_filterAll: '전체',
    rental_filterColor: '컬러',
    rental_filterMono: '흑백',
    rental_brandAll: '브랜드 전체',
    rental_categoryAll: '용도 전체',
    rental_sortDefault: '정렬: 기본',
    rental_sortPriceAsc: '가격 낮은순',
    rental_sortPriceDesc: '가격 높은순',
    rental_sortName: '이름순',
    rental_reset: '초기화',
    rental_rentalProducts: '렌탈 제품',
    rental_count: '건',
    rental_quoteInquiry: '견적 문의',
    rental_noProductsYet: '지역에 등록된 제품이 아직 없습니다',
    rental_selectDistrict: '구/군을 선택해주세요',
    rental_requestQuoteDesc: '에서 원하는 복합기가 있으시면 견적을 요청해주세요. 전문 상담사가 최적의 렌탈 플랜을 안내해드립니다.',
    rental_selectRegionHint: '왼쪽에서 지역을 선택하면 해당 지역 렌탈 제품이 표시됩니다.',
    rental_requestQuote: '견적서 요청하기',
    rental_freeInstall: '무료 설치',
    rental_freeInstallDesc: '전국 어디든 무료 배송·설치',
    rental_regularCheck: '정기 점검',
    rental_regularCheckDesc: '월 1회 무상 점검 서비스',
    rental_freeToner: '토너 무상',
    rental_freeTonerDesc: '소모품 무상 배송 지원',
    rental_badge_rental: '렌탈',
    rental_badge_both: '판매+렌탈',
    rental_monthly: '월',
    rental_won: '원',
    rental_priceInquiry: '가격문의',
    rental_detail: '자세히 →',
    rental_copierConsult: '복합기 렌탈 상담',
    rental_ctaDesc: '원하시는 제품의 견적서를 바로 요청하세요. 무료 설치·정기 점검·토너 무상 지원.',
    rental_freeQuoteRequest: '무료 견적서 요청',
    // ── CustomerERPPage ──
    erp_home: '홈',
    erp_aiConsult: 'AI 상담',
    erp_usageAnalysis: '사용량 분석',
    erp_quoteManage: '견적 관리',
    erp_inquiryManage: '문의 관리',
    erp_cart: '장바구니',
    erp_wishlist: '관심목록',
    erp_orderHistory: '주문 내역',
    erp_purchaseManage: '구매 관리',
    erp_chatHistory: '상담 내역',
    erp_myInfo: '내 정보',
    erp_reviewLounge: '리뷰 라운지',
    erp_tripManage: '출장 관리',
    erp_tripDesc: '출장 경로를 계획하고, 출발·경유·도착지를 관리하세요',
    erp_statusDraft: '임시저장',
    erp_statusSubmitted: '제출완료',
    erp_statusReviewed: '검토중',
    erp_statusSent: '발송완료',
    erp_typeRental: '렌탈',
    erp_typePurchase: '구매',
    erp_typeToner: '토너',
    erp_typeEtc: '기타',
    erp_aiConsultDesc: 'AI에게 무엇이든 물어보세요',
    erp_usageDesc: '리포트 촬영 → AI 자동 인식',
    erp_quickInquiry: '빠른 문의',
    erp_quickInquiryDesc: '1분 만에 문의 완료',
    erp_writeQuote: '견적서 작성',
    erp_writeQuoteDesc: '맞춤 견적 받기',
    erp_bulkPurchase: '대량 구매',
    erp_bulkPurchaseDesc: '회사 구매담당자용',
    erp_nationalRental: '전국 렌탈',
    erp_nationalRentalDesc: '내 지역 렌탈 검색',
    erp_compare: '제품 비교',
    erp_compareDesc: '복합기 비교 분석',
    erp_productSearch: '제품 검색',
    erp_productSearchDesc: 'AI 맞춤 추천',
    erp_wishlistDesc: '저장한 제품 보기',
    erp_sitemap: '사이트맵',
    erp_sitemapDesc: '전체 메뉴 한눈에',
    erp_allProducts: '전체 제품',
    erp_aiSearch: 'AI 추천 검색',
    erp_myPage: '님의 마이페이지',
    erp_seoDesc: '일광오피스 고객 전용 ERP – 견적, 문의, AI 상담, 구매관리',
    erp_hello: '안녕하세요',
    erp_honorific: '님',
    erp_goHome: '홈으로',
    erp_logout: '로그아웃',
    erp_siteShortcuts: '사이트 바로가기',
    erp_more: '더보기',
    erp_quotes: '견적서',
    erp_inquiryHistory: '문의 내역',
    erp_shortcuts: '바로가기',
    erp_recentQuotes: '최근 견적서',
    erp_viewAll: '전체 보기 →',
    erp_recentInquiries: '최근 문의',
    erp_tipText: '💡 알고 계셨나요?',
    erp_tipDesc: 'AI 상담으로 최적의 복합기를 추천받고, 견적서도 바로 작성할 수 있어요.',
    erp_tipBtnAi: 'AI 상담 시작',
    erp_aiDesc: 'AI 도우미가 최적의 복합기와 토너를 추천해드립니다',
    erp_newChat: '새 대화',
    erp_prevChats: '이전 상담',
    erp_aiAsk: 'AI 도우미에게 물어보세요',
    erp_aiHint: '복합기 추천, 토너 호환 확인, 가격 비교 등 무엇이든 질문하세요.',
    erp_suggestOffice: '사무실에 맞는 복합기 추천해주세요',
    erp_suggestCompare: '컬러 복합기 비교해주세요',
    erp_suggestToner: '호환 토너 알려주세요',
    erp_suggestSmall: '소규모 사무실에 적합한 제품은?',
    erp_recCopier: '추천 복합기',
    erp_recToner: '추천 토너',
    erp_msgPlaceholder: '메시지를 입력하세요...',
    erp_chatError: '죄송합니다, 오류가 발생했습니다. 다시 시도해주세요.',
    erp_quoteManageDesc: '견적서를 작성하고 관리하세요',
    erp_newQuote: '새 견적서',
    erp_noQuotes: '아직 견적서가 없습니다',
    erp_noQuotesHint: '새 견적서를 작성해보세요',
    erp_createQuote: '견적서 작성하기',
    erp_submit: '제출',
    erp_delete: '삭제',
    erp_adminNote: '관리자 메모:',
    erp_items: '항목',
    erp_backToQuotes: '← 견적 목록',
    erp_newQuoteTitle: '새 견적서 작성',
    erp_quoteTitle: '견적서 제목',
    erp_companyName: '회사/기관명',
    erp_addItem: '항목 추가',
    erp_productModel: '제품명 / 모델명',
    erp_quantity: '수량',
    erp_addMore: '+ 추가',
    erp_productNameCol: '제품명',
    erp_typeCol: '유형',
    erp_additionalNotes: '추가 요청사항 (선택)',
    erp_saveQuote: '견적서 저장',
    erp_inquiryManageDesc: '문의를 보내고 답변을 확인하세요',
    erp_autoFillInfo: '자동으로 정보가 입력됩니다',
    erp_rentalInquiry: '렌탈 문의',
    erp_purchaseInquiry: '구매 문의',
    erp_tonerInquiry: '토너 문의',
    erp_etcInquiry: '기타 문의',
    erp_sendInquiry: '문의 보내기',
    erp_noInquiries: '아직 문의 내역이 없습니다',
    erp_adminReply: '관리자 답변',
    erp_inquiryPlaceholder: '문의 내용을 입력하세요...',
    erp_answered: '답변완료',
    erp_processing: '처리중',
    erp_received: '접수',
    erp_emptyCart: '장바구니가 비어있습니다',
    erp_emptyCartHint: '마음에 드는 제품을 장바구니에 담아보세요',
    erp_browseProducts: '제품 둘러보기 →',
    erp_copier: '복합기',
    erp_toner: '토너',
    erp_inHouse: '사내',
    erp_requestQuoteInquiry: '견적 문의하기',
    erp_goToCart: '장바구니 페이지로 →',
    erp_product: '제품',
    erp_won: '원',
    erp_cartInquiry: '빠른 문의',
    erp_saved: '관심목록에 저장됨',
    erp_emptyWishlist: '관심목록이 비어있습니다',
    erp_emptyWishlistHint: '관심 있는 제품의 하트를 눌러 저장하세요',
    erp_viewDetail: '상세보기',
    erp_copierAnalysis: '복합기 사용량 분석',
    erp_copierAnalysisDesc: '복합기 리포트를 AI가 자동으로 분석합니다',
    erp_uploadReport: '리포트 업로드',
    erp_uploadReportDesc: '복합기 리포트 사진을 업로드하세요',
    erp_clientName: '고객사명',
    erp_clientExample: '예: 일광오피스',
    erp_selectOtherFile: '다른 파일 선택',
    erp_startAnalysis: '분석 시작',
    erp_aiAnalyzing: 'AI 분석 중...',
    erp_analysisResult: '분석 결과',
    erp_close: '닫기',
    erp_modelName: '모델명',
    erp_reportDate: '리포트 일자',
    erp_totalPages: '총 출력 매수',
    erp_color: '컬러',
    erp_bw: '흑백',
    erp_scan: '스캔',
    erp_fax: '팩스',
    erp_copy: '복사',
    erp_printPages: '인쇄',
    erp_tonerRemaining: '토너 잔량',
    erp_usageByUser: '사용자별 사용량',
    erp_user: '사용자',
    erp_total: '합계',
    erp_extraInfo: '추가정보',
    erp_analysisHistory: '분석 이력',
    erp_countUnit: '건',
    erp_noReports: '아직 분석 이력이 없습니다',
    erp_unknownModel: '알수없음',
    erp_client: '고객사',
    erp_totalPrefix: '총',
    erp_sheets: '매',
    erp_orderHistoryDesc: '주문 내역을 확인하세요',
    erp_noOrders: '주문 내역이 없습니다',
    erp_noOrdersHint: '제품을 주문하시면 여기에 표시됩니다',
    erp_orderPending: '주문접수',
    erp_orderConfirmed: '확인완료',
    erp_orderProcessing: '처리중',
    erp_orderShipping: '배송중',
    erp_orderDelivered: '배송완료',
    erp_orderCancelled: '취소',
    erp_orderRefunded: '환불',
    erp_qtyLabel: '수량',
    erp_cancelOrder: '주문 취소',
    erp_purchaseManageDesc: '대량 구매 및 렌탈 문의를 관리하세요',
    erp_bulkInquiry: '대량 구매/렌탈 문의',
    erp_bulkInquiryDesc: '필요한 장비 정보를 입력하세요',
    erp_equipment: '장비',
    erp_productReq: '제품명/사양',
    erp_productReqExample: '예: 컬러 복합기 A3',
    erp_installLocation: '설치 장소',
    erp_installExample: '예: 서울 강남구',
    erp_addEquipment: '+ 장비 추가',
    erp_sendBulkInquiry: '대량 문의 보내기',
    erp_corporateGuide: '기업 구매 안내',
    erp_corpFeat1Title: '전문 상담',
    erp_corpFeat1Desc: '기업 규모에 맞는 맞춤 상담',
    erp_corpFeat2Title: '대량 할인',
    erp_corpFeat2Desc: '10대 이상 특별 할인 적용',
    erp_corpFeat3Title: '통합 관리',
    erp_corpFeat3Desc: '전사 장비 통합 관리 서비스',
    erp_corpFeat4Title: '우선 A/S',
    erp_corpFeat4Desc: '기업 고객 우선 기술 지원',
    erp_corpFeat5Title: '정기 보고',
    erp_corpFeat5Desc: '월간 사용량 보고서 제공',
    erp_dedicatedConsult: '전담 상담사 배정',
    erp_dedicatedConsultDesc: '기업 고객에게 전담 상담사가 배정됩니다',
    erp_makeInquiry: '문의하기',
    erp_individualBuyer: '개인 구매자',
    erp_aiRec: 'AI 추천',
    erp_rentalQuote: '렌탈 견적',
    erp_clickToSelect: '클릭하여 선택',
    erp_aiChatHistory: 'AI 상담 내역',
    erp_aiChatHistoryDesc: '이전 AI 상담 내역을 확인하세요',
    erp_noChatHistory: '아직 AI 상담 내역이 없습니다',
    erp_startAiChat: 'AI 상담 시작하기',
    erp_messagesCount: '개 메시지',
    erp_editProfileDesc: '프로필 정보를 수정하세요',
    erp_name: '이름',
    erp_company: '회사/기관',
    erp_phone: '연락처',
    erp_email: '이메일',
    erp_editProfile: '프로필 수정',
    erp_accountInfo: '계정 정보',
    erp_accountType: '계정 유형',
    erp_local: '일반',
    erp_accountLabel: '계정',
    erp_loginLabel: '로그인',
    erp_role: '역할',
    erp_roleAdmin: '관리자',
    erp_roleMember: '일반회원',
    erp_deleteAccount: '계정 삭제',
    erp_deleteAccountDesc: '계정을 삭제하면 모든 데이터가 영구 삭제됩니다.',
    erp_deleteAccountRequest: '계정 삭제 요청',
    erp_deleteAccountConfirm: '정말 계정을 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.',
    erp_deleteNow: '삭제하기',
    erp_cancel: '취소',
    erp_requestDelete: '삭제 요청',
    erp_deleteAccountAlerted: '계정 삭제가 요청되었습니다. 관리자가 확인 후 처리됩니다.',
    erp_errorOccurred: '오류가 발생했습니다',
    erp_myReviewLounge: '내 리뷰 라운지',
    erp_communityDesc: '커뮤니티 활동을 확인하세요',
    erp_myTonerPoints: '내 토너 포인트',
    erp_myBadge: '내 뱃지',
    erp_goToReviewLounge: '리뷰 라운지로 이동 →',
    erp_myPosts: '내 게시글',
    erp_myComments: '내 댓글',
    erp_pointHistory: '포인트 내역',
    erp_noMyPosts: '아직 작성한 게시글이 없습니다',
    erp_noMyComments: '아직 작성한 댓글이 없습니다',
    erp_totalPoints: '총 포인트',
    erp_badgeLevel: '뱃지 레벨',
    erp_maxDiscount: '최대 할인',
    erp_typeLabel: '유형',
    erp_pointLabel: '포인트',
    erp_reason: '사유',
    erp_dateTime: '일시',
    erp_noPointHistory: '아직 포인트 내역이 없습니다',
    erp_earn: '적립',
    erp_spend: '사용',
    erp_rec: '추천',
    erp_commentsLabel: '댓글',
    erp_views: '조회',
    erp_badgeA4: 'A4 초보',
    erp_badgeInkjet: '잉크젯 러너',
    erp_badgeColorLaser: '컬러레이저 프로',
    erp_badgeMaster: '복합기 마스터',
    livechat_consult: '1:1 상담',
    livechat_channelSelect: '상담 채널 선택',
    livechat_chat: '1:1 상담',
    livechat_hours: '평일 09:00 ~ 18:00',
    livechat_howToConsult: '어떤 방법으로 상담하시겠어요?',
    livechat_kakaoChat: '카카오톡 상담',
    livechat_kakaoDesc: '빠른 응답 · 사진 전송 가능',
    livechat_fastResponse: '빠른답변',
    livechat_siteChat: '사이트 실시간 채팅',
    livechat_siteChatDesc: '로그인 후 바로 상담',
    livechat_aiAssistant: 'AI 어시스턴트',
    livechat_aiAssistantDesc: '24시간 AI 자동 상담',
    livechat_kakaoFastest: '카카오톡이 가장 빠릅니다!',
    livechat_customerCenter: '고객센터',
    livechat_welcome: '무엇이든 물어보세요!',
    livechat_askAnything: '복합기, 토너, 렌탈 등 궁금한 점을 남겨주세요',
    livechat_fasterTip: '더 빠른 상담을 원하시면',
    livechat_kakaoLink: '카카오톡 상담',
    livechat_fasterTipSuffix: '을 이용해주세요!',
    livechat_agent: '상담원',
    livechat_inputPlaceholder: '메시지를 입력하세요...',
    livechat_chatClosed: '상담이 종료되었습니다',
    filter_all: '전체',
  },

  en: {
    // ── HomePage ──
    home_seoTitle:
      'Copier & Printer Specialists | Ilkwang Office – Rental · Sales · Toner Price Comparison',
    home_seoDesc:
      'Ilkwang Office — copier, printer & printing specialists. Office MFP rental from ₩30,000/mo. Color & mono copier sales, toner price comparison. Compare Samsung, Canon, Fuji Xerox, Kyocera & Sindoh MFPs with AI-powered recommendations.',
    home_heroTitle: 'Store.',
    home_heroSub: 'The best way to choose the perfect MFP for your office.',
    home_askAi: 'Ask AI',
    home_askAiDesc: 'AI finds the right equipment for your needs.',
    home_callConsult: 'Call Us',
    home_callConsultDesc: 'Speak directly with a representative.',
    home_catColor: 'Color MFP',
    home_catMono: 'Mono MFP',
    home_catPrinter: 'Printer',
    home_catToner: 'Toner & Supplies',
    home_catConsult: 'Consultation',
    home_catOwnMall: 'Our Mall',
    home_catAi: 'AI Picks',
    home_catDigital: 'Digital Press',
    home_catDigitalDesc: 'High-speed digital printing',
    home_catLarge: 'Large MFP',
    home_catLargeDesc: 'A3 large multifunction',
    home_catSmall: 'Small MFP',
    home_catSmallDesc: 'A4 desktop multifunction',
    home_catPrinterDesc: 'Laser & Inkjet printers',
    home_catTonerDesc: 'Genuine, compatible & reman toner',
    home_searchTitle: 'Product Search',
    home_searchDesc: 'Search by model, brand, or toner number',
    home_noResults: 'No results found',
    home_searchHint2: 'Try searching',
    home_newProducts: 'New Arrivals',
    home_newProductsDesc: 'Check out the latest products',
    home_rental: 'Rental',
    home_monthlyPrice: '₩{price}/mo~',
    home_priceInquiry: 'Get a Quote',
    home_quickLinks: 'Quick Links.',
    home_quickLinksDesc: 'Jump straight to the pages you visit most.',
    home_productStore: 'Product Store',
    home_aiRecommend: 'AI Picks',
    home_productCompare: 'Compare',
    home_cart: 'Cart',
    home_wishlist: 'Wishlist',
    home_myErp: 'My ERP',
    home_nationalRental: 'Nationwide Rental',
    home_consult: 'Consultation',
    home_sitemapLink: 'Sitemap',
    home_phoneConsult: 'Phone Consultation',
    home_consultSection: 'Consultation',
    home_consultDesc:
      'Rental quotes, product inquiries and live support — all in one place.',
    home_rentalQuote: 'Rental Quote',
    home_rentalQuoteDesc:
      'Check your monthly rental fee instantly with our auto-quote calculator.',
    home_getQuote: 'Get Quote >',
    home_generalConsult: 'General Inquiry',
    home_generalConsultDesc:
      'Submit any inquiry — purchases, toner, after-sales service and more.',
    home_inquireNow: 'Inquire Now >',
    home_liveConsult: 'Live Support',
    home_liveConsultDesc:
      'Get instant help via KakaoTalk, chat or phone.',
    home_consultNow: 'Chat Now >',
    home_globalInquiry: 'Global Inquiry',
    home_rentalMall: 'Nationwide Rental Mall.',
    home_rentalMallDesc1:
      'Available everywhere — Seoul, Busan, Daegu, Incheon, Gwangju, Daejeon, Ulsan, Sejong, Gyeonggi and more.',
    home_rentalMallDesc2:
      'MFP & printer rental services. Free installation & regular maintenance.',
    home_seoul: 'Seoul',
    home_gwanghwamun: 'Gwanghwamun',
    home_busan: 'Busan',
    home_jagalchi: 'Jagalchi Market',
    home_daegu: 'Daegu',
    home_daeguSub: 'Apples & Herbal Medicine Market',
    home_incheon: 'Incheon',
    home_chinatown: 'Chinatown',
    home_gyeonggi: 'Gyeonggi',
    home_suwon: 'Suwon Hwaseong',
    home_gwangju: 'Gwangju',
    home_gwangjuSub: 'Mudeungsan & Bibimbap',
    home_daejeon: 'Daejeon',
    home_daejeonSub: 'Sungsimdang & Bread',
    home_jeju: 'Jeju',
    home_jejuSub: 'Hallabong & Tangerines',
    home_viewAllRegions: 'View all 260+ regions >',
    home_nationalRentalMall: 'Nationwide Rental Mall',
    home_regionsCount: '260+ Regions',
    home_goTo: 'Go >',
    home_aiConsult: 'AI Consultation',
    home_productSearch: 'Product Search',
    home_searchPlaceholder:
      'Search by MFP model name or toner part number.',
    home_searchBtn: 'Search',
    home_searchHint: 'e.g. "Samsung SL-XA225" or "CLT-K3080S"',
    home_shortcuts: 'Shortcuts',
    home_rentalInquiry: 'Rental Inquiry',
    home_ownMall: 'Our Mall',
    home_latestProducts: 'Latest Products.',
    home_latestProductsDesc: 'Popular products from our store.',
    home_viewAll: 'View All >',
    home_rentalProducts: 'Rental Products.',
    home_rentalProductsDesc:
      'Affordable rental MFPs.',
    home_myErpSection: 'My ERP.',
    home_myErpDesc: 'Custom management tools for your office.',
    home_erpAi: 'AI Consultation',
    home_erpAiDesc:
      'Ask AI anything — from MFP recommendations to quotes.',
    home_erpUsage: 'Usage Analysis',
    home_erpUsageDesc:
      'Just snap a photo of your report and AI will analyze it automatically.',
    home_erpQuote: 'Create Quote',
    home_erpQuoteDesc: 'Request and manage custom quotes.',
    home_erpInquiry: 'Quick Inquiry',
    home_erpInquiryDesc: 'Complete your inquiry in just one minute.',
    home_erpBulk: 'Bulk Purchase',
    home_erpBulkDesc: 'Dedicated tools for corporate procurement.',
    home_erpCart: 'Cart',
    home_erpCartDesc: 'Review your items and place an order.',
    home_services: 'Services.',
    home_servicesDesc:
      'Experience the professional services of Ilkwang Office.',
    home_svcAi: 'AI MFP Recommendation',
    home_svcAiDesc:
      'AI analyzes your office environment and recommends the optimal MFP.',
    home_svcAiCta: 'Get Started >',
    home_svcRental: 'Rental Service',
    home_svcRentalDesc:
      'Use an MFP at a reasonable monthly rate. One-stop maintenance included.',
    home_svcRentalCta: 'View Rental Products >',
    home_svcToner: 'Toner & Supplies',
    home_svcTonerDesc:
      'Buy genuine, compatible or remanufactured toner at great prices.',
    home_svcTonerCta: 'View Toner Products >',
    home_convenienceServices: 'Convenience Services.',
    home_convenienceDesc:
      'Everything you need to manage your office equipment, in one place.',
    home_usageAnalysis: 'Usage Analysis',
    home_usageAnalysisDesc:
      'Just snap a photo of your report and AI will analyze your MFP usage.',
    home_analyzeNow: 'Analyze Now >',
    home_orderTracking: 'Order & Delivery Tracking',
    home_orderTrackingDesc:
      'Check your order history and track delivery status in real time.',
    home_trackNow: 'Track Now >',
    home_quoteManage: 'Quote & Inquiry Management',
    home_quoteManageDesc:
      'Review and manage all your quotes and inquiries at a glance.',
    home_checkNow: 'Check Now >',
    home_guideTitle: 'MFP · Copier · Printing Guide.',
    home_guideDesc:
      'Learn how to choose the perfect MFP for your office.',
    home_guideQ1: 'What is an MFP?',
    home_guideA1:
      'A multifunction printer (MFP) combines printing, copying, scanning and fax in one device. Unlike a stand-alone copier, an MFP handles print, scan and fax from a single unit, maximizing office space efficiency. Modern MFPs also support cloud integration, mobile printing and automatic duplex printing.',
    home_guideQ2: 'Copier vs. MFP',
    home_guideA2:
      'A copier is designed solely for document copying, while an MFP is an all-in-one office machine that combines printing, copying, scanning and faxing. Today MFPs are the market standard — when people say "copier," they usually mean an MFP. MFPs are also more cost-effective.',
    home_guideQ3: 'How to reduce office printing costs',
    home_guideA3:
      'Key strategies: ① Switch to rental (lower upfront cost), ② Analyze usage with automated IT reports, ③ Use compatible/remanufactured toner (save 30–60%), ④ Default to duplex printing. Optimize your costs with Ilkwang Office\'s AI usage analysis and tailored rental plans.',
    home_guideQ4: 'MFP Rental vs. Purchase',
    home_guideA4:
      'Rental offers low upfront costs with maintenance and toner included. Purchasing saves money long-term but requires separate repair and supply expenses. For fleets of 5+ units rental is advantageous; for small or short-term use, purchasing may be better.',
    home_guideQ5:
      'Genuine Toner vs. Compatible Toner vs. Remanufactured Toner',
    home_tonerCompareTitle: 'Toner Type Comparison',
    home_tonerCompare: 'Category',
    home_tonerGenuine: 'Genuine Toner',
    home_tonerCompatible: 'Compatible Toner',
    home_tonerRemanufactured: 'Remanufactured Toner',
    home_tonerPrice: 'Price',
    home_tonerPriceGenuine: 'High (baseline)',
    home_tonerPriceCompatible: '30–50% of original',
    home_tonerPriceReman: '20–40% of original',
    home_tonerQuality: 'Quality',
    home_tonerQualityGenuine: 'Excellent',
    home_tonerQualityCompatible: 'Very Good',
    home_tonerQualityReman: 'Fair to Good',
    home_tonerWarranty: 'Warranty',
    home_tonerWarrantyGenuine: 'Manufacturer warranty',
    home_tonerWarrantyCompatible: 'Vendor warranty',
    home_tonerWarrantyReman: 'Limited',
    home_tonerRecommend: 'Best For',
    home_tonerRecommendGenuine: 'High-quality printing',
    home_tonerRecommendCompatible: 'Cost savings + quality',
    home_tonerRecommendReman: 'Lowest cost priority',
    home_tonerNote:
      'Ilkwang Office carries genuine, compatible and remanufactured toner for all major brands including Samsung, Canon, Fuji Xerox, Kyocera, Sindoh, HP and Brother.',
    home_brandTitle: 'MFPs & Copiers by Brand',
    home_brandSamsung: 'Samsung MFP',
    home_brandCanon: 'Canon MFP',
    home_brandFuji: 'Fuji Xerox MFP',
    home_brandKyocera: 'Kyocera MFP',
    home_brandSindoh: 'Sindoh MFP',
    home_brandHp: 'HP MFP',
    home_brandBrother: 'Brother MFP',
    home_brandColor: 'Color MFP',
    home_faqTitle: 'FAQ',
    home_faqQ1: 'How much does MFP rental cost?',
    home_faqA1:
      'MFP rental ranges from ₩30,000 to ₩300,000 per month depending on the model and terms. Check instantly with our rental calculator.',
    home_faqQ2: 'Can I rent a copier?',
    home_faqA2:
      'Yes, copier (MFP) rental is available. We offer nationwide free installation and regular maintenance for color and mono MFPs as well as printers.',
    home_faqQ3: 'Can you optimize our office printing setup?',
    home_faqA3:
      'Yes. With AI usage analysis and expert consulting, we optimize your office printing environment and suggest tailored quotes and cost-saving solutions.',
    home_faqQ4: 'What types of toner are available?',
    home_faqA4:
      'There are three types: genuine, compatible and remanufactured toner. Our AI recommends the right toner based on your needs and budget.',
    home_faqQ5: 'How is MFP maintenance handled?',
    home_faqA5:
      'Rental includes monthly inspections, free on-site service calls and complimentary toner/drum replacements. Maintenance contracts are also available for purchased units.',

    // ── StorePage ──
    store_seoTitle: 'Store | MFP · Printer · Toner Hub – Ilkwang Office',
    store_seoDesc: 'Digital presses, large & small MFPs, printers, toner & supplies in one place. Compare rental & purchase prices.',
    store_heroTitle: 'Store',
    store_heroSub: 'Find the MFP, printer or toner you need.',
    store_searchPlaceholder: 'Search by product, brand, or model',
    store_loading: 'Loading products…',
    store_searchResults: 'Search Results',
    store_productUnit: ' products',
    store_noResults: 'No results found.',
    store_tryOther: 'Try a different keyword.',
    store_shopByCategory: 'Shop by Category',
    store_shopByCategorySub: 'Choose a category to explore.',
    store_viewAll: 'View All',
    store_noProducts: 'No products in this category.',
    store_sortLatest: 'Featured',
    store_sortName: 'Name',
    store_sortPriceAsc: 'Price: Low to High',
    store_sortPriceDesc: 'Price: High to Low',
    store_sortRental: 'Rental: Low to High',
    store_saleRental: 'Rental',
    store_saleBoth: 'Sale+Rental',
    store_salePurchase: 'Sale',
    store_inquiry: 'Inquire',
    store_details: 'Details',
    store_subAll: 'All',
    store_subToner: 'Toner',
    store_subDrum: 'Drum',
    store_subDeveloper: 'Developer',
    store_subFuser: 'Fuser',
    store_subParts: 'Parts',
    store_subPaper: 'Paper',

    // ── ProductsPage ──
    products_seoTitle:
      'All MFPs & Copiers | Rental · Sales Price Comparison – Ilkwang Office',
    products_seoDesc:
      'Compare all Samsung, Canon, Fuji Xerox, Kyocera & Sindoh MFPs and copiers. Color MFP, mono MFP, printer & toner price comparison. Rental from ₩30,000/mo.',
    products_heading: 'Store',
    products_subtitle: 'Click a product to view details.',
    products_searchPlaceholder: 'Search products',
    products_loading: 'Loading…',
    products_itemCount: 'items',
    products_noResults: 'No results found.',
    products_noResultsSub:
      'Try a different category or keyword.',
    products_all: 'All',
    products_digitalPress: 'Digital Press',
    products_largeMFP: 'Large MFP',
    products_smallMFP: 'Small MFP',
    products_printer: 'Printer',
    products_tonerSupplies: 'Toner & Supplies',
    products_colorCopier: 'Color MFP',
    products_monoCopier: 'Mono MFP',
    products_copierRental: 'MFP Rental',
    products_specialEquip: 'Special Equipment',
    products_copierSales: 'MFP Sales',
    products_sktecMall: 'Store',
    products_ikofficesRental: 'Rental',
    products_saleRental: 'Sales + Rental',
    products_sale: 'Sale',
    products_rental: 'Rental',
    products_monthly: '/mo',
    products_won: '₩',
    products_wonTilde: '₩~',
    products_priceInquiry: 'Get a Quote',
    products_prev: 'Prev',
    products_next: 'Next',

    // ── SearchPage ──
    search_seoTitle:
      'AI MFP Search | Find Copiers & Toner – Ilkwang Office',
    search_seoDesc:
      'AI recommends the optimal MFP and copier for your office. Search by model name or toner part number.',
    search_heading: 'AI Search',
    search_subtitle:
      'Ask AI a question or search by model name. Recommended products link directly to our mall or rental site.',
    search_aiConsult: 'AI Consultation',
    search_productSearch: 'Product Search',
    search_placeholder: 'Search model, brand, toner number…',
    search_searching: 'Searching…',
    search_searchBtn: 'Search',
    search_copiers: 'MFPs',
    search_count: 'results',
    search_tonerSupplies: 'Toner & Supplies',
    search_noResults: 'No results found',
    search_initialHint:
      'Search by MFP model name or toner part number.',
    search_exampleHint: 'e.g. "Samsung SL-X4225" or "CLT-K808S"',
    search_shortcuts: 'Shortcuts',
    search_rentalInquiry: 'Rental Inquiry',
    search_ownMall: 'Our Mall',

    // ── ConsultationPage ──
    consult_seoTitle:
      'Consultation – Rental Quote · Live Support · Global Inquiry | Ilkwang Office',
    consult_seoDesc:
      'MFP, printer & toner rental quotes and consultations. KakaoTalk, live chat & phone support. International inquiries welcome.',
    consult_heading: 'Consultation',
    consult_subtitle:
      'Rental quotes, product inquiries and live support — all in one place.',
    consult_tabRental: 'Rental Quote',
    consult_tabGeneral: 'General Inquiry',
    consult_tabLive: 'Live Support',
    consult_tabGlobal: 'Global Inquiry',
    consult_calcTitle: 'Rental Fee Calculator',
    consult_planSelect: 'Select a Plan',
    consult_monthly: '/mo',
    consult_won: '₩',
    consult_bwPages: '{n} B/W pages',
    consult_colorPages: '{n} Color pages',
    consult_adjustPages: 'Adjust Page Counts',
    consult_bwCount: 'B/W Pages',
    consult_colorCount: 'Color Pages',
    consult_pages: 'pages',
    consult_default: 'Default',
    consult_geoNotSupported:
      'Geolocation is not supported by this browser.',
    consult_geoError: 'Unable to retrieve your location.',
    consult_uploadError:
      'File upload failed. (Max 10 MB; jpg/png/pdf/doc/hwp)',
    consult_nameRequired: 'Please enter your name.',
    consult_phoneRequired: 'Please enter your phone number.',
    consult_submitError: 'Failed to submit your inquiry.',
    consult_successTitle: 'Inquiry Submitted',
    consult_successDesc:
      'A representative will contact you shortly.',
    consult_quoteSummary: 'Quote Summary',
    consult_monthlyRental: 'Monthly Rental:',
    consult_autoQuoteNote:
      'A quote has been generated automatically. It will be sent after review.',
    consult_urgent: 'Urgent?',
    consult_callUs: 'Please call us.',
    consult_nationalRental: 'Nationwide Rental Mall',
    consult_goHome: 'Home',
    consult_selectProduct: 'Select Product',
    consult_selectProductPlaceholder: 'Choose a rental product',
    consult_searchProductPlaceholder: 'Search product, brand...',
    consult_inquiryProduct: 'Product of Inquiry',
    consult_autoFilled: 'Member information has been auto-filled.',
    consult_name: 'Name',
    consult_company: 'Company',
    consult_namePlaceholder: 'John Smith',
    consult_companyPlaceholder: 'Company name',
    consult_phone: 'Phone',
    consult_email: 'Email',
    consult_installRegion: 'Installation Region',
    consult_locating: 'Locating…',
    consult_myLocation: 'My Location',
    consult_additionalRequest: 'Additional Requests',
    consult_inquiryContent: 'Inquiry Details',
    consult_contentPlaceholder:
      'Please describe your inquiry.\n(Product name, quantity, installation site, preferred terms, etc.)',
    consult_attachment: 'Attachment',
    consult_uploading: 'Uploading…',
    consult_uploadPrompt: 'Click to attach a file (image, PDF, document)',
    consult_remove: 'Remove',
    consult_estimatedMonthly: 'Est. Monthly Rental (VAT incl.)',
    consult_submitting: 'Submitting…',
    consult_requestQuote: 'Request Quote',
    consult_sendInquiry: 'Send Inquiry',
    consult_responseNote:
      'We will contact you within 1 business day.',
    consult_contentRequired: 'Please enter your inquiry details.',
    consult_generalTitle: 'General Inquiry',
    consult_generalDesc:
      'Ask us anything about MFPs, printers, toner and office equipment. Our specialists will be happy to help.',
    consult_sampleService: 'Sample Print Service',
    consult_sampleDesc:
      'Attach your image and we will print a sample on an actual MFP and mail it to you.',
    consult_inquiryType: 'Inquiry Type',
    consult_typePurchase: 'Purchase Inquiry',
    consult_typeToner: 'Toner / Supplies Inquiry',
    consult_typeService: 'Service & Maintenance',
    consult_typeOther: 'Other',
    consult_generalPlaceholder:
      'Please describe your question in detail.',
    consult_liveIntro:
      'Choose the fastest and most convenient way to reach us.',
    consult_recommended: 'Recommended',
    consult_kakaoTitle: 'KakaoTalk Chat',
    consult_kakaoDesc: 'Get the fastest response',
    consult_kakaoCta: 'Open KakaoTalk >',
    consult_liveChatTitle: 'Live Chat',
    consult_liveChatDescLogin: 'Chat with an agent now',
    consult_liveChatDescNoLogin: 'Login required',
    consult_liveChatCtaLogin: 'Start Chat >',
    consult_liveChatCtaNoLogin: 'Login Required',
    consult_phoneTitle: 'Phone Consultation',
    consult_businessHours: 'Weekdays 10:00 – 18:00',
    consult_chatHeader: '1:1 Live Chat',
    consult_chatGreeting: 'Hello! This is Ilkwang Office.',
    consult_chatSubtext: 'How can we help you?',
    consult_adminLabel: 'Agent',
    consult_chatPlaceholder: 'Type a message…',
    consult_allFieldsRequired: 'Please fill in all required fields.',
    consult_phoneConsult: 'Phone Consultation',
    consult_consultHours: 'Business Hours',

    // ── LoginPage ──
    login_error: 'Login failed',
    login_heading: 'Log in to Ilkwang Office',
    login_subtitle: 'Sign in to save consultation history, create quotes, and submit inquiries faster',
    login_email: 'Email',
    login_password: 'Password',
    login_pwPlaceholder: 'At least 6 characters',
    login_submitting: 'Signing in…',
    login_emailLogin: 'Sign in with Email',
    login_noAccount: "Don't have an account?",
    login_signup: 'Sign Up',

    // ── SignupPage ──
    signup_pwError: 'Password must be at least 6 characters',
    signup_error: 'Sign-up failed',
    signup_heading: 'Sign Up',
    signup_subtitle: 'Create an account to manage quotes, save consultations, and submit inquiries faster',
    signup_name: 'Name *',
    signup_namePlaceholder: 'John Doe',
    signup_email: 'Email *',
    signup_password: 'Password *',
    signup_pwPlaceholder: 'At least 6 characters',
    signup_company: 'Company',
    signup_companyPlaceholder: '(Optional) Company name',
    signup_phone: 'Phone',
    signup_phonePlaceholder: '(Optional) 010-1234-5678',
    signup_submitting: 'Creating account…',
    signup_emailSignup: 'Sign up with Email',
    signup_hasAccount: 'Already have an account?',
    signup_login: 'Log In',

    // ── CartPage ──
    cart_product: 'Product',
    cart_heading: 'Cart',
    cart_loginRequired: 'Please log in to continue',
    cart_loginBtn: 'Log In',
    cart_empty: 'Your cart is empty',
    cart_emptySub: 'Add products you are interested in',
    cart_browse: 'Browse Products',
    cart_sktec: 'Our Mall',
    cart_rental: 'Rental',
    cart_copier: 'Copier',
    cart_toner: 'Toner',
    cart_won: 'KRW',
    cart_remove: 'Remove',
    cart_orderSummary: 'Order Summary',
    cart_itemCount: 'Items',
    cart_count: '',
    cart_totalQty: 'Total Qty',
    cart_estimatedTotal: 'Estimated Total',
    cart_checkout: 'Checkout',
    cart_inquiryBtn: 'Request a Quote',
    cart_phoneNote: 'Call us: Ilkwang Office – office equipment specialists',

    // ── WishlistPage ──
    wish_product: 'Product',
    wish_heading: 'Wishlist',
    wish_loginRequired: 'Please log in to continue',
    wish_loginBtn: 'Log In',
    wish_empty: 'Your wishlist is empty',
    wish_emptySub: 'Tap the ♥ button on products you like',
    wish_browse: 'Browse Products',
    wish_sktec: 'Our Mall',
    wish_rental: 'Rental',
    wish_copier: 'Copier',
    wish_toner: 'Toner',
    wish_won: 'KRW',
    wish_added: 'Saved',
    wish_addToCart: 'Add to Cart',

    // ── ComparePage ──
    compare_product: 'Product',
    compare_specType: 'Type',
    compare_specPrice: 'Price',
    compare_specBrand: 'Brand',
    compare_specColor: 'Color / Mono',
    compare_specSpeed: 'Print Speed',
    compare_specVolume: 'Monthly Volume',
    compare_specPaper: 'Paper Size',
    compare_specDuplex: 'Duplex',
    compare_specScan: 'Scan',
    compare_specFax: 'Fax',
    compare_specNetwork: 'Network',
    compare_specDesc: 'Description',
    compare_sktec: 'Our Mall',
    compare_rental: 'Rental',
    compare_copier: 'Copier',
    compare_toner: 'Toner',
    compare_won: 'KRW',
    compare_addProduct: 'Add Product',
    compare_searchPlaceholder: 'Search by product name or brand…',
    compare_noSearchResults: 'No results found',
    compare_loginRequired: 'Login required',
    compare_addedToCart: 'Added to cart',
    compare_addedToWishlist: 'Added to wishlist',
    compare_removedFromWishlist: 'Removed from wishlist',
    compare_heading: 'Compare Products',
    compare_subtitle: 'Compare specifications side by side.',
    compare_comparing: ' products compared',
    compare_clearAll: 'Clear All',
    compare_priceInquiry: 'Price Inquiry',
    compare_cart: 'Cart',
    compare_detail: 'View Details',
    compare_emptyTitle: 'Select products to compare',
    compare_emptyDesc: 'Click the "Add Product" button above or use the compare button on product listings.',
    compare_browseProd: 'Browse Products',

    // ── CheckoutPage ──
    checkout_product: 'Product',
    checkout_heading: 'Checkout',
    checkout_loginRequired: 'Login required',
    checkout_loginBtn: 'Log In',
    checkout_emptyCart: 'Your cart is empty',
    checkout_browse: 'Browse Products',
    checkout_validation: 'Please enter recipient, phone number, and delivery address.',
    checkout_error: 'An error occurred while processing your order.',
    checkout_delivery: 'Delivery Information',
    checkout_recipient: 'Recipient *',
    checkout_recipientPh: 'Name',
    checkout_phone: 'Phone *',
    checkout_company: 'Company',
    checkout_companyPh: 'Company (optional)',
    checkout_zip: 'Postal Code',
    checkout_address: 'Address *',
    checkout_addressPh: 'Address',
    checkout_detailAddr: 'Detail Address',
    checkout_detailAddrPh: 'Bldg / Unit',
    checkout_memo: 'Delivery Note',
    checkout_memoPh: 'Special instructions (optional)',
    checkout_payMethod: 'Payment Method',
    checkout_bankTransfer: 'Bank Transfer',
    checkout_bankInfo: 'Woori Bank 1005-xxx-xxxxxx',
    checkout_cardPay: 'Card Payment',
    checkout_cardDesc: 'Arranged after phone consultation',
    checkout_postPay: 'Deferred Payment',
    checkout_postPayDesc: 'Invoice issued after delivery',
    checkout_orderItems: 'Order Items',
    checkout_qty: 'Qty:',
    checkout_won: 'KRW',
    checkout_itemCount: 'Items',
    checkout_count: '',
    checkout_shipping: 'Shipping',
    checkout_free: 'Free',
    checkout_total: 'Total',
    checkout_quoteGuide: 'Quote upon request',
    checkout_processing: 'Processing order…',
    checkout_placeOrder: 'Place Order',
    checkout_backToCart: '← Back to Cart',

    // ── OrderConfirmPage ──
    order_seoTitle: 'Order Confirmed',
    order_notFound: 'Order information not found',
    order_browse: 'Browse Products',
    order_success: 'Your order has been placed',
    order_successSub: 'A representative will contact you shortly',
    order_orderNo: 'Order No.',
    order_amount: 'Amount',
    order_won: 'KRW',
    order_guideTitle: 'Order Process',
    order_step1: 'Order Received',
    order_step1Desc: 'Your order has been received successfully',
    order_step2: 'Order Confirmed',
    order_step2Desc: 'A representative will review your order',
    order_step3: 'Preparation',
    order_step3Desc: 'Products are prepared and inspected',
    order_step4: 'Delivery / Installation',
    order_step4Desc: 'Delivery or installation schedule will be arranged',
    order_viewHistory: 'View Order History',
    order_continueShopping: 'Continue Shopping',

    // ── SitemapPage ──
    sitemap_seoTitle: 'Sitemap – Ilkwang Office | Nationwide Copier Rental',
    sitemap_seoDesc: 'Ilkwang Office sitemap. Browse all pages including regional copier rental, product store, and quote inquiries.',
    sitemap_heading: 'Sitemap',
    sitemap_subtitle: 'All Ilkwang Office pages at a glance',
    sitemap_shopping: 'Store',
    sitemap_allProducts: 'All Products',
    sitemap_productSearch: 'Product Search',
    sitemap_cartLink: 'Cart',
    sitemap_wishlistLink: 'Wishlist',
    sitemap_compareLink: 'Compare',
    sitemap_rentalSection: 'Rental',
    sitemap_nationalRental: 'Nationwide Rental',
    sitemap_rentalConsult: 'Rental Consultation',
    sitemap_support: 'Support',
    sitemap_quoteInquiry: 'Quote Inquiry',
    sitemap_phoneConsult: 'Phone Consultation 1600-7542',
    sitemap_account: 'Account',
    sitemap_loginLink: 'Log In',
    sitemap_signupLink: 'Sign Up',
    sitemap_mypage: 'My Page',
    sitemap_regionalTitle: 'Regional Rental Services',
    sitemap_regionalDesc: 'Copier rental services available in {count} regions nationwide',
    sitemap_districtCount: ' regions',
    sitemap_viewAll: 'View All →',
    sitemap_ctaTitle: "Can't find what you're looking for?",
    sitemap_ctaSub: 'Contact our specialist for assistance',
    sitemap_ctaBtn: 'Contact Us',

    // ── ProductCard ──
    card_wishlist: 'Wishlist',
    card_cart: 'Cart',
    card_compare: 'Compare',
    card_black: 'Black',
    card_cyan: 'Cyan',
    card_magenta: 'Magenta',
    card_yellow: 'Yellow',
    card_set: 'Set',
    card_genuine: 'Genuine',
    card_compatible: 'Compatible',
    card_remanufactured: 'Remanufactured',
    card_yield: 'Yield',
    card_pages: 'pages',
    card_won: 'KRW',
    card_purchase: 'Buy',
    card_color: 'Color',
    card_mono: 'Mono',
    card_detail: 'Details',
    card_rentalBtn: 'Rental',

    // ── AiChat ──
    ai_errorMsg: 'Sorry, an error occurred. Please try again.\n\nDirect inquiry: Ilkwang Office 1600-7542',
    ai_q1: 'Recommend a color copier for a 10-person office',
    ai_q2: 'Compare rental vs purchase',
    ai_q3: 'Most cost-effective mono copier?',
    ai_q4: 'Compatible toner prices please',
    ai_header: 'AI Assistant',
    ai_subtitle: 'Ask anything about copiers, printers, and toner',
    ai_emptyTitle: 'How can I help you?',
    ai_emptyDesc: 'Copier recommendations, toner compatibility search, price comparisons, and more',
    ai_recCopier: 'Recommended Copiers',
    ai_recToner: 'Recommended Toner',
    ai_inputPlaceholder: 'Type a message…',

    // ── InlineAiChat ──
    inlineAi_error: 'Sorry, an error occurred. Please try again.',
    inlineAi_q1: 'What are the rental terms for this product?',
    inlineAi_q2: 'Recommend similar models in this price range',
    inlineAi_q3: 'Compatible toner prices please',
    inlineAi_q4: 'Color copier for a 10-person office',
    inlineAi_q5: 'Rental vs purchase comparison',
    inlineAi_q6: 'Budget-friendly mono copier',
    inlineAi_emptyText: 'Ask me anything',
    inlineAi_placeholder: 'Type a message…',
    inlineAi_product: 'Product',

    // ── InlineInquiryForm ──
    inqForm_rental: 'Rental',
    inqForm_rentalMsg: 'I would like to inquire about rental.',
    inqForm_error: 'An error occurred. Please try again.',
    inqForm_successTitle: 'Inquiry Submitted',
    inqForm_successDesc: 'We will contact you shortly.',
    inqForm_name: 'Name *',
    inqForm_company: 'Company',
    inqForm_phone: 'Phone *',
    inqForm_email: 'Email',
    inqForm_inquiryType: 'Inquiry Type',
    inqForm_purchase: 'Purchase',
    inqForm_tonerSupplies: 'Toner & Supplies',
    inqForm_maintenance: 'Maintenance',
    inqForm_other: 'Other',
    inqForm_content: 'Message',
    inqForm_submitting: 'Submitting…',
    inqForm_submitBtn: 'Submit Inquiry',
    inqForm_monthly: '/mo',
    inqForm_won: 'KRW',

    // ── Footer ──
    footer_desc1: 'Copier, Printer & Toner Specialists',
    footer_desc2: 'Rental · Sales · Maintenance',
    footer_hours: 'Weekdays 10:00 AM – 06:00 PM',
    footer_lunch: 'Lunch 12:00 PM – 01:00 PM',
    footer_holidays: 'Closed on weekends & public holidays',
    footer_quickLinks: 'Quick Links',
    footer_rentalLink: 'Rental Products',
    footer_mallLink: 'Toner Products',
    footer_servicesTitle: 'Services',
    footer_svcAi: 'AI Copier Recommendation',
    footer_svcSearch: 'Toner Compatibility Search',
    footer_svcCompare: 'Genuine vs Compatible Price Comparison',
    footer_svcConsult: 'Rental Quote Consultation',

    // ── Common ──
    common_won: 'KRW',
    common_count: '',
    common_monthly: '/mo',
    common_pages: 'pages',
    common_rental: 'Rental',
    common_sale: 'Sales',
    common_copier: 'Copier',
    common_toner: 'Toner',
    common_sktec: 'Our Mall',
    common_priceInquiry: 'Price Inquiry',
    common_color: 'Color',
    common_mono: 'Mono',
    common_supported: 'Supported',
    common_notSupported: 'Not Supported',
    common_goTo: 'Go >',

    // ── ProductDetailPage ──
    detail_reviewError: 'Failed to submit review',
    detail_loading: 'Loading...',
    detail_notFound: 'Product not found.',
    detail_backToStore: '← Back to Store',
    detail_copier: 'Copier',
    detail_rental: 'Rental',
    detail_priceInquiry: 'Price Inquiry',
    detail_ilkwangOffice: 'Ilkwang Office',
    detail_sktec: 'Our Mall',
    detail_sale: 'Sale',
    detail_seoul: 'Seoul',
    detail_overview: 'Overview',
    detail_specs: 'Specifications',
    detail_reviews: 'Reviews',
    detail_store: 'Store',
    detail_freeDelivery: 'Nationwide Delivery',
    detail_expertConsult: 'Expert Consultation',
    detail_genuineWarranty: 'Genuine Warranty',
    detail_monthlyRental: 'Monthly Rental',
    detail_wonMonth: 'KRW/mo',
    detail_salePrice: 'Sale Price',
    detail_price: 'Price',
    detail_won: 'KRW',
    detail_category: 'Category:',
    detail_contract: 'Contract Period:',
    detail_brand: 'Brand',
    detail_model: 'Model',
    detail_categorySpec: 'Category',
    detail_bwSpeed: 'B&W Speed',
    detail_colorSpeed: 'Color Speed',
    detail_paperSize: 'Paper Size',
    detail_fax: 'Fax',
    detail_supported: 'Supported',
    detail_notSupported: 'Not Supported',
    detail_duplex: 'Duplex Printing',
    detail_monthlyVolume: 'Recommended Monthly Volume',
    detail_contractPeriod: 'Contract Period',
    detail_addedToCart: '✓ Added to Cart',
    detail_addToCart: 'Add to Cart',
    detail_loginToCart: 'Log in to Add to Cart',
    detail_rentalInquiry: 'Rental Inquiry',
    detail_addedToWishlist: 'Added to Wishlist',
    detail_addToWishlist: 'Add to Wishlist',
    detail_aiConsult: 'AI Consultation',
    detail_phoneConsult: 'Call 1600-7542',
    detail_helpText: 'Get help choosing the right product.',
    detail_chatNow: 'Chat Now',
    detail_orCall: 'Or call 1600-7542.',
    detail_tabDetail: 'Product Details',
    detail_tabDelivery: 'Delivery Info',
    detail_tabReturn: 'Returns & Exchanges',
    detail_tabReview: 'Reviews',
    detail_noDetail: 'No product details available.',
    detail_productImages: 'Product Images',
    detail_deliveryGuide: 'Delivery Guide',
    detail_deliveryMethod: 'Shipping Method: Courier / Direct delivery (for large copiers)',
    detail_deliveryArea: 'Delivery Area: Nationwide (excluding remote islands)',
    detail_deliveryTime: 'Delivery Time: Courier 2–3 days / Large equipment installation by arrangement',
    detail_deliveryFee: 'Shipping Fee: Free (additional charges may apply for remote areas)',
    detail_deliveryInquiry: 'Delivery Inquiries:',
    detail_returnGuide: 'Returns & Exchanges Guide',
    detail_returnPeriod: 'Return/Exchange Period',
    detail_returnPeriodDesc: 'Returns/exchanges available within 7 days of receipt',
    detail_returnExclude: 'Non-returnable Cases',
    detail_returnExclude1: 'Packaging damaged or product defaced by customer',
    detail_returnExclude2: 'Used toner or consumables',
    detail_returnExclude3: 'Custom-made products',
    detail_returnExclude4: 'More than 7 days after receipt',
    detail_returnCost: 'Return/Exchange Costs',
    detail_returnCostDesc: 'Free for defects/wrong delivery; round-trip shipping at customer expense otherwise',
    detail_returnInquiry: 'Return/Exchange Inquiries:',
    detail_reviewCount: ' reviews',
    detail_noReviews: 'No reviews yet.',
    detail_reviewer: 'Buyer',
    detail_writeReview: 'Write a Review',
    detail_rating: 'Rating',
    detail_reviewTitlePh: 'Review title (optional)',
    detail_reviewContentPh: 'Share your experience with this product...',
    detail_submittingReview: 'Submitting...',
    detail_submitReview: 'Submit Review',
    detail_ctaTitle: 'Need a solution?',
    detail_ctaDesc: 'Design the optimal solution with Ilkwang Office experts.',
    detail_ctaBtn: 'Expert Consultation',
    detail_aiConsultPanel: 'AI Consultation',
    detail_rentalPanel: 'Rental Inquiry',

    // ── CopierDetailPage ──
    copier_loading: 'Loading...',
    copier_notFound: 'Product not found',
    copier_backToList: '← Back to Product List',
    copier_seoSuffix: 'Copier Details - Ilkwang Office',
    copier_seoDesc: 'Copier detailed information. Specifications, pricing, rental terms, and compatible toner data. Compare copiers at Ilkwang Office.',
    copier_catalog: 'Product Catalog',
    copier_color: 'Color',
    copier_mono: 'Mono',
    copier_speed: 'Print Speed',
    copier_paperSize: 'Paper Size',
    copier_monthlyVolume: 'Recommended Monthly Volume',
    copier_priceRange: 'Price Range',
    copier_addedToCart: '✓ Added',
    copier_cart: 'Cart',
    copier_wishlistOn: '♥ Saved',
    copier_wishlistOff: '♡ Save',
    copier_compare: '⚖️ Compare',
    copier_buyAtMall: 'Buy at Our Mall',
    copier_rentalInquiry: '📞 Rental Inquiry',
    copier_askAi: '🤖 Ask AI',
    copier_compatToner: '🔵 Compatible Toner / Consumables',
    copier_tonerCount: 'types',
    copier_priceCompare: '💰 Genuine vs Compatible Price Comparison',
    copier_thToner: 'Toner',
    copier_thColor: 'Color',
    copier_thGenuine: 'Genuine Price',
    copier_thCompatible: 'Compatible Price',
    copier_thSaving: 'Saving',
    copier_thYield: 'Yield',
    copier_black: 'Black',
    copier_cyan: 'Cyan',
    copier_magenta: 'Magenta',
    copier_yellow: 'Yellow',
    copier_set: 'Set',
    copier_won: 'KRW',
    copier_pages: 'pages',
    copier_noToner: 'No compatible toner information available. Please contact Ilkwang Office (1600-7542).',
    copier_aiPanel: 'AI Consultation',
    // ── RegionalRentalPage ──
    rental_locationTitle: 'Location-Based Recommendations',
    rental_locationDesc: 'Share your location to get copier rental recommendations near you.',
    rental_later: 'Later',
    rental_allowLocation: 'Allow Location',
    rental_myLocation: 'My Location',
    rental_all: 'All',
    rental_copierRental: 'Copier Rental',
    rental_regionCopierRental: 'Regional Copier Rental',
    rental_nationwideCopierRental: 'Nationwide Copier Rental by Region',
    rental_districtDesc: 'area copier & printer rental. Free installation, regular maintenance & toner support.',
    rental_regionDesc: 'Full area copier rental service. Select a district.',
    rental_nationwideDesc: 'Copier rental available nationwide. Select a province to get started.',
    rental_nationwide: 'Nationwide',
    rental_districts: 'districts',
    rental_products: 'Products',
    rental_selectRegion: 'Select Region',
    rental_findByLocation: 'Find by Location',
    rental_searchPlaceholder: 'Search copiers...',
    rental_region: 'Region',
    rental_filterAll: 'All',
    rental_filterColor: 'Color',
    rental_filterMono: 'B&W',
    rental_brandAll: 'All Brands',
    rental_categoryAll: 'All Categories',
    rental_sortDefault: 'Sort: Default',
    rental_sortPriceAsc: 'Price: Low to High',
    rental_sortPriceDesc: 'Price: High to Low',
    rental_sortName: 'By Name',
    rental_reset: 'Reset',
    rental_rentalProducts: 'Rental Products',
    rental_count: '',
    rental_quoteInquiry: 'Quote Inquiry',
    rental_noProductsYet: 'No products registered in this area yet',
    rental_selectDistrict: 'Please select a district',
    rental_requestQuoteDesc: 'If you need a copier in this area, please request a quote. Our specialists will guide you to the best rental plan.',
    rental_selectRegionHint: 'Select a region on the left to see available rental products.',
    rental_requestQuote: 'Request Quote',
    rental_freeInstall: 'Free Installation',
    rental_freeInstallDesc: 'Free delivery & installation nationwide',
    rental_regularCheck: 'Regular Maintenance',
    rental_regularCheckDesc: 'Monthly free maintenance service',
    rental_freeToner: 'Free Toner',
    rental_freeTonerDesc: 'Free supplies delivery support',
    rental_badge_rental: 'Rental',
    rental_badge_both: 'Sale+Rental',
    rental_monthly: 'Mo.',
    rental_won: 'KRW',
    rental_priceInquiry: 'Contact for Price',
    rental_detail: 'Details →',
    rental_copierConsult: 'Copier Rental Consultation',
    rental_ctaDesc: 'Request a quote for your desired product. Free installation, regular maintenance & free toner support.',
    rental_freeQuoteRequest: 'Free Quote Request',
    // ── CustomerERPPage ──
    erp_home: 'Home',
    erp_aiConsult: 'AI Chat',
    erp_usageAnalysis: 'Usage Analysis',
    erp_quoteManage: 'Quote Management',
    erp_inquiryManage: 'Inquiry Management',
    erp_cart: 'Cart',
    erp_wishlist: 'Wishlist',
    erp_orderHistory: 'Order History',
    erp_purchaseManage: 'Purchase Management',
    erp_chatHistory: 'Chat History',
    erp_myInfo: 'My Info',
    erp_reviewLounge: 'Review Lounge',
    erp_tripManage: 'Trip Manager',
    erp_tripDesc: 'Plan routes with departure, waypoints, and destination',
    erp_statusDraft: 'Draft',
    erp_statusSubmitted: 'Submitted',
    erp_statusReviewed: 'Under Review',
    erp_statusSent: 'Sent',
    erp_typeRental: 'Rental',
    erp_typePurchase: 'Purchase',
    erp_typeToner: 'Toner',
    erp_typeEtc: 'Other',
    erp_aiConsultDesc: 'Ask AI anything',
    erp_usageDesc: 'Photo report → AI auto-recognition',
    erp_quickInquiry: 'Quick Inquiry',
    erp_quickInquiryDesc: 'Complete in 1 minute',
    erp_writeQuote: 'Create Quote',
    erp_writeQuoteDesc: 'Get a custom quote',
    erp_bulkPurchase: 'Bulk Purchase',
    erp_bulkPurchaseDesc: 'For corporate buyers',
    erp_nationalRental: 'Nationwide Rental',
    erp_nationalRentalDesc: 'Search local rentals',
    erp_compare: 'Compare Products',
    erp_compareDesc: 'Copier comparison analysis',
    erp_productSearch: 'Product Search',
    erp_productSearchDesc: 'AI personalized recommendation',
    erp_wishlistDesc: 'View saved products',
    erp_sitemap: 'Sitemap',
    erp_sitemapDesc: 'Full menu at a glance',
    erp_allProducts: 'All Products',
    erp_aiSearch: 'AI Search',
    erp_myPage: '\'s My Page',
    erp_seoDesc: 'Ilkwang Office Customer ERP – Quotes, Inquiries, AI Consultation, Purchase Management',
    erp_hello: 'Hello',
    erp_honorific: '',
    erp_goHome: 'Home',
    erp_logout: 'Logout',
    erp_siteShortcuts: 'Site Shortcuts',
    erp_more: 'More',
    erp_quotes: 'Quotes',
    erp_inquiryHistory: 'Inquiry History',
    erp_shortcuts: 'Quick Access',
    erp_recentQuotes: 'Recent Quotes',
    erp_viewAll: 'View All →',
    erp_recentInquiries: 'Recent Inquiries',
    erp_tipText: '💡 Did you know?',
    erp_tipDesc: 'Get AI recommendations for the best copier and create quotes instantly.',
    erp_tipBtnAi: 'Start AI Chat',
    erp_aiDesc: 'AI assistant recommends the best copiers and toners for you',
    erp_newChat: 'New Chat',
    erp_prevChats: 'Previous Chats',
    erp_aiAsk: 'Ask AI Assistant',
    erp_aiHint: 'Ask anything about copier recommendations, toner compatibility, price comparisons, etc.',
    erp_suggestOffice: 'Recommend a copier for my office',
    erp_suggestCompare: 'Compare color copiers',
    erp_suggestToner: 'Find compatible toners',
    erp_suggestSmall: 'Best products for a small office?',
    erp_recCopier: 'Recommended Copiers',
    erp_recToner: 'Recommended Toners',
    erp_msgPlaceholder: 'Type a message...',
    erp_chatError: 'Sorry, an error occurred. Please try again.',
    erp_quoteManageDesc: 'Create and manage your quotes',
    erp_newQuote: 'New Quote',
    erp_noQuotes: 'No quotes yet',
    erp_noQuotesHint: 'Create a new quote to get started',
    erp_createQuote: 'Create Quote',
    erp_submit: 'Submit',
    erp_delete: 'Delete',
    erp_adminNote: 'Admin Note:',
    erp_items: 'Items',
    erp_backToQuotes: '← Quote List',
    erp_newQuoteTitle: 'Create New Quote',
    erp_quoteTitle: 'Quote Title',
    erp_companyName: 'Company Name',
    erp_addItem: 'Add Item',
    erp_productModel: 'Product / Model Name',
    erp_quantity: 'Qty',
    erp_addMore: '+ Add',
    erp_productNameCol: 'Product',
    erp_typeCol: 'Type',
    erp_additionalNotes: 'Additional Notes (Optional)',
    erp_saveQuote: 'Save Quote',
    erp_inquiryManageDesc: 'Send inquiries and check replies',
    erp_autoFillInfo: 'Info auto-filled',
    erp_rentalInquiry: 'Rental Inquiry',
    erp_purchaseInquiry: 'Purchase Inquiry',
    erp_tonerInquiry: 'Toner Inquiry',
    erp_etcInquiry: 'Other Inquiry',
    erp_sendInquiry: 'Send Inquiry',
    erp_noInquiries: 'No inquiries yet',
    erp_adminReply: 'Admin Reply',
    erp_inquiryPlaceholder: 'Enter your inquiry...',
    erp_answered: 'Answered',
    erp_processing: 'Processing',
    erp_received: 'Received',
    erp_emptyCart: 'Your cart is empty',
    erp_emptyCartHint: 'Add products you like to your cart',
    erp_browseProducts: 'Browse Products →',
    erp_copier: 'Copier',
    erp_toner: 'Toner',
    erp_inHouse: 'In-house',
    erp_requestQuoteInquiry: 'Request Quote',
    erp_goToCart: 'Go to Cart →',
    erp_product: 'Product',
    erp_won: 'KRW',
    erp_cartInquiry: 'Quick Inquiry',
    erp_saved: 'Saved to Wishlist',
    erp_emptyWishlist: 'Your wishlist is empty',
    erp_emptyWishlistHint: 'Tap the heart icon on products to save them',
    erp_viewDetail: 'View Details',
    erp_copierAnalysis: 'Copier Usage Analysis',
    erp_copierAnalysisDesc: 'AI automatically analyzes your copier reports',
    erp_uploadReport: 'Upload Report',
    erp_uploadReportDesc: 'Upload a photo of your copier report',
    erp_clientName: 'Client Name',
    erp_clientExample: 'e.g., Ilkwang Office',
    erp_selectOtherFile: 'Select Another File',
    erp_startAnalysis: 'Start Analysis',
    erp_aiAnalyzing: 'AI Analyzing...',
    erp_analysisResult: 'Analysis Result',
    erp_close: 'Close',
    erp_modelName: 'Model',
    erp_reportDate: 'Report Date',
    erp_totalPages: 'Total Pages',
    erp_color: 'Color',
    erp_bw: 'B&W',
    erp_scan: 'Scan',
    erp_fax: 'Fax',
    erp_copy: 'Copy',
    erp_printPages: 'Print',
    erp_tonerRemaining: 'Toner Remaining',
    erp_usageByUser: 'Usage by User',
    erp_user: 'User',
    erp_total: 'Total',
    erp_extraInfo: 'Extra Info',
    erp_analysisHistory: 'Analysis History',
    erp_countUnit: '',
    erp_noReports: 'No analysis history yet',
    erp_unknownModel: 'Unknown',
    erp_client: 'Client',
    erp_totalPrefix: 'Total',
    erp_sheets: 'sheets',
    erp_orderHistoryDesc: 'Check your order history',
    erp_noOrders: 'No orders yet',
    erp_noOrdersHint: 'Your orders will appear here',
    erp_orderPending: 'Pending',
    erp_orderConfirmed: 'Confirmed',
    erp_orderProcessing: 'Processing',
    erp_orderShipping: 'Shipping',
    erp_orderDelivered: 'Delivered',
    erp_orderCancelled: 'Cancelled',
    erp_orderRefunded: 'Refunded',
    erp_qtyLabel: 'Qty',
    erp_cancelOrder: 'Cancel Order',
    erp_purchaseManageDesc: 'Manage bulk purchases and rental inquiries',
    erp_bulkInquiry: 'Bulk Purchase/Rental Inquiry',
    erp_bulkInquiryDesc: 'Enter your equipment requirements',
    erp_equipment: 'Equipment',
    erp_productReq: 'Product/Specifications',
    erp_productReqExample: 'e.g., Color copier A3',
    erp_installLocation: 'Installation Location',
    erp_installExample: 'e.g., Seoul Gangnam',
    erp_addEquipment: '+ Add Equipment',
    erp_sendBulkInquiry: 'Send Bulk Inquiry',
    erp_corporateGuide: 'Corporate Purchasing Guide',
    erp_corpFeat1Title: 'Expert Consultation',
    erp_corpFeat1Desc: 'Tailored advice for your company size',
    erp_corpFeat2Title: 'Volume Discounts',
    erp_corpFeat2Desc: 'Special discounts for 10+ units',
    erp_corpFeat3Title: 'Unified Management',
    erp_corpFeat3Desc: 'Enterprise-wide equipment management',
    erp_corpFeat4Title: 'Priority Service',
    erp_corpFeat4Desc: 'Priority technical support for corporate clients',
    erp_corpFeat5Title: 'Monthly Reports',
    erp_corpFeat5Desc: 'Monthly usage reports provided',
    erp_dedicatedConsult: 'Dedicated Consultant',
    erp_dedicatedConsultDesc: 'A dedicated consultant is assigned to corporate clients',
    erp_makeInquiry: 'Make Inquiry',
    erp_individualBuyer: 'Individual Buyer',
    erp_aiRec: 'AI Recommendation',
    erp_rentalQuote: 'Rental Quote',
    erp_clickToSelect: 'Click to select',
    erp_aiChatHistory: 'AI Chat History',
    erp_aiChatHistoryDesc: 'View your previous AI chat sessions',
    erp_noChatHistory: 'No AI chat history yet',
    erp_startAiChat: 'Start AI Chat',
    erp_messagesCount: ' messages',
    erp_editProfileDesc: 'Edit your profile information',
    erp_name: 'Name',
    erp_company: 'Company',
    erp_phone: 'Phone',
    erp_email: 'Email',
    erp_editProfile: 'Edit Profile',
    erp_accountInfo: 'Account Info',
    erp_accountType: 'Account Type',
    erp_local: 'Local',
    erp_accountLabel: 'Account',
    erp_loginLabel: 'Login',
    erp_role: 'Role',
    erp_roleAdmin: 'Admin',
    erp_roleMember: 'Member',
    erp_deleteAccount: 'Delete Account',
    erp_deleteAccountDesc: 'Deleting your account will permanently remove all data.',
    erp_deleteAccountRequest: 'Request Account Deletion',
    erp_deleteAccountConfirm: 'Are you sure you want to delete your account? This cannot be undone.',
    erp_deleteNow: 'Delete Now',
    erp_cancel: 'Cancel',
    erp_requestDelete: 'Request Deletion',
    erp_deleteAccountAlerted: 'Account deletion has been requested. An admin will process it.',
    erp_errorOccurred: 'An error occurred',
    erp_myReviewLounge: 'My Review Lounge',
    erp_communityDesc: 'Check your community activity',
    erp_myTonerPoints: 'My Toner Points',
    erp_myBadge: 'My Badge',
    erp_goToReviewLounge: 'Go to Review Lounge →',
    erp_myPosts: 'My Posts',
    erp_myComments: 'My Comments',
    erp_pointHistory: 'Point History',
    erp_noMyPosts: 'No posts yet',
    erp_noMyComments: 'No comments yet',
    erp_totalPoints: 'Total Points',
    erp_badgeLevel: 'Badge Level',
    erp_maxDiscount: 'Max Discount',
    erp_typeLabel: 'Type',
    erp_pointLabel: 'Points',
    erp_reason: 'Reason',
    erp_dateTime: 'Date',
    erp_noPointHistory: 'No point history yet',
    erp_earn: 'Earn',
    erp_spend: 'Spend',
    erp_rec: 'Rec.',
    erp_commentsLabel: 'Comments',
    erp_views: 'Views',
    erp_badgeA4: 'A4 Beginner',
    erp_badgeInkjet: 'Inkjet Runner',
    erp_badgeColorLaser: 'Color Laser Pro',
    erp_badgeMaster: 'Copier Master',
    livechat_consult: 'Live Chat',
    livechat_channelSelect: 'Select Channel',
    livechat_chat: 'Live Chat',
    livechat_hours: 'Weekdays 09:00 – 18:00',
    livechat_howToConsult: 'How would you like to chat?',
    livechat_kakaoChat: 'KakaoTalk Chat',
    livechat_kakaoDesc: 'Fast response · Send photos',
    livechat_fastResponse: 'Fast',
    livechat_siteChat: 'Site Live Chat',
    livechat_siteChatDesc: 'Chat after logging in',
    livechat_aiAssistant: 'AI Assistant',
    livechat_aiAssistantDesc: '24/7 AI auto consultation',
    livechat_kakaoFastest: 'KakaoTalk is the fastest!',
    livechat_customerCenter: 'Customer Center',
    livechat_welcome: 'Ask us anything!',
    livechat_askAnything: 'Leave your questions about copiers, toners, rentals, etc.',
    livechat_fasterTip: 'For faster support, try',
    livechat_kakaoLink: 'KakaoTalk Chat',
    livechat_fasterTipSuffix: '!',
    livechat_agent: 'Agent',
    livechat_inputPlaceholder: 'Type a message...',
    livechat_chatClosed: 'Chat has ended',
    filter_all: 'All',
  },

  ja: {
    // ── HomePage ──
    home_seoTitle:
      '複合機・コピー機・印刷の専門店 | 一光オフィス – レンタル・販売・トナー価格比較',
    home_seoDesc:
      '複合機・コピー機・印刷の専門店、一光オフィス。オフィス用複合機レンタル月3万ウォンから。カラー・モノクロコピー機販売、トナー価格比較。AIおすすめでSamsung・Canon・富士ゼロックス・京セラ・Sindohの複合機を比較。',
    home_heroTitle: 'ストア.',
    home_heroSub:
      'オフィスに最適な複合機を選ぶ、最も賢い方法。',
    home_askAi: 'AIに聞く',
    home_askAiDesc: '用途に合った機器をAIがお探しします。',
    home_callConsult: '電話相談',
    home_callConsultDesc: '担当者と直接お話しいただけます。',
    home_catColor: 'カラー複合機',
    home_catMono: 'モノクロ複合機',
    home_catPrinter: 'プリンター',
    home_catToner: 'トナー・消耗品',
    home_catConsult: '相談',
    home_catOwnMall: '自社モール',
    home_catAi: 'AIおすすめ',
    home_catDigital: 'デジタル印刷機',
    home_catDigitalDesc: '高速デジタル印刷',
    home_catLarge: '大型複合機',
    home_catLargeDesc: 'A3大型複合機',
    home_catSmall: '小型複合機',
    home_catSmallDesc: 'A4デスクトップ複合機',
    home_catPrinterDesc: 'レーザー・インクジェットプリンター',
    home_catTonerDesc: '純正・互換・再生トナー',
    home_searchTitle: '製品検索',
    home_searchDesc: 'モデル名、ブランド、トナー番号で検索',
    home_noResults: '検索結果がありません',
    home_searchHint2: '検索してみてください',
    home_newProducts: '新製品',
    home_newProductsDesc: '新しく登録された製品をご覧ください',
    home_rental: 'レンタル',
    home_monthlyPrice: '月額 {price}ウォン〜',
    home_priceInquiry: '価格お問合せ',
    home_quickLinks: 'クイックリンク.',
    home_quickLinksDesc: 'よく使うページにすぐアクセス。',
    home_productStore: '製品ストア',
    home_aiRecommend: 'AIおすすめ',
    home_productCompare: '製品比較',
    home_cart: 'カート',
    home_wishlist: 'お気に入り',
    home_myErp: 'マイERP',
    home_nationalRental: '全国レンタル',
    home_consult: '相談',
    home_sitemapLink: 'サイトマップ',
    home_phoneConsult: '電話相談',
    home_consultSection: '相談',
    home_consultDesc:
      'レンタル見積もり、製品のお問合せ、リアルタイム相談をワンストップで。',
    home_rentalQuote: 'レンタル見積もり',
    home_rentalQuoteDesc:
      '自動見積もり計算機で月額レンタル料を即座に確認。',
    home_getQuote: '見積もりを取る >',
    home_generalConsult: '一般相談',
    home_generalConsultDesc:
      '購入、トナー、アフターサービスなどすべてのお問合せを受け付けます。',
    home_inquireNow: 'お問合せ >',
    home_liveConsult: 'リアルタイム相談',
    home_liveConsultDesc:
      'KakaoTalk、チャット、電話ですぐに相談。',
    home_consultNow: '相談する >',
    home_globalInquiry: '海外からのお問合せ',
    home_rentalMall: '全国レンタルモール.',
    home_rentalMallDesc1:
      'ソウル・釜山・大邱・仁川・光州・大田・蔚山・世宗・京畿など全国どこでも',
    home_rentalMallDesc2:
      '複合機・プリンターのレンタルサービスをご利用ください。無料設置＆定期点検。',
    home_seoul: 'ソウル',
    home_gwanghwamun: '光化門',
    home_busan: '釜山',
    home_jagalchi: 'チャガルチ市場',
    home_daegu: '大邱',
    home_daeguSub: 'りんご・薬令市',
    home_incheon: '仁川',
    home_chinatown: 'チャイナタウン',
    home_gyeonggi: '京畿',
    home_suwon: '水原華城',
    home_gwangju: '光州',
    home_gwangjuSub: '無等山・ビビンバ',
    home_daejeon: '大田',
    home_daejeonSub: 'ソンシムダン・パン',
    home_jeju: '済州',
    home_jejuSub: 'ハルラボン・みかん',
    home_viewAllRegions: '全国260+地域を見る >',
    home_nationalRentalMall: '全国レンタルモール',
    home_regionsCount: '260+地域',
    home_goTo: '移動 >',
    home_aiConsult: 'AI相談',
    home_productSearch: '製品検索',
    home_searchPlaceholder:
      '複合機のモデル名やトナー番号で検索してください。',
    home_searchBtn: '検索',
    home_searchHint: '例: "Samsung SL-XA225" または "CLT-K3080S"',
    home_shortcuts: 'ショートカット',
    home_rentalInquiry: 'レンタルお問合せ',
    home_ownMall: '自社モール',
    home_latestProducts: '最新製品.',
    home_latestProductsDesc: '一光オフィスの人気製品。',
    home_viewAll: 'すべて見る >',
    home_rentalProducts: 'レンタル製品.',
    home_rentalProductsDesc:
      'お得なレンタル複合機。',
    home_myErpSection: 'マイERP.',
    home_myErpDesc: 'オフィス向けカスタム管理ツール。',
    home_erpAi: 'AI相談',
    home_erpAiDesc:
      'AIに何でもお尋ねください。複合機推薦から見積もりまで。',
    home_erpUsage: '使用量分析',
    home_erpUsageDesc:
      'レポートを1枚撮影するだけでAIが自動的に分析します。',
    home_erpQuote: '見積書作成',
    home_erpQuoteDesc: 'カスタム見積もりをリクエスト・管理。',
    home_erpInquiry: 'クイックお問合せ',
    home_erpInquiryDesc: '1分でお問合せ完了。',
    home_erpBulk: '大量購入',
    home_erpBulkDesc: '企業購買担当者向け専用ツール。',
    home_erpCart: 'カート',
    home_erpCartDesc: '商品を確認して注文。',
    home_services: 'サービス.',
    home_servicesDesc:
      '一光オフィスのプロフェッショナルサービスをご体験ください。',
    home_svcAi: 'AI複合機おすすめ',
    home_svcAiDesc:
      'オフィス環境に最適な複合機をAIが分析しておすすめします。',
    home_svcAiCta: '始める >',
    home_svcRental: 'レンタルサービス',
    home_svcRentalDesc:
      'リーズナブルな月額でレンタル。メンテナンスまでワンストップ。',
    home_svcRentalCta: 'レンタル製品を見る >',
    home_svcToner: 'トナー・消耗品購入',
    home_svcTonerDesc:
      '純正・互換・リサイクルトナーをお得な価格で。',
    home_svcTonerCta: 'トナー製品を見る >',
    home_convenienceServices: '便利サービス.',
    home_convenienceDesc:
      'オフィス機器管理に必要なすべてのツールをワンストップで。',
    home_usageAnalysis: '使用量分析',
    home_usageAnalysisDesc:
      'レポートを1枚撮影するだけでAIが複合機の使用量を自動分析。',
    home_analyzeNow: '分析する >',
    home_orderTracking: '注文・配送追跡',
    home_orderTrackingDesc:
      '注文履歴を確認し、配送状況をリアルタイムで追跡。',
    home_trackNow: '追跡する >',
    home_quoteManage: '見積もり・お問合せ管理',
    home_quoteManageDesc:
      'リクエストした見積書とお問合せ内容を一括で確認・管理。',
    home_checkNow: '確認する >',
    home_guideTitle: '複合機・コピー機・印刷ガイド.',
    home_guideDesc:
      'オフィスに最適な複合機の選び方をご紹介します。',
    home_guideQ1: '複合機とは？',
    home_guideA1:
      '複合機（MFP）はプリンター、コピー機、スキャナー、ファクス機能を一台に統合したオフィス機器です。コピー機と違い、印刷・スキャン・ファクスを1台で処理でき、オフィススペースを最大限に活用できます。最新の複合機はクラウド連携、モバイル印刷、自動両面印刷にも対応しています。',
    home_guideQ2: 'コピー機と複合機の違い',
    home_guideA2:
      'コピー機は文書のコピーに特化した機器で、複合機は印刷＋コピー＋スキャン＋ファクス機能を一台に統合したオールインワン機器です。現在の市場では複合機が標準であり、「コピー機」と言えば実質的に複合機を指します。コスト面でも複合機が有利です。',
    home_guideQ3: 'オフィス印刷コスト削減の方法',
    home_guideA3:
      'コスト削減の要点は ①レンタル導入（初期費用↓）、②使用量分析（IT自動レポート）、③互換/再生トナー活用（30〜60%削減）、④両面印刷の標準設定です。一光オフィスのAI使用量分析とカスタムレンタルで印刷コストを最適化しましょう。',
    home_guideQ4: '複合機レンタル vs 購入',
    home_guideA4:
      'レンタルは初期費用が低く、メンテナンスとトナーが含まれ管理が簡単です。購入は長期的にコスト削減になりますが、修理・消耗品費用は別途必要です。5台以上の大量導入にはレンタル、少量・短期使用には購入が有利です。',
    home_guideQ5: '純正トナー vs 互換トナー vs 再生トナー',
    home_tonerCompareTitle: 'トナー種類別比較',
    home_tonerCompare: '区分',
    home_tonerGenuine: '純正トナー',
    home_tonerCompatible: '互換トナー',
    home_tonerRemanufactured: '再生トナー',
    home_tonerPrice: '価格',
    home_tonerPriceGenuine: '高い（基準価格）',
    home_tonerPriceCompatible: '30〜50%水準',
    home_tonerPriceReman: '20〜40%水準',
    home_tonerQuality: '品質',
    home_tonerQualityGenuine: '最高',
    home_tonerQualityCompatible: '優秀',
    home_tonerQualityReman: '普通〜良好',
    home_tonerWarranty: '保証',
    home_tonerWarrantyGenuine: 'メーカー保証',
    home_tonerWarrantyCompatible: '販売店保証',
    home_tonerWarrantyReman: '限定的',
    home_tonerRecommend: 'おすすめ対象',
    home_tonerRecommendGenuine: '高品質印刷が必要な場合',
    home_tonerRecommendCompatible: 'コスト削減＋品質',
    home_tonerRecommendReman: '最低価格を重視',
    home_tonerNote:
      '一光オフィスでは Samsung、Canon、富士ゼロックス、京セラ、Sindoh、HP、Brother など全ブランドの純正・互換・再生トナーを取り扱っています。',
    home_brandTitle: 'ブランド別 複合機・コピー機',
    home_brandSamsung: 'Samsung 複合機',
    home_brandCanon: 'Canon 複合機',
    home_brandFuji: '富士ゼロックス 複合機',
    home_brandKyocera: '京セラ 複合機',
    home_brandSindoh: 'Sindoh 複合機',
    home_brandHp: 'HP 複合機',
    home_brandBrother: 'Brother 複合機',
    home_brandColor: 'カラー複合機',
    home_faqTitle: 'よくある質問',
    home_faqQ1: '複合機レンタルの料金はいくらですか？',
    home_faqA1:
      '複合機レンタル料金はモデルと条件により月3万〜30万ウォンです。レンタル計算機で即座にご確認ください。',
    home_faqQ2: 'コピー機のレンタルも可能ですか？',
    home_faqA2:
      'はい、コピー機（複合機）のレンタルが可能です。カラー・モノクロ複合機からプリンターまで、全国無料設置・定期点検サービスを提供しています。',
    home_faqQ3: 'オフィスの印刷環境の最適化は可能ですか？',
    home_faqA3:
      'はい、AI使用量分析と専門コンサルティングでオフィスの印刷環境を最適化します。カスタム見積もりとコスト削減策をご提案します。',
    home_faqQ4: 'トナーにはどんな種類がありますか？',
    home_faqA4:
      '純正、互換、再生トナーの3種類があります。使用目的と予算に合ったトナーをAIがおすすめします。',
    home_faqQ5: '複合機のメンテナンスはどのように行われますか？',
    home_faqA5:
      'レンタルには月1回の定期点検、無料出張修理、トナー・ドラムの無償交換が含まれます。購入の場合もメンテナンス契約が可能です。',

    // ── StorePage ──
    store_seoTitle: 'ストア | 複合機・プリンター・トナー総合 – 一光オフィス',
    store_seoDesc: 'デジタル印刷機、大型・小型複合機、プリンター、トナー・消耗品のすべてが一ヶ所に。レンタル・販売価格比較。',
    store_heroTitle: 'ストア',
    store_heroSub: '複合機・プリンター・トナー、お探しの製品を見つけましょう。',
    store_searchPlaceholder: '製品名、ブランド、モデル名で検索',
    store_loading: '製品を読み込み中…',
    store_searchResults: '検索結果',
    store_productUnit: '件の製品',
    store_noResults: '検索結果がありません。',
    store_tryOther: '別のキーワードで検索してください。',
    store_shopByCategory: 'カテゴリーで探す',
    store_shopByCategorySub: 'お好みのカテゴリーを選んでください。',
    store_viewAll: 'すべて見る',
    store_noProducts: 'このカテゴリーに製品がありません。',
    store_sortLatest: 'おすすめ順',
    store_sortName: '名前順',
    store_sortPriceAsc: '価格: 安い順',
    store_sortPriceDesc: '価格: 高い順',
    store_sortRental: 'レンタル料: 安い順',
    store_saleRental: 'レンタル',
    store_saleBoth: '販売+レンタル',
    store_salePurchase: '販売',
    store_inquiry: 'お問合せ',
    store_details: '詳細',
    store_subAll: 'すべて',
    store_subToner: 'トナー',
    store_subDrum: 'ドラム',
    store_subDeveloper: '現像器',
    store_subFuser: '定着器',
    store_subParts: '部品',
    store_subPaper: '用紙',

    // ── ProductsPage ──
    products_seoTitle:
      '複合機・コピー機 全製品 | レンタル・販売 価格比較 – 一光オフィス',
    products_seoDesc:
      'Samsung、Canon、富士ゼロックス、京セラ、Sindoh 複合機・コピー機の全製品比較。カラー複合機、モノクロ複合機、プリンター、トナーの価格比較。レンタル月3万ウォンから。',
    products_heading: 'ストア',
    products_subtitle: '製品をクリックすると詳細をご覧いただけます。',
    products_searchPlaceholder: '製品名を検索',
    products_loading: '読み込み中…',
    products_itemCount: '件',
    products_noResults: '検索結果がありません。',
    products_noResultsSub:
      '別のカテゴリやキーワードでお試しください。',
    products_all: 'すべて',
    products_digitalPress: 'デジタル印刷機',
    products_largeMFP: '大型複合機',
    products_smallMFP: '小型複合機',
    products_printer: 'プリンター',
    products_tonerSupplies: 'トナー・消耗品',
    products_colorCopier: 'カラー複合機',
    products_monoCopier: 'モノクロ複合機',
    products_copierRental: '複合機レンタル',
    products_specialEquip: '特殊機器',
    products_copierSales: '複合機販売',
    products_sktecMall: 'ストア',
    products_ikofficesRental: 'レンタル',
    products_saleRental: '販売＋レンタル',
    products_sale: '販売',
    products_rental: 'レンタル',
    products_monthly: '月',
    products_won: 'ウォン',
    products_wonTilde: 'ウォン〜',
    products_priceInquiry: '価格お問合せ',
    products_prev: '前へ',
    products_next: '次へ',

    // ── SearchPage ──
    search_seoTitle:
      '複合機 AI検索 | コピー機・トナー検索 – 一光オフィス',
    search_seoDesc:
      'AIがオフィス環境に最適な複合機・コピー機をおすすめします。モデル名・トナー番号で検索。',
    search_heading: 'AI検索',
    search_subtitle:
      'AIに質問、またはモデル名で直接検索。おすすめ製品は自社モールまたはレンタルモールへ直接リンクします。',
    search_aiConsult: 'AI相談',
    search_productSearch: '製品検索',
    search_placeholder: 'モデル名、ブランド、トナー番号を検索…',
    search_searching: '検索中…',
    search_searchBtn: '検索',
    search_copiers: '複合機',
    search_count: '件',
    search_tonerSupplies: 'トナー・消耗品',
    search_noResults: '検索結果がありません',
    search_initialHint:
      '複合機のモデル名やトナー番号を検索してください。',
    search_exampleHint: '例: "Samsung SL-X4225" または "CLT-K808S"',
    search_shortcuts: 'ショートカット',
    search_rentalInquiry: 'レンタルお問合せ',
    search_ownMall: '自社モール',

    // ── ConsultationPage ──
    consult_seoTitle:
      '相談 – レンタル見積もり・リアルタイム相談・海外お問合せ | 一光オフィス',
    consult_seoDesc:
      '複合機、プリンター、トナーのレンタル見積もり・相談。KakaoTalk・リアルタイムチャット・電話相談。海外からのお問合せも対応。',
    consult_heading: '相談',
    consult_subtitle:
      'レンタル見積もり、製品お問合せ、リアルタイム相談をワンストップで。',
    consult_tabRental: 'レンタル見積もり',
    consult_tabGeneral: '一般相談',
    consult_tabLive: 'リアルタイム相談',
    consult_tabGlobal: '海外お問合せ',
    consult_calcTitle: 'レンタル料金計算機',
    consult_planSelect: 'プランを選択',
    consult_monthly: '月',
    consult_won: 'ウォン',
    consult_bwPages: '白黒 {n}枚',
    consult_colorPages: 'カラー {n}枚',
    consult_adjustPages: '出力枚数の調整',
    consult_bwCount: '白黒枚数',
    consult_colorCount: 'カラー枚数',
    consult_pages: '枚',
    consult_default: '基本',
    consult_geoNotSupported:
      'このブラウザは位置情報サービスに対応していません。',
    consult_geoError: '位置情報を取得できません。',
    consult_uploadError:
      'ファイルのアップロードに失敗しました。（最大10MB、jpg/png/pdf/doc/hwp）',
    consult_nameRequired: 'お名前を入力してください。',
    consult_phoneRequired: '電話番号を入力してください。',
    consult_submitError: 'お問合せの送信に失敗しました。',
    consult_successTitle: 'お問合せを受け付けました',
    consult_successDesc: '担当者よりすぐにご連絡いたします。',
    consult_quoteSummary: '見積もり概要',
    consult_monthlyRental: '月額レンタル料:',
    consult_autoQuoteNote:
      '見積書が自動生成されました。担当者の確認後に送付いたします。',
    consult_urgent: 'お急ぎの場合',
    consult_callUs: 'までお電話ください。',
    consult_nationalRental: '全国レンタルモール',
    consult_goHome: 'ホームへ',
    consult_selectProduct: '製品を選択',
    consult_selectProductPlaceholder: 'レンタル製品を選択してください',
    consult_searchProductPlaceholder: '製品名、ブランド検索...',
    consult_inquiryProduct: 'お問合せ製品',
    consult_autoFilled: '会員情報が自動入力されました。',
    consult_name: 'お名前',
    consult_company: '会社名',
    consult_namePlaceholder: '山田太郎',
    consult_companyPlaceholder: '株式会社〇〇',
    consult_phone: '電話番号',
    consult_email: 'メールアドレス',
    consult_installRegion: '設置地域',
    consult_locating: '位置を確認中…',
    consult_myLocation: '現在地',
    consult_additionalRequest: '追加リクエスト',
    consult_inquiryContent: 'お問合せ内容',
    consult_contentPlaceholder:
      'お問合せ内容をご入力ください。\n（製品名、数量、設置場所、ご希望条件など）',
    consult_attachment: '添付ファイル',
    consult_uploading: 'アップロード中…',
    consult_uploadPrompt:
      'クリックしてファイルを添付（画像、PDF、文書）',
    consult_remove: '削除',
    consult_estimatedMonthly: '月額レンタル料（税込）',
    consult_submitting: '送信中…',
    consult_requestQuote: '見積書をリクエスト',
    consult_sendInquiry: 'お問合せを送信',
    consult_responseNote:
      '受付後、営業日1日以内にご連絡いたします。',
    consult_contentRequired: 'お問合せ内容を入力してください。',
    consult_generalTitle: '一般相談',
    consult_generalDesc:
      '複合機、プリンター、トナーなどオフィス機器に関するすべてのご質問にお答えします。専門スタッフが丁寧にご案内します。',
    consult_sampleService: 'サンプル出力サービス',
    consult_sampleDesc:
      'ご希望の画像を添付いただければ、実際の複合機でサンプル出力し郵送いたします。',
    consult_inquiryType: 'お問合せ種類',
    consult_typePurchase: '購入に関するお問合せ',
    consult_typeToner: 'トナー/消耗品に関するお問合せ',
    consult_typeService: 'アフターサービス・メンテナンス',
    consult_typeOther: 'その他',
    consult_generalPlaceholder:
      'ご質問内容をご自由にお書きください。',
    consult_liveIntro:
      '最速で便利な相談方法をお選びください。',
    consult_recommended: 'おすすめ',
    consult_kakaoTitle: 'KakaoTalk相談',
    consult_kakaoDesc: '最も迅速にお返事できます',
    consult_kakaoCta: 'KakaoTalkで接続 >',
    consult_liveChatTitle: 'リアルタイムチャット',
    consult_liveChatDescLogin: 'オペレーターとすぐに会話',
    consult_liveChatDescNoLogin: 'ログイン後にご利用いただけます',
    consult_liveChatCtaLogin: 'チャット開始 >',
    consult_liveChatCtaNoLogin: 'ログインが必要です',
    consult_phoneTitle: '電話相談',
    consult_businessHours: '平日 10:00〜18:00',
    consult_chatHeader: '1:1 リアルタイムチャット',
    consult_chatGreeting: 'こんにちは！一光オフィスです。',
    consult_chatSubtext: 'ご質問をお気軽にどうぞ',
    consult_adminLabel: 'オペレーター',
    consult_chatPlaceholder: 'メッセージを入力…',
    consult_allFieldsRequired: '必須項目をすべて入力してください。',
    consult_phoneConsult: '電話相談',
    consult_consultHours: '相談時間',

    // ── LoginPage ──
    login_error: 'ログインに失敗しました',
    login_heading: '一光オフィス ログイン',
    login_subtitle: 'ログインすると相談履歴の保存、見積書作成、お問い合わせが便利になります',
    login_email: 'メールアドレス',
    login_password: 'パスワード',
    login_pwPlaceholder: '6文字以上',
    login_submitting: 'ログイン中…',
    login_emailLogin: 'メールでログイン',
    login_noAccount: 'アカウントをお持ちでないですか？',
    login_signup: '新規登録',

    // ── SignupPage ──
    signup_pwError: 'パスワードは6文字以上必要です',
    signup_error: '新規登録に失敗しました',
    signup_heading: '新規登録',
    signup_subtitle: '登録すると見積書作成、相談履歴の保存、お問い合わせが便利になります',
    signup_name: '氏名 *',
    signup_namePlaceholder: '山田太郎',
    signup_email: 'メールアドレス *',
    signup_password: 'パスワード *',
    signup_pwPlaceholder: '6文字以上',
    signup_company: '会社名',
    signup_companyPlaceholder: '（任意）会社・団体名',
    signup_phone: '電話番号',
    signup_phonePlaceholder: '（任意）090-1234-5678',
    signup_submitting: '登録中…',
    signup_emailSignup: 'メールで登録',
    signup_hasAccount: 'すでにアカウントをお持ちですか？',
    signup_login: 'ログイン',

    // ── CartPage ──
    cart_product: '製品',
    cart_heading: 'カート',
    cart_loginRequired: 'ログイン後にご利用いただけます',
    cart_loginBtn: 'ログイン',
    cart_empty: 'カートは空です',
    cart_emptySub: '気になる商品を追加してみましょう',
    cart_browse: '製品を見る',
    cart_sktec: '自社モール',
    cart_rental: 'レンタル',
    cart_copier: '複合機',
    cart_toner: 'トナー',
    cart_won: 'ウォン',
    cart_remove: '削除',
    cart_orderSummary: '注文概要',
    cart_itemCount: '商品数',
    cart_count: '個',
    cart_totalQty: '合計数量',
    cart_estimatedTotal: '見積金額',
    cart_checkout: '注文する',
    cart_inquiryBtn: '見積もりを依頼',
    cart_phoneNote: 'お電話でのご相談：OA機器専門 一光オフィス',

    // ── WishlistPage ──
    wish_product: '製品',
    wish_heading: 'お気に入り',
    wish_loginRequired: 'ログイン後にご利用いただけます',
    wish_loginBtn: 'ログイン',
    wish_empty: 'お気に入りリストは空です',
    wish_emptySub: '気に入った商品の♥ボタンを押してみてください',
    wish_browse: '製品を見る',
    wish_sktec: '自社モール',
    wish_rental: 'レンタル',
    wish_copier: '複合機',
    wish_toner: 'トナー',
    wish_won: 'ウォン',
    wish_added: '保存済',
    wish_addToCart: 'カートに入れる',

    // ── ComparePage ──
    compare_product: '製品',
    compare_specType: 'タイプ',
    compare_specPrice: '価格',
    compare_specBrand: 'ブランド',
    compare_specColor: 'カラー／モノクロ',
    compare_specSpeed: '印刷速度',
    compare_specVolume: '月間出力量',
    compare_specPaper: '用紙サイズ',
    compare_specDuplex: '両面印刷',
    compare_specScan: 'スキャン',
    compare_specFax: 'ファクス',
    compare_specNetwork: 'ネットワーク',
    compare_specDesc: '説明',
    compare_sktec: '自社モール',
    compare_rental: 'レンタル',
    compare_copier: '複合機',
    compare_toner: 'トナー',
    compare_won: 'ウォン',
    compare_addProduct: '製品を追加',
    compare_searchPlaceholder: '製品名・ブランドで検索…',
    compare_noSearchResults: '検索結果がありません',
    compare_loginRequired: 'ログインが必要です',
    compare_addedToCart: 'カートに追加しました',
    compare_addedToWishlist: 'お気に入りに追加',
    compare_removedFromWishlist: 'お気に入りから削除',
    compare_heading: '製品比較',
    compare_subtitle: '製品のスペックを一目で比較できます。',
    compare_comparing: '個の製品を比較中',
    compare_clearAll: 'すべてクリア',
    compare_priceInquiry: '価格お問い合わせ',
    compare_cart: 'カート',
    compare_detail: '詳細を見る',
    compare_emptyTitle: '比較する製品を選択してください',
    compare_emptyDesc: '上の「製品を追加」ボタンをクリックするか、製品一覧の比較ボタンを押してください。',
    compare_browseProd: '製品を見る',

    // ── CheckoutPage ──
    checkout_product: '製品',
    checkout_heading: 'ご注文',
    checkout_loginRequired: 'ログインが必要です',
    checkout_loginBtn: 'ログイン',
    checkout_emptyCart: 'カートは空です',
    checkout_browse: '製品を見る',
    checkout_validation: '受取人、電話番号、配送先を入力してください。',
    checkout_error: '注文処理中にエラーが発生しました。',
    checkout_delivery: '配送情報',
    checkout_recipient: '受取人 *',
    checkout_recipientPh: 'お名前',
    checkout_phone: '電話番号 *',
    checkout_company: '会社名',
    checkout_companyPh: '会社名（任意）',
    checkout_zip: '郵便番号',
    checkout_address: '配送先 *',
    checkout_addressPh: '住所',
    checkout_detailAddr: '詳細住所',
    checkout_detailAddrPh: '建物名・部屋番号',
    checkout_memo: '配送メモ',
    checkout_memoPh: '配送時のご要望（任意）',
    checkout_payMethod: 'お支払い方法',
    checkout_bankTransfer: '銀行振込',
    checkout_bankInfo: 'ウリ銀行 1005-xxx-xxxxxx',
    checkout_cardPay: 'カード決済',
    checkout_cardDesc: 'お電話でのご相談後に手続き',
    checkout_postPay: '後払い',
    checkout_postPayDesc: '納品後に請求書を発行',
    checkout_orderItems: '注文商品',
    checkout_qty: '数量：',
    checkout_won: 'ウォン',
    checkout_itemCount: '商品数',
    checkout_count: '個',
    checkout_shipping: '送料',
    checkout_free: '無料',
    checkout_total: '合計金額',
    checkout_quoteGuide: 'お見積り後にご案内',
    checkout_processing: '注文処理中…',
    checkout_placeOrder: '注文を確定する',
    checkout_backToCart: '← カートに戻る',

    // ── OrderConfirmPage ──
    order_seoTitle: '注文完了',
    order_notFound: '注文情報が見つかりません',
    order_browse: '製品を見る',
    order_success: 'ご注文が完了しました',
    order_successSub: '担当者が確認後ご連絡いたします',
    order_orderNo: '注文番号',
    order_amount: 'お支払い金額',
    order_won: 'ウォン',
    order_guideTitle: '注文の流れ',
    order_step1: '注文受付',
    order_step1Desc: 'ご注文を正常に受け付けました',
    order_step2: '注文確認',
    order_step2Desc: '担当者がご注文を確認します',
    order_step3: '商品準備',
    order_step3Desc: '商品を準備・検品します',
    order_step4: '配送／設置',
    order_step4Desc: '配送または設置日程を調整いたします',
    order_viewHistory: '注文履歴を確認',
    order_continueShopping: 'お買い物を続ける',

    // ── SitemapPage ──
    sitemap_seoTitle: 'サイトマップ – 一光オフィス | 全国複合機レンタル',
    sitemap_seoDesc: '一光オフィスのサイトマップ。地域別複合機レンタル、製品ショップ、見積もりお問い合わせなど、すべてのページをご覧いただけます。',
    sitemap_heading: 'サイトマップ',
    sitemap_subtitle: '一光オフィスの全ページを一覧でご確認ください',
    sitemap_shopping: 'ショッピング',
    sitemap_allProducts: '全製品',
    sitemap_productSearch: '製品検索',
    sitemap_cartLink: 'カート',
    sitemap_wishlistLink: 'お気に入り',
    sitemap_compareLink: '比較する',
    sitemap_rentalSection: 'レンタル',
    sitemap_nationalRental: '全国レンタル',
    sitemap_rentalConsult: 'レンタル相談',
    sitemap_support: 'サポート',
    sitemap_quoteInquiry: '見積もりお問い合わせ',
    sitemap_phoneConsult: '電話相談 1600-7542',
    sitemap_account: 'アカウント',
    sitemap_loginLink: 'ログイン',
    sitemap_signupLink: '新規登録',
    sitemap_mypage: 'マイページ',
    sitemap_regionalTitle: '全国地域別レンタル',
    sitemap_regionalDesc: '全国{count}地域で複合機レンタルサービスを提供しています',
    sitemap_districtCount: '地域',
    sitemap_viewAll: 'すべて表示 →',
    sitemap_ctaTitle: 'お探しのページが見つかりませんか？',
    sitemap_ctaSub: '専門スタッフにお問い合わせください',
    sitemap_ctaBtn: 'お問い合わせ',

    // ── ProductCard ──
    card_wishlist: 'お気に入り',
    card_cart: 'カート',
    card_compare: '比較',
    card_black: 'ブラック',
    card_cyan: 'シアン',
    card_magenta: 'マゼンタ',
    card_yellow: 'イエロー',
    card_set: 'セット',
    card_genuine: '純正',
    card_compatible: '互換',
    card_remanufactured: 'リサイクル',
    card_yield: '印刷可能枚数',
    card_pages: '枚',
    card_won: 'ウォン',
    card_purchase: '購入',
    card_color: 'カラー',
    card_mono: 'モノクロ',
    card_detail: '詳細を見る',
    card_rentalBtn: 'レンタル',

    // ── AiChat ──
    ai_errorMsg: '申し訳ございません、エラーが発生しました。もう一度お試しください。\n\n直接お問い合わせ：一光オフィス 1600-7542',
    ai_q1: '10名のオフィスに適したカラー複合機を推薦してください',
    ai_q2: 'レンタルと購入を比較してください',
    ai_q3: '経済的なモノクロ複合機は？',
    ai_q4: '互換トナーの価格を教えてください',
    ai_header: 'AIアシスタント',
    ai_subtitle: '複合機・プリンター・トナーについて何でもお聞きください',
    ai_emptyTitle: '何をお手伝いしましょうか？',
    ai_emptyDesc: 'オフィス環境に合った複合機の推薦、トナー互換検索、価格比較など',
    ai_recCopier: 'おすすめ複合機',
    ai_recToner: 'おすすめトナー',
    ai_inputPlaceholder: 'メッセージを入力…',

    // ── InlineAiChat ──
    inlineAi_error: '申し訳ございません、エラーが発生しました。もう一度お試しください。',
    inlineAi_q1: 'この製品のレンタル条件を知りたいです',
    inlineAi_q2: '同価格帯の他のモデルを推薦',
    inlineAi_q3: '互換トナーの価格を教えてください',
    inlineAi_q4: '10名オフィス向けカラー複合機のおすすめ',
    inlineAi_q5: 'レンタル vs 購入の比較',
    inlineAi_q6: '経済的なモノクロ複合機',
    inlineAi_emptyText: '何でもお聞きください',
    inlineAi_placeholder: 'メッセージを入力…',
    inlineAi_product: '商品',

    // ── InlineInquiryForm ──
    inqForm_rental: 'レンタル',
    inqForm_rentalMsg: 'レンタルについてお問い合わせです。',
    inqForm_error: 'お問い合わせの送信中にエラーが発生しました。もう一度お試しください。',
    inqForm_successTitle: 'お問い合わせを受け付けました',
    inqForm_successDesc: '早急にご連絡いたします。',
    inqForm_name: '氏名 *',
    inqForm_company: '会社名',
    inqForm_phone: '電話番号 *',
    inqForm_email: 'メールアドレス',
    inqForm_inquiryType: 'お問い合わせ種類',
    inqForm_purchase: '購入',
    inqForm_tonerSupplies: 'トナー・消耗品',
    inqForm_maintenance: 'メンテナンス',
    inqForm_other: 'その他',
    inqForm_content: 'お問い合わせ内容',
    inqForm_submitting: '送信中…',
    inqForm_submitBtn: 'お問い合わせを送信',
    inqForm_monthly: '月',
    inqForm_won: 'ウォン',

    // ── Footer ──
    footer_desc1: '複合機・プリンター・トナー消耗品の専門店',
    footer_desc2: 'レンタル · 販売 · メンテナンス',
    footer_hours: '平日 10:00〜18:00',
    footer_lunch: '昼休み 12:00〜13:00',
    footer_holidays: '土日・祝日は休業',
    footer_quickLinks: 'クイックリンク',
    footer_rentalLink: 'レンタルお問い合わせ',
    footer_mallLink: '販売製品',
    footer_servicesTitle: 'サービス',
    footer_svcAi: 'AI複合機おすすめ',
    footer_svcSearch: 'トナー互換検索',
    footer_svcCompare: '純正・互換 価格比較',
    footer_svcConsult: 'レンタル見積もり相談',

    // ── Common ──
    common_won: 'ウォン',
    common_count: '個',
    common_monthly: '月',
    common_pages: '枚',
    common_rental: 'レンタル',
    common_sale: '販売',
    common_copier: '複合機',
    common_toner: 'トナー',
    common_sktec: '自社モール',
    common_priceInquiry: '価格お問い合わせ',
    common_color: 'カラー',
    common_mono: 'モノクロ',
    common_supported: '対応',
    common_notSupported: '非対応',
    common_goTo: '詳細 >',

    // ── ProductDetailPage ──
    detail_reviewError: 'レビューの登録に失敗しました',
    detail_loading: '読み込み中...',
    detail_notFound: '商品が見つかりません。',
    detail_backToStore: '← ストアに戻る',
    detail_copier: '複合機',
    detail_rental: 'レンタル',
    detail_priceInquiry: '価格お問い合わせ',
    detail_ilkwangOffice: '一光オフィス',
    detail_sktec: '自社モール',
    detail_sale: '販売',
    detail_seoul: 'ソウル',
    detail_overview: '概要',
    detail_specs: '仕様',
    detail_reviews: 'レビュー',
    detail_store: 'ストア',
    detail_freeDelivery: '全国配送',
    detail_expertConsult: '専門相談',
    detail_genuineWarranty: '正規品保証',
    detail_monthlyRental: '月額レンタル料',
    detail_wonMonth: 'ウォン/月',
    detail_salePrice: '販売価格',
    detail_price: '価格',
    detail_won: 'ウォン',
    detail_category: 'カテゴリ：',
    detail_contract: '契約期間：',
    detail_brand: 'ブランド',
    detail_model: 'モデル名',
    detail_categorySpec: 'カテゴリ',
    detail_bwSpeed: '白黒速度',
    detail_colorSpeed: 'カラー速度',
    detail_paperSize: '用紙サイズ',
    detail_fax: 'ファックス',
    detail_supported: '対応',
    detail_notSupported: '非対応',
    detail_duplex: '両面印刷',
    detail_monthlyVolume: '月間推奨出力量',
    detail_contractPeriod: '契約期間',
    detail_addedToCart: '✓ カートに追加済み',
    detail_addToCart: 'カートに入れる',
    detail_loginToCart: 'ログインしてカートに入れる',
    detail_rentalInquiry: 'レンタル相談お問い合わせ',
    detail_addedToWishlist: 'お気に入りに追加済み',
    detail_addToWishlist: 'お気に入りに追加',
    detail_aiConsult: 'AI相談する',
    detail_phoneConsult: '電話相談 1600-7542',
    detail_helpText: '製品購入に必要なサポートを受けましょう。',
    detail_chatNow: '今すぐチャット',
    detail_orCall: 'または1600-7542までお問い合わせください。',
    detail_tabDetail: '商品詳細情報',
    detail_tabDelivery: '配送案内',
    detail_tabReturn: '交換・返品案内',
    detail_tabReview: '商品レビュー',
    detail_noDetail: '商品詳細情報がありません。',
    detail_productImages: '商品画像',
    detail_deliveryGuide: '配送案内',
    detail_deliveryMethod: '配送方法：宅配便 / 直接配送（大型複合機の場合）',
    detail_deliveryArea: '配送地域：全国（離島を除く）',
    detail_deliveryTime: '配送所要：宅配便2〜3日 / 大型機器の設置配送は別途協議',
    detail_deliveryFee: '送料：無料（一部離島地域は追加費用が発生する場合があります）',
    detail_deliveryInquiry: '配送に関するお問い合わせ：',
    detail_returnGuide: '交換・返品案内',
    detail_returnPeriod: '交換/返品期間',
    detail_returnPeriodDesc: '商品受領後7日以内に交換/返品申請可能',
    detail_returnExclude: '交換/返品不可事由',
    detail_returnExclude1: 'お客様の事由による梱包損傷または商品損傷',
    detail_returnExclude2: '使用済みのトナーまたは消耗品',
    detail_returnExclude3: '受注生産商品',
    detail_returnExclude4: '受領後7日超過',
    detail_returnCost: '交換/返品費用',
    detail_returnCostDesc: '不良・誤配送の場合は無料、お客様都合の場合は往復送料負担',
    detail_returnInquiry: '交換/返品お問い合わせ：',
    detail_reviewCount: '件のレビュー',
    detail_noReviews: 'まだレビューがありません。',
    detail_reviewer: '購入者',
    detail_writeReview: 'レビューを書く',
    detail_rating: '評価',
    detail_reviewTitlePh: 'レビュータイトル（任意）',
    detail_reviewContentPh: '製品の使用感をお聞かせください...',
    detail_submittingReview: '登録中...',
    detail_submitReview: 'レビュー登録',
    detail_ctaTitle: '導入をお考えですか？',
    detail_ctaDesc: '一光オフィスの専門家と最適なソリューションを設計しましょう。',
    detail_ctaBtn: '専門家に相談',
    detail_aiConsultPanel: 'AI相談',
    detail_rentalPanel: 'レンタル相談お問い合わせ',

    // ── CopierDetailPage ──
    copier_loading: '読み込み中...',
    copier_notFound: '製品が見つかりません',
    copier_backToList: '← 製品一覧に戻る',
    copier_seoSuffix: '複合機詳細情報 - 一光オフィス',
    copier_seoDesc: '複合機の詳細情報。仕様、価格、レンタル条件、互換トナー情報。一光オフィスで複合機を比較。',
    copier_catalog: '製品カタログ',
    copier_color: 'カラー',
    copier_mono: 'モノクロ',
    copier_speed: '出力速度',
    copier_paperSize: '用紙サイズ',
    copier_monthlyVolume: '月間推奨出力量',
    copier_priceRange: '価格帯',
    copier_addedToCart: '✓ 追加済み',
    copier_cart: 'カート',
    copier_wishlistOn: '♥ お気に入り',
    copier_wishlistOff: '♡ お気に入り',
    copier_compare: '⚖️ 比較',
    copier_buyAtMall: '自社モールで購入',
    copier_rentalInquiry: '📞 レンタルお問い合わせ',
    copier_askAi: '🤖 AIに質問する',
    copier_compatToner: '🔵 互換トナー / 消耗品',
    copier_tonerCount: '種',
    copier_priceCompare: '💰 純正 vs 互換 価格比較',
    copier_thToner: 'トナー',
    copier_thColor: '色',
    copier_thGenuine: '純正価格',
    copier_thCompatible: '互換価格',
    copier_thSaving: '節約',
    copier_thYield: '収率',
    copier_black: 'ブラック',
    copier_cyan: 'シアン',
    copier_magenta: 'マゼンタ',
    copier_yellow: 'イエロー',
    copier_set: 'セット',
    copier_won: 'ウォン',
    copier_pages: '枚',
    copier_noToner: '互換トナー情報が登録されていません。一光オフィス（1600-7542）にお問い合わせください。',
    copier_aiPanel: 'AI相談',
    // ── RegionalRentalPage ──
    rental_locationTitle: '位置情報に基づくおすすめ',
    rental_locationDesc: '現在位置を共有すると、お近くの複合機レンタルサービスをおすすめします。',
    rental_later: '後で',
    rental_allowLocation: '位置情報を許可',
    rental_myLocation: '現在地',
    rental_all: 'すべて',
    rental_copierRental: '複合機レンタル',
    rental_regionCopierRental: '地域複合機レンタル',
    rental_nationwideCopierRental: '全国地域別複合機レンタル',
    rental_districtDesc: '地域の複合機・プリンターレンタル。無料設置・定期点検・トナーサポート。',
    rental_regionDesc: '全地域の複合機レンタルサービス。区/郡を選択してください。',
    rental_nationwideDesc: '全国どこでも複合機レンタル。都道府県を選択して始めましょう。',
    rental_nationwide: '全国',
    rental_districts: '地域',
    rental_products: '製品',
    rental_selectRegion: '地域選択',
    rental_findByLocation: '現在地で検索',
    rental_searchPlaceholder: '複合機検索...',
    rental_region: '地域',
    rental_filterAll: 'すべて',
    rental_filterColor: 'カラー',
    rental_filterMono: 'モノクロ',
    rental_brandAll: 'ブランド全体',
    rental_categoryAll: '用途全体',
    rental_sortDefault: '並べ替え: デフォルト',
    rental_sortPriceAsc: '価格が低い順',
    rental_sortPriceDesc: '価格が高い順',
    rental_sortName: '名前順',
    rental_reset: 'リセット',
    rental_rentalProducts: 'レンタル製品',
    rental_count: '件',
    rental_quoteInquiry: '見積もりお問い合わせ',
    rental_noProductsYet: 'この地域にはまだ製品が登録されていません',
    rental_selectDistrict: '区/郡を選択してください',
    rental_requestQuoteDesc: 'でお探しの複合機がございましたら、お見積もりをご依頼ください。専門スタッフが最適なレンタルプランをご案内いたします。',
    rental_selectRegionHint: '左側で地域を選択すると、該当地域のレンタル製品が表示されます。',
    rental_requestQuote: '見積もりを依頼する',
    rental_freeInstall: '無料設置',
    rental_freeInstallDesc: '全国どこでも無料配送・設置',
    rental_regularCheck: '定期点検',
    rental_regularCheckDesc: '月1回無償点検サービス',
    rental_freeToner: 'トナー無償',
    rental_freeTonerDesc: '消耗品無償配送サポート',
    rental_badge_rental: 'レンタル',
    rental_badge_both: '販売+レンタル',
    rental_monthly: '月',
    rental_won: '円',
    rental_priceInquiry: '価格をお問い合わせ',
    rental_detail: '詳細 →',
    rental_copierConsult: '複合機レンタル相談',
    rental_ctaDesc: 'ご希望の製品のお見積もりをすぐにご依頼ください。無料設置・定期点検・トナー無償サポート。',
    rental_freeQuoteRequest: '無料見積もり依頼',
    // ── CustomerERPPage ──
    erp_home: 'ホーム',
    erp_aiConsult: 'AI相談',
    erp_usageAnalysis: '使用量分析',
    erp_quoteManage: '見積管理',
    erp_inquiryManage: 'お問い合わせ管理',
    erp_cart: 'カート',
    erp_wishlist: 'お気に入り',
    erp_orderHistory: '注文履歴',
    erp_purchaseManage: '購入管理',
    erp_chatHistory: '相談履歴',
    erp_myInfo: 'マイ情報',
    erp_reviewLounge: 'レビューラウンジ',
    erp_tripManage: '出張管理',
    erp_tripDesc: '出張ルートを計画し、出発・経由・到着地を管理します',
    erp_statusDraft: '下書き',
    erp_statusSubmitted: '提出済み',
    erp_statusReviewed: '確認中',
    erp_statusSent: '送信済み',
    erp_typeRental: 'レンタル',
    erp_typePurchase: '購入',
    erp_typeToner: 'トナー',
    erp_typeEtc: 'その他',
    erp_aiConsultDesc: 'AIに何でも聞いてください',
    erp_usageDesc: 'レポート撮影 → AI自動認識',
    erp_quickInquiry: 'クイックお問い合わせ',
    erp_quickInquiryDesc: '1分で完了',
    erp_writeQuote: '見積書作成',
    erp_writeQuoteDesc: 'カスタム見積もり',
    erp_bulkPurchase: '大量購入',
    erp_bulkPurchaseDesc: '法人購買担当者向け',
    erp_nationalRental: '全国レンタル',
    erp_nationalRentalDesc: '地域レンタル検索',
    erp_compare: '製品比較',
    erp_compareDesc: '複合機比較分析',
    erp_productSearch: '製品検索',
    erp_productSearchDesc: 'AIカスタム推薦',
    erp_wishlistDesc: '保存した製品を見る',
    erp_sitemap: 'サイトマップ',
    erp_sitemapDesc: '全メニュー一覧',
    erp_allProducts: '全製品',
    erp_aiSearch: 'AI検索',
    erp_myPage: 'のマイページ',
    erp_seoDesc: '一光オフィス顧客専用ERP – 見積、お問い合わせ、AI相談、購入管理',
    erp_hello: 'こんにちは',
    erp_honorific: 'さん',
    erp_goHome: 'ホームへ',
    erp_logout: 'ログアウト',
    erp_siteShortcuts: 'サイトショートカット',
    erp_more: 'もっと見る',
    erp_quotes: '見積書',
    erp_inquiryHistory: 'お問い合わせ履歴',
    erp_shortcuts: 'クイックアクセス',
    erp_recentQuotes: '最近の見積書',
    erp_viewAll: 'すべて見る →',
    erp_recentInquiries: '最近のお問い合わせ',
    erp_tipText: '💡 ご存知ですか？',
    erp_tipDesc: 'AI相談で最適な複合機を推薦してもらい、見積書もすぐに作成できます。',
    erp_tipBtnAi: 'AI相談を始める',
    erp_aiDesc: 'AIアシスタントが最適な複合機とトナーを推薦します',
    erp_newChat: '新しい会話',
    erp_prevChats: '以前の相談',
    erp_aiAsk: 'AIアシスタントに聞く',
    erp_aiHint: '複合機推薦、トナー互換性、価格比較など何でもお聞きください。',
    erp_suggestOffice: 'オフィスに合う複合機を推薦してください',
    erp_suggestCompare: 'カラー複合機を比較してください',
    erp_suggestToner: '互換トナーを教えてください',
    erp_suggestSmall: '小規模オフィスに適した製品は？',
    erp_recCopier: 'おすすめ複合機',
    erp_recToner: 'おすすめトナー',
    erp_msgPlaceholder: 'メッセージを入力...',
    erp_chatError: '申し訳ございません、エラーが発生しました。もう一度お試しください。',
    erp_quoteManageDesc: '見積書を作成・管理します',
    erp_newQuote: '新規見積書',
    erp_noQuotes: 'まだ見積書がありません',
    erp_noQuotesHint: '新しい見積書を作成してみましょう',
    erp_createQuote: '見積書を作成',
    erp_submit: '提出',
    erp_delete: '削除',
    erp_adminNote: '管理者メモ:',
    erp_items: '項目',
    erp_backToQuotes: '← 見積一覧',
    erp_newQuoteTitle: '新規見積書作成',
    erp_quoteTitle: '見積書タイトル',
    erp_companyName: '会社/機関名',
    erp_addItem: '項目追加',
    erp_productModel: '製品名/モデル名',
    erp_quantity: '数量',
    erp_addMore: '+ 追加',
    erp_productNameCol: '製品名',
    erp_typeCol: '種類',
    erp_additionalNotes: '追加リクエスト（任意）',
    erp_saveQuote: '見積書を保存',
    erp_inquiryManageDesc: 'お問い合わせを送信し回答を確認',
    erp_autoFillInfo: '情報が自動入力されます',
    erp_rentalInquiry: 'レンタルお問い合わせ',
    erp_purchaseInquiry: '購入お問い合わせ',
    erp_tonerInquiry: 'トナーお問い合わせ',
    erp_etcInquiry: 'その他お問い合わせ',
    erp_sendInquiry: 'お問い合わせを送信',
    erp_noInquiries: 'まだお問い合わせがありません',
    erp_adminReply: '管理者回答',
    erp_inquiryPlaceholder: 'お問い合わせ内容を入力...',
    erp_answered: '回答済み',
    erp_processing: '処理中',
    erp_received: '受付',
    erp_emptyCart: 'カートが空です',
    erp_emptyCartHint: '気に入った製品をカートに追加しましょう',
    erp_browseProducts: '製品を見る →',
    erp_copier: '複合機',
    erp_toner: 'トナー',
    erp_inHouse: '社内',
    erp_requestQuoteInquiry: '見積もりお問い合わせ',
    erp_goToCart: 'カートページへ →',
    erp_product: '製品',
    erp_won: '円',
    erp_cartInquiry: 'クイックお問い合わせ',
    erp_saved: 'お気に入りに保存済み',
    erp_emptyWishlist: 'お気に入りが空です',
    erp_emptyWishlistHint: '製品のハートアイコンをタップして保存',
    erp_viewDetail: '詳細を見る',
    erp_copierAnalysis: '複合機使用量分析',
    erp_copierAnalysisDesc: 'AIが複合機レポートを自動分析します',
    erp_uploadReport: 'レポートをアップロード',
    erp_uploadReportDesc: '複合機レポートの写真をアップロード',
    erp_clientName: '顧客名',
    erp_clientExample: '例：一光オフィス',
    erp_selectOtherFile: '別のファイルを選択',
    erp_startAnalysis: '分析開始',
    erp_aiAnalyzing: 'AI分析中...',
    erp_analysisResult: '分析結果',
    erp_close: '閉じる',
    erp_modelName: 'モデル名',
    erp_reportDate: 'レポート日付',
    erp_totalPages: '総出力枚数',
    erp_color: 'カラー',
    erp_bw: 'モノクロ',
    erp_scan: 'スキャン',
    erp_fax: 'ファックス',
    erp_copy: 'コピー',
    erp_printPages: '印刷',
    erp_tonerRemaining: 'トナー残量',
    erp_usageByUser: 'ユーザー別使用量',
    erp_user: 'ユーザー',
    erp_total: '合計',
    erp_extraInfo: '追加情報',
    erp_analysisHistory: '分析履歴',
    erp_countUnit: '件',
    erp_noReports: 'まだ分析履歴がありません',
    erp_unknownModel: '不明',
    erp_client: '顧客',
    erp_totalPrefix: '合計',
    erp_sheets: '枚',
    erp_orderHistoryDesc: '注文履歴を確認',
    erp_noOrders: '注文履歴がありません',
    erp_noOrdersHint: '注文するとここに表示されます',
    erp_orderPending: '注文受付',
    erp_orderConfirmed: '確認済み',
    erp_orderProcessing: '処理中',
    erp_orderShipping: '配送中',
    erp_orderDelivered: '配送完了',
    erp_orderCancelled: 'キャンセル',
    erp_orderRefunded: '返金',
    erp_qtyLabel: '数量',
    erp_cancelOrder: '注文キャンセル',
    erp_purchaseManageDesc: '大量購入とレンタルのお問い合わせを管理',
    erp_bulkInquiry: '大量購入/レンタルお問い合わせ',
    erp_bulkInquiryDesc: '必要な機器情報を入力してください',
    erp_equipment: '機器',
    erp_productReq: '製品名/仕様',
    erp_productReqExample: '例：カラー複合機A3',
    erp_installLocation: '設置場所',
    erp_installExample: '例：東京都港区',
    erp_addEquipment: '+ 機器追加',
    erp_sendBulkInquiry: '大量お問い合わせを送信',
    erp_corporateGuide: '法人購入ガイド',
    erp_corpFeat1Title: '専門相談',
    erp_corpFeat1Desc: '企業規模に合わせたカスタム相談',
    erp_corpFeat2Title: '大量割引',
    erp_corpFeat2Desc: '10台以上特別割引適用',
    erp_corpFeat3Title: '統合管理',
    erp_corpFeat3Desc: '全社機器統合管理サービス',
    erp_corpFeat4Title: '優先A/S',
    erp_corpFeat4Desc: '法人顧客優先技術サポート',
    erp_corpFeat5Title: '定期レポート',
    erp_corpFeat5Desc: '月間使用量レポート提供',
    erp_dedicatedConsult: '専任コンサルタント配置',
    erp_dedicatedConsultDesc: '法人顧客に専任コンサルタントが配置されます',
    erp_makeInquiry: 'お問い合わせ',
    erp_individualBuyer: '個人購入者',
    erp_aiRec: 'AIおすすめ',
    erp_rentalQuote: 'レンタル見積もり',
    erp_clickToSelect: 'クリックして選択',
    erp_aiChatHistory: 'AI相談履歴',
    erp_aiChatHistoryDesc: '以前のAI相談履歴を確認',
    erp_noChatHistory: 'まだAI相談履歴がありません',
    erp_startAiChat: 'AI相談を始める',
    erp_messagesCount: '件のメッセージ',
    erp_editProfileDesc: 'プロフィール情報を編集',
    erp_name: '名前',
    erp_company: '会社/機関',
    erp_phone: '連絡先',
    erp_email: 'メール',
    erp_editProfile: 'プロフィール編集',
    erp_accountInfo: 'アカウント情報',
    erp_accountType: 'アカウントタイプ',
    erp_local: '一般',
    erp_accountLabel: 'アカウント',
    erp_loginLabel: 'ログイン',
    erp_role: '役割',
    erp_roleAdmin: '管理者',
    erp_roleMember: '一般会員',
    erp_deleteAccount: 'アカウント削除',
    erp_deleteAccountDesc: 'アカウントを削除すると全データが永久削除されます。',
    erp_deleteAccountRequest: 'アカウント削除リクエスト',
    erp_deleteAccountConfirm: '本当にアカウントを削除しますか？この操作は取り消せません。',
    erp_deleteNow: '今すぐ削除',
    erp_cancel: 'キャンセル',
    erp_requestDelete: '削除リクエスト',
    erp_deleteAccountAlerted: 'アカウント削除がリクエストされました。管理者が確認後処理します。',
    erp_errorOccurred: 'エラーが発生しました',
    erp_myReviewLounge: 'マイレビューラウンジ',
    erp_communityDesc: 'コミュニティ活動を確認',
    erp_myTonerPoints: 'マイトナーポイント',
    erp_myBadge: 'マイバッジ',
    erp_goToReviewLounge: 'レビューラウンジへ →',
    erp_myPosts: 'マイ投稿',
    erp_myComments: 'マイコメント',
    erp_pointHistory: 'ポイント履歴',
    erp_noMyPosts: 'まだ投稿がありません',
    erp_noMyComments: 'まだコメントがありません',
    erp_totalPoints: '合計ポイント',
    erp_badgeLevel: 'バッジレベル',
    erp_maxDiscount: '最大割引',
    erp_typeLabel: '種類',
    erp_pointLabel: 'ポイント',
    erp_reason: '理由',
    erp_dateTime: '日時',
    erp_noPointHistory: 'まだポイント履歴がありません',
    erp_earn: '獲得',
    erp_spend: '使用',
    erp_rec: '推薦',
    erp_commentsLabel: 'コメント',
    erp_views: '閲覧',
    erp_badgeA4: 'A4ビギナー',
    erp_badgeInkjet: 'インクジェットランナー',
    erp_badgeColorLaser: 'カラーレーザープロ',
    erp_badgeMaster: '複合機マスター',
    livechat_consult: 'ライブ相談',
    livechat_channelSelect: '相談チャンネル選択',
    livechat_chat: 'ライブ相談',
    livechat_hours: '平日 09:00～18:00',
    livechat_howToConsult: 'どの方法で相談しますか？',
    livechat_kakaoChat: 'カカオトーク相談',
    livechat_kakaoDesc: '迅速な対応・写真送信可能',
    livechat_fastResponse: '即答',
    livechat_siteChat: 'サイトリアルタイムチャット',
    livechat_siteChatDesc: 'ログイン後すぐに相談',
    livechat_aiAssistant: 'AIアシスタント',
    livechat_aiAssistantDesc: '24時間AI自動相談',
    livechat_kakaoFastest: 'カカオトークが最も早いです！',
    livechat_customerCenter: 'カスタマーセンター',
    livechat_welcome: '何でもお気軽にどうぞ！',
    livechat_askAnything: '複合機、トナー、レンタルなどご質問をどうぞ',
    livechat_fasterTip: 'より早い相談をご希望なら',
    livechat_kakaoLink: 'カカオトーク相談',
    livechat_fasterTipSuffix: 'をご利用ください！',
    livechat_agent: '担当者',
    livechat_inputPlaceholder: 'メッセージを入力...',
    livechat_chatClosed: '相談が終了しました',
    filter_all: 'すべて',
  },

  ru: {
    // ── HomePage ──
    home_seoTitle:
      'МФУ и копиры: профессиональная печать | Ilkwang Office – аренда · продажа · сравнение цен на тонер',
    home_seoDesc:
      'Ilkwang Office — специалисты по МФУ, копирам и печати. Аренда офисных МФУ от ₩30 000/мес. Продажа цветных и ч/б копиров, сравнение цен на тонер. Сравните МФУ Samsung, Canon, Fuji Xerox, Kyocera и Sindoh с помощью ИИ.',
    home_heroTitle: 'Магазин.',
    home_heroSub: 'Лучший способ выбрать идеальное МФУ для вашего офиса.',
    home_askAi: 'Спросить ИИ',
    home_askAiDesc: 'ИИ подберёт оборудование под ваши задачи.',
    home_callConsult: 'Позвонить',
    home_callConsultDesc: 'Свяжитесь напрямую со специалистом.',
    home_catColor: 'Цветные МФУ',
    home_catMono: 'Ч/Б МФУ',
    home_catPrinter: 'Принтеры',
    home_catToner: 'Тонер и расходники',
    home_catConsult: 'Консультация',
    home_catOwnMall: 'Наш магазин',
    home_catAi: 'ИИ-подбор',
    home_catDigital: 'Цифровой пресс',
    home_catDigitalDesc: 'Высокоскоростная цифровая печать',
    home_catLarge: 'Большие МФУ',
    home_catLargeDesc: 'A3 многофункциональные устройства',
    home_catSmall: 'Малые МФУ',
    home_catSmallDesc: 'A4 настольные МФУ',
    home_catPrinterDesc: 'Лазерные и струйные принтеры',
    home_catTonerDesc: 'Оригинальный, совместимый и восстановленный тонер',
    home_searchTitle: 'Поиск продукции',
    home_searchDesc: 'Поиск по модели, бренду или номеру тонера',
    home_noResults: 'Ничего не найдено',
    home_searchHint2: 'Попробуйте поиск',
    home_newProducts: 'Новинки',
    home_newProductsDesc: 'Ознакомьтесь с новыми поступлениями',
    home_rental: 'Аренда',
    home_monthlyPrice: '₩{price}/мес.~',
    home_priceInquiry: 'Узнать цену',
    home_quickLinks: 'Быстрые ссылки.',
    home_quickLinksDesc: 'Переходите на нужные страницы одним кликом.',
    home_productStore: 'Каталог продукции',
    home_aiRecommend: 'ИИ-подбор',
    home_productCompare: 'Сравнение',
    home_cart: 'Корзина',
    home_wishlist: 'Избранное',
    home_myErp: 'Мой ERP',
    home_nationalRental: 'Аренда по всей стране',
    home_consult: 'Консультация',
    home_sitemapLink: 'Карта сайта',
    home_phoneConsult: 'Телефонная консультация',
    home_consultSection: 'Консультация',
    home_consultDesc:
      'Расчёт аренды, вопросы по продукции и онлайн-поддержка — всё в одном месте.',
    home_rentalQuote: 'Расчёт аренды',
    home_rentalQuoteDesc:
      'Мгновенный расчёт ежемесячной арендной платы с помощью калькулятора.',
    home_getQuote: 'Получить расчёт >',
    home_generalConsult: 'Общая консультация',
    home_generalConsultDesc:
      'Отправьте любой запрос — покупка, тонер, сервис и т.д.',
    home_inquireNow: 'Отправить запрос >',
    home_liveConsult: 'Онлайн-поддержка',
    home_liveConsultDesc:
      'Мгновенная помощь через KakaoTalk, чат или телефон.',
    home_consultNow: 'Начать чат >',
    home_globalInquiry: 'Международные запросы',
    home_rentalMall: 'Аренда по всей стране.',
    home_rentalMallDesc1:
      'Сеул, Пусан, Тэгу, Инчхон, Кванджу, Тэджон, Ульсан, Седжон, Кёнги и другие регионы.',
    home_rentalMallDesc2:
      'Аренда МФУ и принтеров. Бесплатная установка и регулярное обслуживание.',
    home_seoul: 'Сеул',
    home_gwanghwamun: 'Кванхвамун',
    home_busan: 'Пусан',
    home_jagalchi: 'Рынок Чагальчи',
    home_daegu: 'Тэгу',
    home_daeguSub: 'Яблоки и рынок лекарственных трав',
    home_incheon: 'Инчхон',
    home_chinatown: 'Чайнатаун',
    home_gyeonggi: 'Кёнги',
    home_suwon: 'Крепость Хвасон (Сувон)',
    home_gwangju: 'Кванджу',
    home_gwangjuSub: 'Мудынсан и пибимпап',
    home_daejeon: 'Тэджон',
    home_daejeonSub: 'Сонсимдан и хлеб',
    home_jeju: 'Чеджу',
    home_jejuSub: 'Халлабон и мандарины',
    home_viewAllRegions: 'Все 260+ регионов >',
    home_nationalRentalMall: 'Аренда по всей стране',
    home_regionsCount: '260+ регионов',
    home_goTo: 'Перейти >',
    home_aiConsult: 'ИИ-консультация',
    home_productSearch: 'Поиск продукции',
    home_searchPlaceholder:
      'Введите модель МФУ или номер тонера.',
    home_searchBtn: 'Поиск',
    home_searchHint: 'например: "Samsung SL-XA225" или "CLT-K3080S"',
    home_shortcuts: 'Быстрые ссылки',
    home_rentalInquiry: 'Запрос на аренду',
    home_ownMall: 'Наш магазин',
    home_latestProducts: 'Новинки.',
    home_latestProductsDesc: 'Популярные товары в нашем магазине.',
    home_viewAll: 'Смотреть все >',
    home_rentalProducts: 'Арендные продукты.',
    home_rentalProductsDesc:
      'Оптимальные МФУ в аренду.',
    home_myErpSection: 'Мой ERP.',
    home_myErpDesc: 'Персонализированные инструменты управления для вашего офиса.',
    home_erpAi: 'ИИ-консультация',
    home_erpAiDesc:
      'Спросите ИИ что угодно — от рекомендаций МФУ до расчёта стоимости.',
    home_erpUsage: 'Анализ использования',
    home_erpUsageDesc:
      'Сфотографируйте отчёт — ИИ проанализирует его автоматически.',
    home_erpQuote: 'Составить КП',
    home_erpQuoteDesc: 'Запросите и управляйте индивидуальными КП.',
    home_erpInquiry: 'Быстрый запрос',
    home_erpInquiryDesc: 'Отправьте запрос за 1 минуту.',
    home_erpBulk: 'Оптовые закупки',
    home_erpBulkDesc: 'Инструменты для корпоративных закупщиков.',
    home_erpCart: 'Корзина',
    home_erpCartDesc: 'Проверьте товары и оформите заказ.',
    home_services: 'Услуги.',
    home_servicesDesc:
      'Оцените профессиональные услуги Ilkwang Office.',
    home_svcAi: 'ИИ-подбор МФУ',
    home_svcAiDesc:
      'ИИ анализирует ваш офис и рекомендует оптимальное МФУ.',
    home_svcAiCta: 'Начать >',
    home_svcRental: 'Услуга аренды',
    home_svcRentalDesc:
      'Используйте МФУ с выгодной ежемесячной оплатой. Обслуживание включено.',
    home_svcRentalCta: 'Аренда продуктов >',
    home_svcToner: 'Покупка тонера и расходников',
    home_svcTonerDesc:
      'Оригинальный, совместимый и восстановленный тонер по выгодным ценам.',
    home_svcTonerCta: 'Продажа продуктов >',
    home_convenienceServices: 'Дополнительные сервисы.',
    home_convenienceDesc:
      'Все инструменты для управления офисной техникой — в одном месте.',
    home_usageAnalysis: 'Анализ использования',
    home_usageAnalysisDesc:
      'Сфотографируйте отчёт — ИИ автоматически проанализирует расход МФУ.',
    home_analyzeNow: 'Анализировать >',
    home_orderTracking: 'Отслеживание заказов',
    home_orderTrackingDesc:
      'Проверяйте историю заказов и отслеживайте доставку в реальном времени.',
    home_trackNow: 'Отследить >',
    home_quoteManage: 'Управление КП и запросами',
    home_quoteManageDesc:
      'Просматривайте и управляйте всеми вашими КП и запросами.',
    home_checkNow: 'Проверить >',
    home_guideTitle: 'Руководство по МФУ, копирам и печати.',
    home_guideDesc:
      'Узнайте, как выбрать идеальное МФУ для вашего офиса.',
    home_guideQ1: 'Что такое МФУ?',
    home_guideA1:
      'МФУ (многофункциональное устройство) объединяет принтер, копир, сканер и факс в одном аппарате. В отличие от обычного копира, МФУ выполняет печать, сканирование и факс в одном устройстве, максимально эффективно используя офисное пространство. Современные МФУ поддерживают облачную интеграцию, мобильную печать и автоматическую двустороннюю печать.',
    home_guideQ2: 'Копир и МФУ: в чём разница',
    home_guideA2:
      'Копир предназначен только для копирования документов, а МФУ — это универсальное устройство, совмещающее печать, копирование, сканирование и факс. Сегодня МФУ является стандартом рынка. Когда говорят «копир», обычно имеют в виду МФУ. МФУ также выгоднее по стоимости.',
    home_guideQ3: 'Как сократить расходы на печать',
    home_guideA3:
      'Основные стратегии: ① Перейти на аренду (↓ начальные затраты), ② Анализ расхода (автоматические IT-отчёты), ③ Совместимый/восстановленный тонер (экономия 30–60%), ④ Двусторонняя печать по умолчанию. Оптимизируйте расходы с ИИ-анализом и арендой от Ilkwang Office.',
    home_guideQ4: 'Аренда МФУ vs покупка',
    home_guideA4:
      'Аренда — низкие начальные затраты, обслуживание и тонер включены. Покупка экономичнее в долгосрочной перспективе, но требует отдельных расходов на ремонт и расходники. Для парка от 5 единиц выгодна аренда, для малого объёма — покупка.',
    home_guideQ5:
      'Оригинальный тонер vs совместимый тонер vs восстановленный тонер',
    home_tonerCompareTitle: 'Сравнение типов тонера',
    home_tonerCompare: 'Категория',
    home_tonerGenuine: 'Оригинальный тонер',
    home_tonerCompatible: 'Совместимый тонер',
    home_tonerRemanufactured: 'Восстановленный тонер',
    home_tonerPrice: 'Цена',
    home_tonerPriceGenuine: 'Высокая (базовая)',
    home_tonerPriceCompatible: '30–50% от оригинала',
    home_tonerPriceReman: '20–40% от оригинала',
    home_tonerQuality: 'Качество',
    home_tonerQualityGenuine: 'Отличное',
    home_tonerQualityCompatible: 'Очень хорошее',
    home_tonerQualityReman: 'Среднее — хорошее',
    home_tonerWarranty: 'Гарантия',
    home_tonerWarrantyGenuine: 'Гарантия производителя',
    home_tonerWarrantyCompatible: 'Гарантия продавца',
    home_tonerWarrantyReman: 'Ограниченная',
    home_tonerRecommend: 'Рекомендуется для',
    home_tonerRecommendGenuine: 'Высококачественной печати',
    home_tonerRecommendCompatible: 'Экономии + качества',
    home_tonerRecommendReman: 'Минимальной стоимости',
    home_tonerNote:
      'Ilkwang Office предлагает оригинальный, совместимый и восстановленный тонер для всех основных брендов: Samsung, Canon, Fuji Xerox, Kyocera, Sindoh, HP и Brother.',
    home_brandTitle: 'МФУ и копиры по брендам',
    home_brandSamsung: 'Samsung МФУ',
    home_brandCanon: 'Canon МФУ',
    home_brandFuji: 'Fuji Xerox МФУ',
    home_brandKyocera: 'Kyocera МФУ',
    home_brandSindoh: 'Sindoh МФУ',
    home_brandHp: 'HP МФУ',
    home_brandBrother: 'Brother МФУ',
    home_brandColor: 'Цветные МФУ',
    home_faqTitle: 'Часто задаваемые вопросы',
    home_faqQ1: 'Сколько стоит аренда МФУ?',
    home_faqA1:
      'Аренда МФУ — от ₩30 000 до ₩300 000 в месяц в зависимости от модели и условий. Проверьте мгновенно с помощью нашего калькулятора.',
    home_faqQ2: 'Можно ли арендовать копир?',
    home_faqA2:
      'Да, аренда копиров (МФУ) доступна. Мы предоставляем бесплатную установку и регулярное обслуживание по всей стране для цветных и ч/б МФУ, а также принтеров.',
    home_faqQ3: 'Можете ли вы оптимизировать печатную среду нашего офиса?',
    home_faqA3:
      'Да. С помощью ИИ-анализа расхода и экспертного консалтинга мы оптимизируем печатную среду вашего офиса и предложим индивидуальные решения по снижению затрат.',
    home_faqQ4: 'Какие типы тонера доступны?',
    home_faqA4:
      'Три типа: оригинальный, совместимый и восстановленный тонер. ИИ порекомендует подходящий тонер с учётом ваших задач и бюджета.',
    home_faqQ5: 'Как проходит обслуживание МФУ?',
    home_faqA5:
      'Аренда включает ежемесячный осмотр, бесплатный выезд сервис-инженера и бесплатную замену тонера/барабана. Контракты на обслуживание также доступны для купленных устройств.',

    // ── StorePage ──
    store_seoTitle: 'Магазин | МФУ · Принтеры · Тонер – Ilkwang Office',
    store_seoDesc: 'Цифровые прессы, большие и малые МФУ, принтеры, тонер и расходники — всё в одном месте. Сравнение цен аренды и покупки.',
    store_heroTitle: 'Магазин',
    store_heroSub: 'Найдите нужное МФУ, принтер или тонер.',
    store_searchPlaceholder: 'Поиск по названию, бренду или модели',
    store_loading: 'Загрузка продукции…',
    store_searchResults: 'Результаты поиска',
    store_productUnit: ' товаров',
    store_noResults: 'Ничего не найдено.',
    store_tryOther: 'Попробуйте другой запрос.',
    store_shopByCategory: 'По категориям',
    store_shopByCategorySub: 'Выберите категорию для просмотра.',
    store_viewAll: 'Смотреть все',
    store_noProducts: 'В этой категории нет товаров.',
    store_sortLatest: 'Рекомендуемые',
    store_sortName: 'По имени',
    store_sortPriceAsc: 'Цена: по возрастанию',
    store_sortPriceDesc: 'Цена: по убыванию',
    store_sortRental: 'Аренда: по возрастанию',
    store_saleRental: 'Аренда',
    store_saleBoth: 'Продажа+Аренда',
    store_salePurchase: 'Продажа',
    store_inquiry: 'Запрос',
    store_details: 'Подробнее',
    store_subAll: 'Все',
    store_subToner: 'Тонер',
    store_subDrum: 'Барабан',
    store_subDeveloper: 'Блок проявки',
    store_subFuser: 'Термоблок',
    store_subParts: 'Запчасти',
    store_subPaper: 'Бумага',

    // ── ProductsPage ──
    products_seoTitle:
      'Все МФУ и копиры | Сравнение цен на аренду и покупку – Ilkwang Office',
    products_seoDesc:
      'Сравните все МФУ и копиры Samsung, Canon, Fuji Xerox, Kyocera и Sindoh. Цветные МФУ, ч/б МФУ, принтеры, тонер. Аренда от ₩30 000/мес.',
    products_heading: 'Каталог',
    products_subtitle: 'Нажмите на продукт для просмотра подробностей.',
    products_searchPlaceholder: 'Поиск продукции',
    products_loading: 'Загрузка…',
    products_itemCount: 'шт.',
    products_noResults: 'Ничего не найдено.',
    products_noResultsSub:
      'Попробуйте другую категорию или ключевое слово.',
    products_all: 'Все',
    products_digitalPress: 'Цифровая печатная машина',
    products_largeMFP: 'Большие МФУ',
    products_smallMFP: 'Малые МФУ',
    products_printer: 'Принтеры',
    products_tonerSupplies: 'Тонер и расходники',
    products_colorCopier: 'Цветные МФУ',
    products_monoCopier: 'Ч/Б МФУ',
    products_copierRental: 'Аренда МФУ',
    products_specialEquip: 'Спецоборудование',
    products_copierSales: 'Продажа МФУ',
    products_sktecMall: 'Магазин',
    products_ikofficesRental: 'Аренда',
    products_saleRental: 'Продажа + Аренда',
    products_sale: 'Продажа',
    products_rental: 'Аренда',
    products_monthly: '/мес.',
    products_won: '₩',
    products_wonTilde: '₩~',
    products_priceInquiry: 'Узнать цену',
    products_prev: 'Назад',
    products_next: 'Далее',

    // ── SearchPage ──
    search_seoTitle:
      'ИИ-поиск МФУ | Найти копиры и тонер – Ilkwang Office',
    search_seoDesc:
      'ИИ порекомендует оптимальное МФУ и копир для вашего офиса. Поиск по модели и номеру тонера.',
    search_heading: 'ИИ-поиск',
    search_subtitle:
      'Задайте вопрос ИИ или найдите по модели. Рекомендации ведут напрямую в наш магазин или на сайт аренды.',
    search_aiConsult: 'ИИ-консультация',
    search_productSearch: 'Поиск продукции',
    search_placeholder: 'Модель, бренд, номер тонера…',
    search_searching: 'Поиск…',
    search_searchBtn: 'Поиск',
    search_copiers: 'МФУ',
    search_count: 'рез.',
    search_tonerSupplies: 'Тонер и расходники',
    search_noResults: 'Ничего не найдено',
    search_initialHint:
      'Введите модель МФУ или номер тонера для поиска.',
    search_exampleHint:
      'например: "Samsung SL-X4225" или "CLT-K808S"',
    search_shortcuts: 'Быстрые ссылки',
    search_rentalInquiry: 'Запрос на аренду',
    search_ownMall: 'Наш магазин',

    // ── ConsultationPage ──
    consult_seoTitle:
      'Консультация — расчёт аренды · онлайн-поддержка · международные запросы | Ilkwang Office',
    consult_seoDesc:
      'Расчёт аренды МФУ, принтеров и тонера. KakaoTalk, онлайн-чат и телефонная поддержка. Международные запросы приветствуются.',
    consult_heading: 'Консультация',
    consult_subtitle:
      'Расчёт аренды, вопросы по продукции и онлайн-поддержка — всё в одном месте.',
    consult_tabRental: 'Расчёт аренды',
    consult_tabGeneral: 'Общая консультация',
    consult_tabLive: 'Онлайн-поддержка',
    consult_tabGlobal: 'Международные запросы',
    consult_calcTitle: 'Калькулятор аренды',
    consult_planSelect: 'Выберите тариф',
    consult_monthly: '/мес.',
    consult_won: '₩',
    consult_bwPages: 'Ч/Б {n} стр.',
    consult_colorPages: 'Цвет {n} стр.',
    consult_adjustPages: 'Настроить количество страниц',
    consult_bwCount: 'Ч/Б страницы',
    consult_colorCount: 'Цветные страницы',
    consult_pages: 'стр.',
    consult_default: 'По умолчанию',
    consult_geoNotSupported:
      'Этот браузер не поддерживает геолокацию.',
    consult_geoError: 'Не удалось определить местоположение.',
    consult_uploadError:
      'Ошибка загрузки файла. (Макс. 10 МБ; jpg/png/pdf/doc/hwp)',
    consult_nameRequired: 'Пожалуйста, введите ваше имя.',
    consult_phoneRequired: 'Пожалуйста, введите номер телефона.',
    consult_submitError: 'Не удалось отправить запрос.',
    consult_successTitle: 'Запрос отправлен',
    consult_successDesc: 'Наш специалист свяжется с вами в ближайшее время.',
    consult_quoteSummary: 'Сводка КП',
    consult_monthlyRental: 'Ежемесячная аренда:',
    consult_autoQuoteNote:
      'КП сформировано автоматически. Будет отправлено после проверки менеджером.',
    consult_urgent: 'Срочно?',
    consult_callUs: 'Позвоните нам.',
    consult_nationalRental: 'Аренда по всей стране',
    consult_goHome: 'На главную',
    consult_selectProduct: 'Выберите продукт',
    consult_selectProductPlaceholder: 'Выберите продукт для аренды',
    consult_searchProductPlaceholder: 'Поиск по названию, бренду...',
    consult_inquiryProduct: 'Продукт запроса',
    consult_autoFilled: 'Данные участника заполнены автоматически.',
    consult_name: 'Имя',
    consult_company: 'Компания',
    consult_namePlaceholder: 'Иван Иванов',
    consult_companyPlaceholder: 'ООО «Компания»',
    consult_phone: 'Телефон',
    consult_email: 'Электронная почта',
    consult_installRegion: 'Регион установки',
    consult_locating: 'Определение местоположения…',
    consult_myLocation: 'Моё местоположение',
    consult_additionalRequest: 'Дополнительные пожелания',
    consult_inquiryContent: 'Содержание запроса',
    consult_contentPlaceholder:
      'Опишите ваш запрос.\n(Название продукта, количество, место установки, предпочтения и т.д.)',
    consult_attachment: 'Вложение',
    consult_uploading: 'Загрузка…',
    consult_uploadPrompt:
      'Нажмите, чтобы прикрепить файл (изображение, PDF, документ)',
    consult_remove: 'Удалить',
    consult_estimatedMonthly: 'Ориентир. ежемесячная аренда (с НДС)',
    consult_submitting: 'Отправка…',
    consult_requestQuote: 'Запросить КП',
    consult_sendInquiry: 'Отправить запрос',
    consult_responseNote:
      'Мы свяжемся с вами в течение 1 рабочего дня.',
    consult_contentRequired: 'Пожалуйста, опишите ваш запрос.',
    consult_generalTitle: 'Общая консультация',
    consult_generalDesc:
      'Задайте любой вопрос о МФУ, принтерах, тонере и офисной технике. Наши специалисты с радостью помогут.',
    consult_sampleService: 'Услуга пробной печати',
    consult_sampleDesc:
      'Приложите изображение — мы напечатаем образец на МФУ и отправим вам по почте.',
    consult_inquiryType: 'Тип запроса',
    consult_typePurchase: 'Запрос на покупку',
    consult_typeToner: 'Тонер / расходники',
    consult_typeService: 'Сервис и обслуживание',
    consult_typeOther: 'Прочее',
    consult_generalPlaceholder:
      'Опишите ваш вопрос в свободной форме.',
    consult_liveIntro:
      'Выберите самый быстрый и удобный способ связи.',
    consult_recommended: 'Рекомендуем',
    consult_kakaoTitle: 'Чат KakaoTalk',
    consult_kakaoDesc: 'Самый быстрый ответ',
    consult_kakaoCta: 'Открыть KakaoTalk >',
    consult_liveChatTitle: 'Онлайн-чат',
    consult_liveChatDescLogin: 'Пообщайтесь с оператором прямо сейчас',
    consult_liveChatDescNoLogin: 'Требуется авторизация',
    consult_liveChatCtaLogin: 'Начать чат >',
    consult_liveChatCtaNoLogin: 'Требуется вход',
    consult_phoneTitle: 'Телефонная консультация',
    consult_businessHours: 'Пн–Пт 10:00–18:00',
    consult_chatHeader: 'Чат 1:1',
    consult_chatGreeting: 'Здравствуйте! Это Ilkwang Office.',
    consult_chatSubtext: 'Чем можем помочь?',
    consult_adminLabel: 'Оператор',
    consult_chatPlaceholder: 'Введите сообщение…',
    consult_allFieldsRequired: 'Пожалуйста, заполните все обязательные поля.',
    consult_phoneConsult: 'Телефонная консультация',
    consult_consultHours: 'Часы работы',

    // ── LoginPage ──
    login_error: 'Ошибка входа',
    login_heading: 'Вход в Ilkwang Office',
    login_subtitle: 'Войдите, чтобы сохранять историю консультаций, создавать сметы и отправлять запросы быстрее',
    login_email: 'Эл. почта',
    login_password: 'Пароль',
    login_pwPlaceholder: 'Не менее 6 символов',
    login_submitting: 'Вход…',
    login_emailLogin: 'Войти по эл. почте',
    login_noAccount: 'Нет аккаунта?',
    login_signup: 'Регистрация',

    // ── SignupPage ──
    signup_pwError: 'Пароль должен содержать не менее 6 символов',
    signup_error: 'Ошибка регистрации',
    signup_heading: 'Регистрация',
    signup_subtitle: 'Зарегистрируйтесь для управления сметами, сохранения консультаций и быстрой отправки запросов',
    signup_name: 'Имя *',
    signup_namePlaceholder: 'Иван Иванов',
    signup_email: 'Эл. почта *',
    signup_password: 'Пароль *',
    signup_pwPlaceholder: 'Не менее 6 символов',
    signup_company: 'Компания',
    signup_companyPlaceholder: '(Необязательно) Название компании',
    signup_phone: 'Телефон',
    signup_phonePlaceholder: '(Необязательно) 010-1234-5678',
    signup_submitting: 'Регистрация…',
    signup_emailSignup: 'Зарегистрироваться по эл. почте',
    signup_hasAccount: 'Уже есть аккаунт?',
    signup_login: 'Войти',

    // ── CartPage ──
    cart_product: 'Товар',
    cart_heading: 'Корзина',
    cart_loginRequired: 'Для продолжения необходимо войти',
    cart_loginBtn: 'Войти',
    cart_empty: 'Корзина пуста',
    cart_emptySub: 'Добавьте интересующие товары',
    cart_browse: 'Смотреть товары',
    cart_sktec: 'Наш магазин',
    cart_rental: 'Аренда',
    cart_copier: 'МФУ',
    cart_toner: 'Тонер',
    cart_won: 'вон',
    cart_remove: 'Удалить',
    cart_orderSummary: 'Итого по заказу',
    cart_itemCount: 'Товаров',
    cart_count: 'шт.',
    cart_totalQty: 'Общее кол-во',
    cart_estimatedTotal: 'Ориентировочная сумма',
    cart_checkout: 'Оформить заказ',
    cart_inquiryBtn: 'Запросить смету',
    cart_phoneNote: 'Телефон: Ilkwang Office — эксперты по оргтехнике',

    // ── WishlistPage ──
    wish_product: 'Товар',
    wish_heading: 'Избранное',
    wish_loginRequired: 'Для продолжения необходимо войти',
    wish_loginBtn: 'Войти',
    wish_empty: 'Список избранного пуст',
    wish_emptySub: 'Нажмите ♥ на понравившихся товарах',
    wish_browse: 'Смотреть товары',
    wish_sktec: 'Наш магазин',
    wish_rental: 'Аренда',
    wish_copier: 'МФУ',
    wish_toner: 'Тонер',
    wish_won: 'вон',
    wish_added: 'Сохранено',
    wish_addToCart: 'В корзину',

    // ── ComparePage ──
    compare_product: 'Товар',
    compare_specType: 'Тип',
    compare_specPrice: 'Цена',
    compare_specBrand: 'Бренд',
    compare_specColor: 'Цвет / Ч/Б',
    compare_specSpeed: 'Скорость печати',
    compare_specVolume: 'Месячный объём',
    compare_specPaper: 'Формат бумаги',
    compare_specDuplex: 'Двусторонняя печать',
    compare_specScan: 'Сканирование',
    compare_specFax: 'Факс',
    compare_specNetwork: 'Сеть',
    compare_specDesc: 'Описание',
    compare_sktec: 'Наш магазин',
    compare_rental: 'Аренда',
    compare_copier: 'МФУ',
    compare_toner: 'Тонер',
    compare_won: 'вон',
    compare_addProduct: 'Добавить товар',
    compare_searchPlaceholder: 'Поиск по названию или бренду…',
    compare_noSearchResults: 'Ничего не найдено',
    compare_loginRequired: 'Необходимо войти',
    compare_addedToCart: 'Добавлено в корзину',
    compare_addedToWishlist: 'Добавлено в избранное',
    compare_removedFromWishlist: 'Удалено из избранного',
    compare_heading: 'Сравнение товаров',
    compare_subtitle: 'Сравните характеристики рядом.',
    compare_comparing: ' товаров сравниваются',
    compare_clearAll: 'Очистить всё',
    compare_priceInquiry: 'Запрос цены',
    compare_cart: 'Корзина',
    compare_detail: 'Подробнее',
    compare_emptyTitle: 'Выберите товары для сравнения',
    compare_emptyDesc: 'Нажмите кнопку «Добавить товар» выше или используйте кнопку сравнения в списке товаров.',
    compare_browseProd: 'Смотреть товары',

    // ── CheckoutPage ──
    checkout_product: 'Товар',
    checkout_heading: 'Оформление заказа',
    checkout_loginRequired: 'Необходимо войти',
    checkout_loginBtn: 'Войти',
    checkout_emptyCart: 'Корзина пуста',
    checkout_browse: 'Смотреть товары',
    checkout_validation: 'Укажите получателя, телефон и адрес доставки.',
    checkout_error: 'Произошла ошибка при оформлении заказа.',
    checkout_delivery: 'Данные доставки',
    checkout_recipient: 'Получатель *',
    checkout_recipientPh: 'Имя',
    checkout_phone: 'Телефон *',
    checkout_company: 'Компания',
    checkout_companyPh: 'Компания (необязательно)',
    checkout_zip: 'Почтовый индекс',
    checkout_address: 'Адрес доставки *',
    checkout_addressPh: 'Адрес',
    checkout_detailAddr: 'Доп. адрес',
    checkout_detailAddrPh: 'Корпус / квартира',
    checkout_memo: 'Примечание к доставке',
    checkout_memoPh: 'Пожелания к доставке (необязательно)',
    checkout_payMethod: 'Способ оплаты',
    checkout_bankTransfer: 'Банковский перевод',
    checkout_bankInfo: 'Woori Bank 1005-xxx-xxxxxx',
    checkout_cardPay: 'Оплата картой',
    checkout_cardDesc: 'Оформляется после телефонной консультации',
    checkout_postPay: 'Оплата по факту',
    checkout_postPayDesc: 'Счёт выставляется после доставки',
    checkout_orderItems: 'Товары в заказе',
    checkout_qty: 'Кол-во:',
    checkout_won: 'вон',
    checkout_itemCount: 'Товаров',
    checkout_count: 'шт.',
    checkout_shipping: 'Доставка',
    checkout_free: 'Бесплатно',
    checkout_total: 'Итого',
    checkout_quoteGuide: 'Смета по запросу',
    checkout_processing: 'Обработка заказа…',
    checkout_placeOrder: 'Подтвердить заказ',
    checkout_backToCart: '← Назад в корзину',

    // ── OrderConfirmPage ──
    order_seoTitle: 'Заказ подтверждён',
    order_notFound: 'Информация о заказе не найдена',
    order_browse: 'Смотреть товары',
    order_success: 'Ваш заказ оформлен',
    order_successSub: 'Наш специалист свяжется с вами в ближайшее время',
    order_orderNo: 'Номер заказа',
    order_amount: 'Сумма',
    order_won: 'вон',
    order_guideTitle: 'Этапы обработки заказа',
    order_step1: 'Заказ принят',
    order_step1Desc: 'Ваш заказ успешно принят',
    order_step2: 'Подтверждение',
    order_step2Desc: 'Специалист проверит ваш заказ',
    order_step3: 'Подготовка',
    order_step3Desc: 'Товары подготавливаются и проверяются',
    order_step4: 'Доставка / Установка',
    order_step4Desc: 'Согласование даты доставки или установки',
    order_viewHistory: 'История заказов',
    order_continueShopping: 'Продолжить покупки',

    // ── SitemapPage ──
    sitemap_seoTitle: 'Карта сайта — Ilkwang Office | Аренда МФУ по всей стране',
    sitemap_seoDesc: 'Карта сайта Ilkwang Office. Все страницы: региональная аренда МФУ, магазин товаров, запрос сметы и др.',
    sitemap_heading: 'Карта сайта',
    sitemap_subtitle: 'Все страницы Ilkwang Office',
    sitemap_shopping: 'Магазин',
    sitemap_allProducts: 'Все товары',
    sitemap_productSearch: 'Поиск товаров',
    sitemap_cartLink: 'Корзина',
    sitemap_wishlistLink: 'Избранное',
    sitemap_compareLink: 'Сравнение',
    sitemap_rentalSection: 'Аренда',
    sitemap_nationalRental: 'Аренда по всей стране',
    sitemap_rentalConsult: 'Консультация по аренде',
    sitemap_support: 'Поддержка',
    sitemap_quoteInquiry: 'Запрос сметы',
    sitemap_phoneConsult: 'Тел. консультация 1600-7542',
    sitemap_account: 'Аккаунт',
    sitemap_loginLink: 'Войти',
    sitemap_signupLink: 'Регистрация',
    sitemap_mypage: 'Мой кабинет',
    sitemap_regionalTitle: 'Аренда по регионам',
    sitemap_regionalDesc: 'Аренда МФУ доступна в {count} регионах по всей стране',
    sitemap_districtCount: ' регионов',
    sitemap_viewAll: 'Смотреть все →',
    sitemap_ctaTitle: 'Не нашли нужную страницу?',
    sitemap_ctaSub: 'Свяжитесь с нашим специалистом',
    sitemap_ctaBtn: 'Связаться',

    // ── ProductCard ──
    card_wishlist: 'Избранное',
    card_cart: 'Корзина',
    card_compare: 'Сравнить',
    card_black: 'Чёрный',
    card_cyan: 'Голубой',
    card_magenta: 'Пурпурный',
    card_yellow: 'Жёлтый',
    card_set: 'Комплект',
    card_genuine: 'Оригинал',
    card_compatible: 'Совместимый',
    card_remanufactured: 'Восстановленный',
    card_yield: 'Ресурс',
    card_pages: 'стр.',
    card_won: 'вон',
    card_purchase: 'Купить',
    card_color: 'Цветной',
    card_mono: 'Ч/Б',
    card_detail: 'Подробнее',
    card_rentalBtn: 'Аренда',

    // ── AiChat ──
    ai_errorMsg: 'Произошла ошибка. Попробуйте ещё раз.\n\nПрямой запрос: Ilkwang Office 1600-7542',
    ai_q1: 'Порекомендуйте цветное МФУ для офиса на 10 человек',
    ai_q2: 'Сравните аренду и покупку',
    ai_q3: 'Самое экономичное ч/б МФУ?',
    ai_q4: 'Цены на совместимые тонеры',
    ai_header: 'ИИ-ассистент',
    ai_subtitle: 'Задайте любой вопрос о МФУ, принтерах и тонерах',
    ai_emptyTitle: 'Чем могу помочь?',
    ai_emptyDesc: 'Рекомендации МФУ, поиск совместимого тонера, сравнение цен и многое другое',
    ai_recCopier: 'Рекомендуемые МФУ',
    ai_recToner: 'Рекомендуемые тонеры',
    ai_inputPlaceholder: 'Введите сообщение…',

    // ── InlineAiChat ──
    inlineAi_error: 'Произошла ошибка. Попробуйте ещё раз.',
    inlineAi_q1: 'Условия аренды этого товара',
    inlineAi_q2: 'Порекомендуйте аналоги в этом ценовом диапазоне',
    inlineAi_q3: 'Цены на совместимые тонеры',
    inlineAi_q4: 'Цветное МФУ для офиса на 10 человек',
    inlineAi_q5: 'Аренда vs покупка',
    inlineAi_q6: 'Экономичное ч/б МФУ',
    inlineAi_emptyText: 'Задайте любой вопрос',
    inlineAi_placeholder: 'Введите сообщение…',
    inlineAi_product: 'Товар',

    // ── InlineInquiryForm ──
    inqForm_rental: 'Аренда',
    inqForm_rentalMsg: 'Запрос по аренде.',
    inqForm_error: 'Ошибка отправки. Попробуйте ещё раз.',
    inqForm_successTitle: 'Запрос отправлен',
    inqForm_successDesc: 'Мы свяжемся с вами в ближайшее время.',
    inqForm_name: 'Имя *',
    inqForm_company: 'Компания',
    inqForm_phone: 'Телефон *',
    inqForm_email: 'Эл. почта',
    inqForm_inquiryType: 'Тип запроса',
    inqForm_purchase: 'Покупка',
    inqForm_tonerSupplies: 'Тонер и расходные материалы',
    inqForm_maintenance: 'Обслуживание',
    inqForm_other: 'Прочее',
    inqForm_content: 'Сообщение',
    inqForm_submitting: 'Отправка…',
    inqForm_submitBtn: 'Отправить запрос',
    inqForm_monthly: '/мес.',
    inqForm_won: 'вон',

    // ── Footer ──
    footer_desc1: 'МФУ, принтеры, тонер и расходные материалы',
    footer_desc2: 'Аренда · Продажа · Обслуживание',
    footer_hours: 'Будни 10:00–18:00',
    footer_lunch: 'Обед 12:00–13:00',
    footer_holidays: 'Выходные и праздники — нерабочие',
    footer_quickLinks: 'Быстрые ссылки',
    footer_rentalLink: 'Запрос аренды',
    footer_mallLink: 'Интернет-магазин',
    footer_servicesTitle: 'Услуги',
    footer_svcAi: 'ИИ-рекомендации МФУ',
    footer_svcSearch: 'Поиск совместимого тонера',
    footer_svcCompare: 'Сравнение цен: оригинал vs совместимый',
    footer_svcConsult: 'Консультация по аренде',

    // ── Common ──
    common_won: 'вон',
    common_count: 'шт.',
    common_monthly: '/мес.',
    common_pages: 'стр.',
    common_rental: 'Аренда',
    common_sale: 'Продажа',
    common_copier: 'МФУ',
    common_toner: 'Тонер',
    common_sktec: 'Наш магазин',
    common_priceInquiry: 'Запрос цены',
    common_color: 'Цветной',
    common_mono: 'Ч/Б',
    common_supported: 'Поддерживается',
    common_notSupported: 'Не поддерживается',
    common_goTo: 'Перейти >',

    // ── ProductDetailPage ──
    detail_reviewError: 'Не удалось отправить отзыв',
    detail_loading: 'Загрузка...',
    detail_notFound: 'Товар не найден.',
    detail_backToStore: '← Вернуться в магазин',
    detail_copier: 'МФУ',
    detail_rental: 'Аренда',
    detail_priceInquiry: 'Запрос цены',
    detail_ilkwangOffice: 'Ilkwang Office',
    detail_sktec: 'Наш магазин',
    detail_sale: 'Продажа',
    detail_seoul: 'Сеул',
    detail_overview: 'Обзор',
    detail_specs: 'Характеристики',
    detail_reviews: 'Отзывы',
    detail_store: 'Магазин',
    detail_freeDelivery: 'Доставка по всей стране',
    detail_expertConsult: 'Консультация эксперта',
    detail_genuineWarranty: 'Гарантия подлинности',
    detail_monthlyRental: 'Ежемесячная аренда',
    detail_wonMonth: 'вон/мес.',
    detail_salePrice: 'Цена продажи',
    detail_price: 'Цена',
    detail_won: 'вон',
    detail_category: 'Категория:',
    detail_contract: 'Срок контракта:',
    detail_brand: 'Бренд',
    detail_model: 'Модель',
    detail_categorySpec: 'Категория',
    detail_bwSpeed: 'Ч/Б скорость',
    detail_colorSpeed: 'Цветная скорость',
    detail_paperSize: 'Формат бумаги',
    detail_fax: 'Факс',
    detail_supported: 'Поддерживается',
    detail_notSupported: 'Не поддерживается',
    detail_duplex: 'Двусторонняя печать',
    detail_monthlyVolume: 'Рекомендуемый месячный объём',
    detail_contractPeriod: 'Срок контракта',
    detail_addedToCart: '✓ Добавлено в корзину',
    detail_addToCart: 'В корзину',
    detail_loginToCart: 'Войдите, чтобы добавить в корзину',
    detail_rentalInquiry: 'Запрос на аренду',
    detail_addedToWishlist: 'Добавлено в избранное',
    detail_addToWishlist: 'В избранное',
    detail_aiConsult: 'AI-консультация',
    detail_phoneConsult: 'Звоните: 1600-7542',
    detail_helpText: 'Получите помощь в выборе продукта.',
    detail_chatNow: 'Начать чат',
    detail_orCall: 'Или позвоните по номеру 1600-7542.',
    detail_tabDetail: 'Описание товара',
    detail_tabDelivery: 'Доставка',
    detail_tabReturn: 'Возврат и обмен',
    detail_tabReview: 'Отзывы',
    detail_noDetail: 'Описание товара отсутствует.',
    detail_productImages: 'Изображения товара',
    detail_deliveryGuide: 'Информация о доставке',
    detail_deliveryMethod: 'Способ доставки: курьер / прямая доставка (для крупных МФУ)',
    detail_deliveryArea: 'Зона доставки: вся страна (кроме отдалённых районов)',
    detail_deliveryTime: 'Сроки: курьер 2–3 дня / установка крупного оборудования по договорённости',
    detail_deliveryFee: 'Стоимость: бесплатно (возможна доплата для удалённых районов)',
    detail_deliveryInquiry: 'Вопросы по доставке:',
    detail_returnGuide: 'Возврат и обмен',
    detail_returnPeriod: 'Срок возврата/обмена',
    detail_returnPeriodDesc: 'Возврат/обмен возможен в течение 7 дней после получения',
    detail_returnExclude: 'Возврат/обмен невозможен',
    detail_returnExclude1: 'Повреждение упаковки или товара по вине покупателя',
    detail_returnExclude2: 'Использованный тонер или расходные материалы',
    detail_returnExclude3: 'Товары, изготовленные на заказ',
    detail_returnExclude4: 'Более 7 дней с момента получения',
    detail_returnCost: 'Стоимость возврата/обмена',
    detail_returnCostDesc: 'Бесплатно при браке/ошибочной доставке; за счёт покупателя в остальных случаях',
    detail_returnInquiry: 'Вопросы по возврату/обмену:',
    detail_reviewCount: ' отзывов',
    detail_noReviews: 'Отзывов пока нет.',
    detail_reviewer: 'Покупатель',
    detail_writeReview: 'Написать отзыв',
    detail_rating: 'Оценка',
    detail_reviewTitlePh: 'Заголовок отзыва (необязательно)',
    detail_reviewContentPh: 'Поделитесь опытом использования продукта...',
    detail_submittingReview: 'Отправка...',
    detail_submitReview: 'Отправить отзыв',
    detail_ctaTitle: 'Нужно решение?',
    detail_ctaDesc: 'Спроектируйте оптимальное решение с экспертами Ilkwang Office.',
    detail_ctaBtn: 'Консультация эксперта',
    detail_aiConsultPanel: 'AI-консультация',
    detail_rentalPanel: 'Запрос на аренду',

    // ── CopierDetailPage ──
    copier_loading: 'Загрузка...',
    copier_notFound: 'Продукт не найден',
    copier_backToList: '← Вернуться к списку продуктов',
    copier_seoSuffix: 'Подробности МФУ - Ilkwang Office',
    copier_seoDesc: 'Подробная информация о МФУ. Характеристики, цены, условия аренды, совместимые тонеры. Сравнивайте МФУ в Ilkwang Office.',
    copier_catalog: 'Каталог продукции',
    copier_color: 'Цветной',
    copier_mono: 'Ч/Б',
    copier_speed: 'Скорость печати',
    copier_paperSize: 'Формат бумаги',
    copier_monthlyVolume: 'Рекомендуемый месячный объём',
    copier_priceRange: 'Ценовой диапазон',
    copier_addedToCart: '✓ Добавлено',
    copier_cart: 'Корзина',
    copier_wishlistOn: '♥ В избранном',
    copier_wishlistOff: '♡ В избранное',
    copier_compare: '⚖️ Сравнить',
    copier_buyAtMall: 'Купить в нашем магазине',
    copier_rentalInquiry: '📞 Запрос на аренду',
    copier_askAi: '🤖 Спросить AI',
    copier_compatToner: '🔵 Совместимый тонер / расходные материалы',
    copier_tonerCount: 'видов',
    copier_priceCompare: '💰 Оригинал vs совместимый: сравнение цен',
    copier_thToner: 'Тонер',
    copier_thColor: 'Цвет',
    copier_thGenuine: 'Цена оригинала',
    copier_thCompatible: 'Цена совместимого',
    copier_thSaving: 'Экономия',
    copier_thYield: 'Ресурс',
    copier_black: 'Чёрный',
    copier_cyan: 'Голубой',
    copier_magenta: 'Пурпурный',
    copier_yellow: 'Жёлтый',
    copier_set: 'Комплект',
    copier_won: 'вон',
    copier_pages: 'стр.',
    copier_noToner: 'Информация о совместимых тонерах отсутствует. Свяжитесь с Ilkwang Office (1600-7542).',
    copier_aiPanel: 'AI-консультация',
    // ── RegionalRentalPage ──
    rental_locationTitle: 'Рекомендации по местоположению',
    rental_locationDesc: 'Поделитесь своим местоположением, и мы порекомендуем ближайшие службы аренды МФУ.',
    rental_later: 'Позже',
    rental_allowLocation: 'Разрешить геолокацию',
    rental_myLocation: 'Моё местоположение',
    rental_all: 'Все',
    rental_copierRental: 'Аренда МФУ',
    rental_regionCopierRental: 'Аренда МФУ в регионе',
    rental_nationwideCopierRental: 'Аренда МФУ по всей стране',
    rental_districtDesc: 'Аренда МФУ и принтеров в районе. Бесплатная установка, регулярное обслуживание, поддержка тонера.',
    rental_regionDesc: 'Сервис аренды МФУ по всему региону. Выберите район.',
    rental_nationwideDesc: 'Аренда МФУ по всей стране. Выберите область для начала.',
    rental_nationwide: 'По всей стране',
    rental_districts: 'районов',
    rental_products: 'Продукты',
    rental_selectRegion: 'Выбор региона',
    rental_findByLocation: 'Найти по местоположению',
    rental_searchPlaceholder: 'Поиск МФУ...',
    rental_region: 'Регион',
    rental_filterAll: 'Все',
    rental_filterColor: 'Цветной',
    rental_filterMono: 'Ч/Б',
    rental_brandAll: 'Все бренды',
    rental_categoryAll: 'Все категории',
    rental_sortDefault: 'Сортировка: по умолчанию',
    rental_sortPriceAsc: 'Цена: по возрастанию',
    rental_sortPriceDesc: 'Цена: по убыванию',
    rental_sortName: 'По имени',
    rental_reset: 'Сбросить',
    rental_rentalProducts: 'Арендные продукты',
    rental_count: '',
    rental_quoteInquiry: 'Запрос на расчёт',
    rental_noProductsYet: 'В этом районе пока нет зарегистрированных продуктов',
    rental_selectDistrict: 'Пожалуйста, выберите район',
    rental_requestQuoteDesc: 'Если вам нужен МФУ, отправьте запрос на расчёт. Наши специалисты подберут оптимальный план аренды.',
    rental_selectRegionHint: 'Выберите регион слева, чтобы увидеть доступные товары.',
    rental_requestQuote: 'Запросить расчёт',
    rental_freeInstall: 'Бесплатная установка',
    rental_freeInstallDesc: 'Бесплатная доставка и установка по всей стране',
    rental_regularCheck: 'Регулярное обслуживание',
    rental_regularCheckDesc: 'Ежемесячное бесплатное обслуживание',
    rental_freeToner: 'Бесплатный тонер',
    rental_freeTonerDesc: 'Бесплатная доставка расходных материалов',
    rental_badge_rental: 'Аренда',
    rental_badge_both: 'Продажа+Аренда',
    rental_monthly: 'Мес.',
    rental_won: '₩',
    rental_priceInquiry: 'Цена по запросу',
    rental_detail: 'Подробнее →',
    rental_copierConsult: 'Консультация по аренде МФУ',
    rental_ctaDesc: 'Запрашивайте расчёт прямо сейчас. Бесплатная установка, регулярное обслуживание, бесплатный тонер.',
    rental_freeQuoteRequest: 'Бесплатный запрос на расчёт',
    // ── CustomerERPPage ──
    erp_home: 'Главная',
    erp_aiConsult: 'AI-консультация',
    erp_usageAnalysis: 'Анализ использования',
    erp_quoteManage: 'Управление расчётами',
    erp_inquiryManage: 'Управление запросами',
    erp_cart: 'Корзина',
    erp_wishlist: 'Избранное',
    erp_orderHistory: 'История заказов',
    erp_purchaseManage: 'Управление закупками',
    erp_chatHistory: 'История чатов',
    erp_myInfo: 'Мои данные',
    erp_reviewLounge: 'Лаунж отзывов',
    erp_tripManage: 'Упр. командировками',
    erp_tripDesc: 'Планируйте маршруты с отправлением, промежуточными и пунктом назначения',
    erp_statusDraft: 'Черновик',
    erp_statusSubmitted: 'Отправлено',
    erp_statusReviewed: 'На проверке',
    erp_statusSent: 'Доставлено',
    erp_typeRental: 'Аренда',
    erp_typePurchase: 'Покупка',
    erp_typeToner: 'Тонер',
    erp_typeEtc: 'Прочее',
    erp_aiConsultDesc: 'Спросите AI что угодно',
    erp_usageDesc: 'Фото отчёта → AI автораспознавание',
    erp_quickInquiry: 'Быстрый запрос',
    erp_quickInquiryDesc: 'Завершение за 1 минуту',
    erp_writeQuote: 'Создать расчёт',
    erp_writeQuoteDesc: 'Получить индивидуальный расчёт',
    erp_bulkPurchase: 'Оптовые закупки',
    erp_bulkPurchaseDesc: 'Для корпоративных покупателей',
    erp_nationalRental: 'Аренда по стране',
    erp_nationalRentalDesc: 'Поиск местной аренды',
    erp_compare: 'Сравнение продуктов',
    erp_compareDesc: 'Сравнительный анализ МФУ',
    erp_productSearch: 'Поиск продуктов',
    erp_productSearchDesc: 'AI персонализированные рекомендации',
    erp_wishlistDesc: 'Просмотр сохранённых продуктов',
    erp_sitemap: 'Карта сайта',
    erp_sitemapDesc: 'Все меню одним взглядом',
    erp_allProducts: 'Все продукты',
    erp_aiSearch: 'AI-поиск',
    erp_myPage: ' — Мой кабинет',
    erp_seoDesc: 'Ilkwang Office — Клиентская ERP: расчёты, запросы, AI-консультации, управление закупками',
    erp_hello: 'Здравствуйте',
    erp_honorific: '',
    erp_goHome: 'На главную',
    erp_logout: 'Выйти',
    erp_siteShortcuts: 'Быстрые ссылки',
    erp_more: 'Ещё',
    erp_quotes: 'Расчёты',
    erp_inquiryHistory: 'История запросов',
    erp_shortcuts: 'Быстрый доступ',
    erp_recentQuotes: 'Недавние расчёты',
    erp_viewAll: 'Показать все →',
    erp_recentInquiries: 'Недавние запросы',
    erp_tipText: '💡 Знаете ли вы?',
    erp_tipDesc: 'Получите от AI рекомендации по лучшим МФУ и мгновенно создайте расчёт.',
    erp_tipBtnAi: 'Начать AI-чат',
    erp_aiDesc: 'AI-помощник порекомендует лучшие МФУ и тонеры',
    erp_newChat: 'Новый чат',
    erp_prevChats: 'Предыдущие чаты',
    erp_aiAsk: 'Спросите AI-помощника',
    erp_aiHint: 'Задайте вопрос о рекомендациях МФУ, совместимости тонеров, сравнении цен и т.д.',
    erp_suggestOffice: 'Порекомендуйте МФУ для офиса',
    erp_suggestCompare: 'Сравните цветные МФУ',
    erp_suggestToner: 'Найдите совместимые тонеры',
    erp_suggestSmall: 'Лучшие продукты для небольшого офиса?',
    erp_recCopier: 'Рекомендуемые МФУ',
    erp_recToner: 'Рекомендуемые тонеры',
    erp_msgPlaceholder: 'Введите сообщение...',
    erp_chatError: 'Извините, произошла ошибка. Попробуйте ещё раз.',
    erp_quoteManageDesc: 'Создавайте и управляйте расчётами',
    erp_newQuote: 'Новый расчёт',
    erp_noQuotes: 'Расчётов пока нет',
    erp_noQuotesHint: 'Создайте новый расчёт',
    erp_createQuote: 'Создать расчёт',
    erp_submit: 'Отправить',
    erp_delete: 'Удалить',
    erp_adminNote: 'Заметка администратора:',
    erp_items: 'Позиции',
    erp_backToQuotes: '← Список расчётов',
    erp_newQuoteTitle: 'Создание нового расчёта',
    erp_quoteTitle: 'Название расчёта',
    erp_companyName: 'Название компании',
    erp_addItem: 'Добавить позицию',
    erp_productModel: 'Продукт / Модель',
    erp_quantity: 'Кол-во',
    erp_addMore: '+ Добавить',
    erp_productNameCol: 'Продукт',
    erp_typeCol: 'Тип',
    erp_additionalNotes: 'Дополнительные пожелания (необязательно)',
    erp_saveQuote: 'Сохранить расчёт',
    erp_inquiryManageDesc: 'Отправляйте запросы и проверяйте ответы',
    erp_autoFillInfo: 'Информация заполнена автоматически',
    erp_rentalInquiry: 'Запрос на аренду',
    erp_purchaseInquiry: 'Запрос на покупку',
    erp_tonerInquiry: 'Запрос на тонер',
    erp_etcInquiry: 'Другой запрос',
    erp_sendInquiry: 'Отправить запрос',
    erp_noInquiries: 'Запросов пока нет',
    erp_adminReply: 'Ответ администратора',
    erp_inquiryPlaceholder: 'Введите ваш запрос...',
    erp_answered: 'Отвечено',
    erp_processing: 'В обработке',
    erp_received: 'Получено',
    erp_emptyCart: 'Корзина пуста',
    erp_emptyCartHint: 'Добавьте понравившиеся товары в корзину',
    erp_browseProducts: 'Смотреть товары →',
    erp_copier: 'МФУ',
    erp_toner: 'Тонер',
    erp_inHouse: 'Внутренний',
    erp_requestQuoteInquiry: 'Запросить расчёт',
    erp_goToCart: 'Перейти в корзину →',
    erp_product: 'Продукт',
    erp_won: '₩',
    erp_cartInquiry: 'Быстрый запрос',
    erp_saved: 'Сохранено в избранное',
    erp_emptyWishlist: 'Избранное пусто',
    erp_emptyWishlistHint: 'Нажмите сердечко на товарах для сохранения',
    erp_viewDetail: 'Подробнее',
    erp_copierAnalysis: 'Анализ использования МФУ',
    erp_copierAnalysisDesc: 'AI автоматически анализирует отчёты МФУ',
    erp_uploadReport: 'Загрузить отчёт',
    erp_uploadReportDesc: 'Загрузите фото отчёта МФУ',
    erp_clientName: 'Название клиента',
    erp_clientExample: 'напр.: Ilkwang Office',
    erp_selectOtherFile: 'Выбрать другой файл',
    erp_startAnalysis: 'Начать анализ',
    erp_aiAnalyzing: 'AI анализирует...',
    erp_analysisResult: 'Результат анализа',
    erp_close: 'Закрыть',
    erp_modelName: 'Модель',
    erp_reportDate: 'Дата отчёта',
    erp_totalPages: 'Всего страниц',
    erp_color: 'Цветной',
    erp_bw: 'Ч/Б',
    erp_scan: 'Скан',
    erp_fax: 'Факс',
    erp_copy: 'Копия',
    erp_printPages: 'Печать',
    erp_tonerRemaining: 'Остаток тонера',
    erp_usageByUser: 'Использование по пользователям',
    erp_user: 'Пользователь',
    erp_total: 'Итого',
    erp_extraInfo: 'Дополнительно',
    erp_analysisHistory: 'История анализов',
    erp_countUnit: '',
    erp_noReports: 'История анализов пуста',
    erp_unknownModel: 'Неизвестно',
    erp_client: 'Клиент',
    erp_totalPrefix: 'Всего',
    erp_sheets: 'листов',
    erp_orderHistoryDesc: 'Проверьте историю заказов',
    erp_noOrders: 'Заказов пока нет',
    erp_noOrdersHint: 'Ваши заказы появятся здесь',
    erp_orderPending: 'Ожидание',
    erp_orderConfirmed: 'Подтверждён',
    erp_orderProcessing: 'В обработке',
    erp_orderShipping: 'Доставляется',
    erp_orderDelivered: 'Доставлен',
    erp_orderCancelled: 'Отменён',
    erp_orderRefunded: 'Возврат',
    erp_qtyLabel: 'Кол-во',
    erp_cancelOrder: 'Отменить заказ',
    erp_purchaseManageDesc: 'Управление оптовыми закупками и арендой',
    erp_bulkInquiry: 'Оптовая закупка/аренда',
    erp_bulkInquiryDesc: 'Введите информацию об оборудовании',
    erp_equipment: 'Оборудование',
    erp_productReq: 'Продукт/Характеристики',
    erp_productReqExample: 'напр.: Цветной МФУ A3',
    erp_installLocation: 'Место установки',
    erp_installExample: 'напр.: Москва, центр',
    erp_addEquipment: '+ Добавить оборудование',
    erp_sendBulkInquiry: 'Отправить оптовый запрос',
    erp_corporateGuide: 'Руководство для корпоративных клиентов',
    erp_corpFeat1Title: 'Экспертная консультация',
    erp_corpFeat1Desc: 'Индивидуальный подход к размеру компании',
    erp_corpFeat2Title: 'Оптовые скидки',
    erp_corpFeat2Desc: 'Специальные скидки от 10 единиц',
    erp_corpFeat3Title: 'Единое управление',
    erp_corpFeat3Desc: 'Централизованное управление оборудованием',
    erp_corpFeat4Title: 'Приоритетный сервис',
    erp_corpFeat4Desc: 'Приоритетная техподдержка для компаний',
    erp_corpFeat5Title: 'Ежемесячные отчёты',
    erp_corpFeat5Desc: 'Ежемесячные отчёты об использовании',
    erp_dedicatedConsult: 'Персональный консультант',
    erp_dedicatedConsultDesc: 'Корпоративным клиентам назначается персональный консультант',
    erp_makeInquiry: 'Отправить запрос',
    erp_individualBuyer: 'Индивидуальный покупатель',
    erp_aiRec: 'AI-рекомендация',
    erp_rentalQuote: 'Расчёт аренды',
    erp_clickToSelect: 'Нажмите для выбора',
    erp_aiChatHistory: 'История AI-чатов',
    erp_aiChatHistoryDesc: 'Просмотр предыдущих AI-консультаций',
    erp_noChatHistory: 'История AI-чатов пуста',
    erp_startAiChat: 'Начать AI-чат',
    erp_messagesCount: ' сообщений',
    erp_editProfileDesc: 'Редактирование профиля',
    erp_name: 'Имя',
    erp_company: 'Компания',
    erp_phone: 'Телефон',
    erp_email: 'Эл. почта',
    erp_editProfile: 'Редактировать профиль',
    erp_accountInfo: 'Информация об аккаунте',
    erp_accountType: 'Тип аккаунта',
    erp_local: 'Обычный',
    erp_accountLabel: 'Аккаунт',
    erp_loginLabel: 'Вход',
    erp_role: 'Роль',
    erp_roleAdmin: 'Администратор',
    erp_roleMember: 'Участник',
    erp_deleteAccount: 'Удалить аккаунт',
    erp_deleteAccountDesc: 'Удаление аккаунта безвозвратно удалит все данные.',
    erp_deleteAccountRequest: 'Запрос на удаление аккаунта',
    erp_deleteAccountConfirm: 'Вы уверены, что хотите удалить аккаунт? Это действие необратимо.',
    erp_deleteNow: 'Удалить сейчас',
    erp_cancel: 'Отмена',
    erp_requestDelete: 'Запросить удаление',
    erp_deleteAccountAlerted: 'Запрос на удаление аккаунта отправлен. Администратор обработает его.',
    erp_errorOccurred: 'Произошла ошибка',
    erp_myReviewLounge: 'Мой лаунж отзывов',
    erp_communityDesc: 'Проверьте свою активность в сообществе',
    erp_myTonerPoints: 'Мои баллы за тонер',
    erp_myBadge: 'Мой значок',
    erp_goToReviewLounge: 'Перейти в лаунж отзывов →',
    erp_myPosts: 'Мои посты',
    erp_myComments: 'Мои комментарии',
    erp_pointHistory: 'История баллов',
    erp_noMyPosts: 'Постов пока нет',
    erp_noMyComments: 'Комментариев пока нет',
    erp_totalPoints: 'Всего баллов',
    erp_badgeLevel: 'Уровень значка',
    erp_maxDiscount: 'Макс. скидка',
    erp_typeLabel: 'Тип',
    erp_pointLabel: 'Баллы',
    erp_reason: 'Причина',
    erp_dateTime: 'Дата',
    erp_noPointHistory: 'История баллов пуста',
    erp_earn: 'Получено',
    erp_spend: 'Потрачено',
    erp_rec: 'Рек.',
    erp_commentsLabel: 'Комментарии',
    erp_views: 'Просмотры',
    erp_badgeA4: 'A4 Новичок',
    erp_badgeInkjet: 'Inkjet Бегун',
    erp_badgeColorLaser: 'Color Laser Про',
    erp_badgeMaster: 'Мастер МФУ',
    livechat_consult: 'Онлайн-чат',
    livechat_channelSelect: 'Выберите канал',
    livechat_chat: 'Онлайн-чат',
    livechat_hours: 'Будни 09:00–18:00',
    livechat_howToConsult: 'Как вы хотите связаться?',
    livechat_kakaoChat: 'KakaoTalk чат',
    livechat_kakaoDesc: 'Быстрый ответ · Можно отправить фото',
    livechat_fastResponse: 'Быстро',
    livechat_siteChat: 'Чат на сайте',
    livechat_siteChatDesc: 'Чат после входа',
    livechat_aiAssistant: 'AI-помощник',
    livechat_aiAssistantDesc: '24/7 автоматическая AI-консультация',
    livechat_kakaoFastest: 'KakaoTalk — самый быстрый!',
    livechat_customerCenter: 'Служба поддержки',
    livechat_welcome: 'Спрашивайте что угодно!',
    livechat_askAnything: 'Оставьте ваш вопрос о МФУ, тонерах, аренде и т.д.',
    livechat_fasterTip: 'Для быстрой поддержки попробуйте',
    livechat_kakaoLink: 'KakaoTalk чат',
    livechat_fasterTipSuffix: '!',
    livechat_agent: 'Оператор',
    livechat_inputPlaceholder: 'Введите сообщение...',
    livechat_chatClosed: 'Чат завершён',
    filter_all: 'Все',
  },

  de: {
    // ── HomePage ──
    home_seoTitle:
      'Multifunktionsdrucker & Kopierer Experten | Ilkwang Office – Miete · Verkauf · Tonerpreisvergleich',
    home_seoDesc:
      'Ilkwang Office — Spezialisten für Multifunktionsdrucker, Kopierer und Druck. Büro-MFP-Miete ab ₩30.000/Monat. Farb- & S/W-Kopierer, Tonerpreisvergleich. Vergleichen Sie Samsung, Canon, Fuji Xerox, Kyocera & Sindoh MFPs mit KI-Empfehlungen.',
    home_heroTitle: 'Store.',
    home_heroSub:
      'Der beste Weg, den perfekten Multifunktionsdrucker für Ihr Büro zu finden.',
    home_askAi: 'KI fragen',
    home_askAiDesc: 'KI findet die passende Ausstattung für Ihre Anforderungen.',
    home_callConsult: 'Telefonberatung',
    home_callConsultDesc: 'Sprechen Sie direkt mit einem Berater.',
    home_catColor: 'Farb-MFP',
    home_catMono: 'S/W-MFP',
    home_catPrinter: 'Drucker',
    home_catToner: 'Toner & Verbrauchsmaterial',
    home_catConsult: 'Beratung',
    home_catOwnMall: 'Unser Shop',
    home_catAi: 'KI-Empfehlung',
    home_catDigital: 'Digitaldruck',
    home_catDigitalDesc: 'Hochgeschwindigkeits-Digitaldruck',
    home_catLarge: 'Großes MFP',
    home_catLargeDesc: 'A3 Großformat-Multifunktion',
    home_catSmall: 'Kleines MFP',
    home_catSmallDesc: 'A4 Desktop-Multifunktion',
    home_catPrinterDesc: 'Laser- und Tintenstrahldrucker',
    home_catTonerDesc: 'Original-, Kompatibel- und Recyclingtoner',
    home_searchTitle: 'Produktsuche',
    home_searchDesc: 'Nach Modell, Marke oder Tonernummer suchen',
    home_noResults: 'Keine Ergebnisse gefunden',
    home_searchHint2: 'Versuchen Sie eine Suche',
    home_newProducts: 'Neuheiten',
    home_newProductsDesc: 'Entdecken Sie die neuesten Produkte',
    home_rental: 'Miete',
    home_monthlyPrice: '₩{price}/Monat~',
    home_priceInquiry: 'Preis anfragen',
    home_quickLinks: 'Schnellzugriff.',
    home_quickLinksDesc: 'Direkter Zugang zu häufig besuchten Seiten.',
    home_productStore: 'Produktkatalog',
    home_aiRecommend: 'KI-Empfehlung',
    home_productCompare: 'Vergleich',
    home_cart: 'Warenkorb',
    home_wishlist: 'Merkliste',
    home_myErp: 'Mein ERP',
    home_nationalRental: 'Landesweite Miete',
    home_consult: 'Beratung',
    home_sitemapLink: 'Sitemap',
    home_phoneConsult: 'Telefonberatung',
    home_consultSection: 'Beratung',
    home_consultDesc:
      'Mietangebote, Produktanfragen und Live-Support — alles an einem Ort.',
    home_rentalQuote: 'Mietangebot',
    home_rentalQuoteDesc:
      'Berechnen Sie Ihre monatliche Miete sofort mit unserem Kalkulator.',
    home_getQuote: 'Angebot anfordern >',
    home_generalConsult: 'Allgemeine Anfrage',
    home_generalConsultDesc:
      'Stellen Sie jede Anfrage — Kauf, Toner, Kundendienst und mehr.',
    home_inquireNow: 'Jetzt anfragen >',
    home_liveConsult: 'Live-Support',
    home_liveConsultDesc:
      'Sofortige Hilfe über KakaoTalk, Chat oder Telefon.',
    home_consultNow: 'Jetzt chatten >',
    home_globalInquiry: 'Internationale Anfrage',
    home_rentalMall: 'Landesweiter Mietshop.',
    home_rentalMallDesc1:
      'Verfügbar überall — Seoul, Busan, Daegu, Incheon, Gwangju, Daejeon, Ulsan, Sejong, Gyeonggi und mehr.',
    home_rentalMallDesc2:
      'MFP- & Druckermiete. Kostenlose Installation & regelmäßige Wartung.',
    home_seoul: 'Seoul',
    home_gwanghwamun: 'Gwanghwamun',
    home_busan: 'Busan',
    home_jagalchi: 'Jagalchi-Markt',
    home_daegu: 'Daegu',
    home_daeguSub: 'Äpfel & Kräutermedizinmarkt',
    home_incheon: 'Incheon',
    home_chinatown: 'Chinatown',
    home_gyeonggi: 'Gyeonggi',
    home_suwon: 'Hwaseong-Festung (Suwon)',
    home_gwangju: 'Gwangju',
    home_gwangjuSub: 'Mudeungsan & Bibimbap',
    home_daejeon: 'Daejeon',
    home_daejeonSub: 'Sungsimdang & Brot',
    home_jeju: 'Jeju',
    home_jejuSub: 'Hallabong & Mandarinen',
    home_viewAllRegions: 'Alle 260+ Regionen anzeigen >',
    home_nationalRentalMall: 'Landesweiter Mietshop',
    home_regionsCount: '260+ Regionen',
    home_goTo: 'Öffnen >',
    home_aiConsult: 'KI-Beratung',
    home_productSearch: 'Produktsuche',
    home_searchPlaceholder:
      'Suchen Sie nach MFP-Modell oder Tonernummer.',
    home_searchBtn: 'Suchen',
    home_searchHint: 'z. B. "Samsung SL-XA225" oder "CLT-K3080S"',
    home_shortcuts: 'Schnellzugriff',
    home_rentalInquiry: 'Mietanfrage',
    home_ownMall: 'Unser Shop',
    home_latestProducts: 'Neueste Produkte.',
    home_latestProductsDesc: 'Beliebte Produkte in unserem Shop.',
    home_viewAll: 'Alle anzeigen >',
    home_rentalProducts: 'Mietprodukte.',
    home_rentalProductsDesc:
      'Günstige Miet-MFPs.',
    home_myErpSection: 'Mein ERP.',
    home_myErpDesc:
      'Maßgeschneiderte Verwaltungstools für Ihr Büro.',
    home_erpAi: 'KI-Beratung',
    home_erpAiDesc:
      'Fragen Sie die KI — von MFP-Empfehlungen bis zu Angeboten.',
    home_erpUsage: 'Nutzungsanalyse',
    home_erpUsageDesc:
      'Fotografieren Sie Ihren Bericht — die KI analysiert automatisch.',
    home_erpQuote: 'Angebot erstellen',
    home_erpQuoteDesc: 'Individuelle Angebote anfordern und verwalten.',
    home_erpInquiry: 'Schnellanfrage',
    home_erpInquiryDesc: 'Anfrage in nur einer Minute senden.',
    home_erpBulk: 'Großeinkauf',
    home_erpBulkDesc: 'Spezialtools für Firmeneinkäufer.',
    home_erpCart: 'Warenkorb',
    home_erpCartDesc: 'Produkte prüfen und bestellen.',
    home_services: 'Services.',
    home_servicesDesc:
      'Erleben Sie die professionellen Services von Ilkwang Office.',
    home_svcAi: 'KI-MFP-Empfehlung',
    home_svcAiDesc:
      'Die KI analysiert Ihre Büroumgebung und empfiehlt den optimalen MFP.',
    home_svcAiCta: 'Jetzt starten >',
    home_svcRental: 'Mietservice',
    home_svcRentalDesc:
      'Nutzen Sie einen MFP zu einer günstigen Monatsrate. Wartung inklusive.',
    home_svcRentalCta: 'Mietprodukte >',
    home_svcToner: 'Toner & Verbrauchsmaterial',
    home_svcTonerDesc:
      'Original-, Kompatibel- und Recycling-Toner zu günstigen Preisen.',
    home_svcTonerCta: 'Verkaufsprodukte >',
    home_convenienceServices: 'Komfort-Services.',
    home_convenienceDesc:
      'Alle Werkzeuge für Ihr Bürogeräte-Management an einem Ort.',
    home_usageAnalysis: 'Nutzungsanalyse',
    home_usageAnalysisDesc:
      'Fotografieren Sie Ihren Bericht — die KI analysiert den MFP-Verbrauch automatisch.',
    home_analyzeNow: 'Jetzt analysieren >',
    home_orderTracking: 'Bestell- & Lieferverfolgung',
    home_orderTrackingDesc:
      'Bestellverlauf einsehen und Lieferstatus in Echtzeit verfolgen.',
    home_trackNow: 'Jetzt verfolgen >',
    home_quoteManage: 'Angebots- & Anfragenverwaltung',
    home_quoteManageDesc:
      'Alle Ihre Angebote und Anfragen auf einen Blick einsehen und verwalten.',
    home_checkNow: 'Jetzt prüfen >',
    home_guideTitle: 'MFP- · Kopierer- · Druckratgeber.',
    home_guideDesc:
      'Erfahren Sie, wie Sie den perfekten MFP für Ihr Büro auswählen.',
    home_guideQ1: 'Was ist ein MFP?',
    home_guideA1:
      'Ein Multifunktionsdrucker (MFP) vereint Drucker, Kopierer, Scanner und Fax in einem Gerät. Im Gegensatz zu einem einfachen Kopierer erledigt ein MFP Druck, Scan und Fax aus einem Gerät und maximiert die Büroflächeneffizienz. Moderne MFPs unterstützen Cloud-Anbindung, mobiles Drucken und automatischen Duplexdruck.',
    home_guideQ2: 'Kopierer vs. MFP',
    home_guideA2:
      'Ein Kopierer ist nur für das Kopieren von Dokumenten ausgelegt, während ein MFP ein All-in-One-Bürogerät ist, das Druck, Kopie, Scan und Fax vereint. Heute sind MFPs der Marktstandard — „Kopierer" meint in der Regel einen MFP. MFPs sind auch kosteneffizienter.',
    home_guideQ3: 'Druckkosten im Büro senken',
    home_guideA3:
      'Schlüsselstrategien: ① Miete statt Kauf (niedrigere Anfangskosten), ② Nutzungsanalyse durch automatische IT-Berichte, ③ Kompatibel-/Recycling-Toner (30–60 % sparen), ④ Duplexdruck als Standard. Optimieren Sie Ihre Kosten mit der KI-Nutzungsanalyse und maßgeschneiderten Mietlösungen von Ilkwang Office.',
    home_guideQ4: 'MFP-Miete vs. Kauf',
    home_guideA4:
      'Miete bietet geringe Anfangskosten inklusive Wartung und Toner. Ein Kauf spart langfristig, erfordert aber separate Reparatur- und Verbrauchsmaterialkosten. Für Flotten ab 5 Geräten ist Miete vorteilhaft, bei geringen Mengen oder Kurzzeitbedarf ist ein Kauf sinnvoller.',
    home_guideQ5:
      'Originaltoner vs. Kompatibeltoner vs. Recyclingtoner',
    home_tonerCompareTitle: 'Tonertypen im Vergleich',
    home_tonerCompare: 'Kategorie',
    home_tonerGenuine: 'Originaltoner',
    home_tonerCompatible: 'Kompatibeltoner',
    home_tonerRemanufactured: 'Recyclingtoner',
    home_tonerPrice: 'Preis',
    home_tonerPriceGenuine: 'Hoch (Referenzpreis)',
    home_tonerPriceCompatible: '30–50 % des Originals',
    home_tonerPriceReman: '20–40 % des Originals',
    home_tonerQuality: 'Qualität',
    home_tonerQualityGenuine: 'Ausgezeichnet',
    home_tonerQualityCompatible: 'Sehr gut',
    home_tonerQualityReman: 'Befriedigend bis gut',
    home_tonerWarranty: 'Garantie',
    home_tonerWarrantyGenuine: 'Herstellergarantie',
    home_tonerWarrantyCompatible: 'Händlergarantie',
    home_tonerWarrantyReman: 'Eingeschränkt',
    home_tonerRecommend: 'Empfohlen für',
    home_tonerRecommendGenuine: 'Hochwertigen Druck',
    home_tonerRecommendCompatible: 'Kostenersparnis + Qualität',
    home_tonerRecommendReman: 'Niedrigste Kosten',
    home_tonerNote:
      'Ilkwang Office führt Original-, Kompatibel- und Recyclingtoner aller großen Marken: Samsung, Canon, Fuji Xerox, Kyocera, Sindoh, HP und Brother.',
    home_brandTitle: 'MFPs & Kopierer nach Marke',
    home_brandSamsung: 'Samsung MFP',
    home_brandCanon: 'Canon MFP',
    home_brandFuji: 'Fuji Xerox MFP',
    home_brandKyocera: 'Kyocera MFP',
    home_brandSindoh: 'Sindoh MFP',
    home_brandHp: 'HP MFP',
    home_brandBrother: 'Brother MFP',
    home_brandColor: 'Farb-MFP',
    home_faqTitle: 'Häufig gestellte Fragen',
    home_faqQ1: 'Was kostet die Miete eines MFP?',
    home_faqA1:
      'Die MFP-Miete liegt je nach Modell und Konditionen zwischen ₩30.000 und ₩300.000 pro Monat. Prüfen Sie sofort mit unserem Mietkalkulator.',
    home_faqQ2: 'Kann man einen Kopierer mieten?',
    home_faqA2:
      'Ja, Kopierer-Miete (MFP) ist möglich. Wir bieten landesweit kostenlose Installation und regelmäßige Wartung für Farb- und S/W-MFPs sowie Drucker.',
    home_faqQ3:
      'Kann die Druckumgebung im Büro optimiert werden?',
    home_faqA3:
      'Ja. Mit KI-Nutzungsanalyse und fachkundiger Beratung optimieren wir Ihre Büro-Druckumgebung und schlagen individuelle Angebote und Sparmaßnahmen vor.',
    home_faqQ4: 'Welche Tonerarten gibt es?',
    home_faqA4:
      'Es gibt drei Arten: Original-, Kompatibel- und Recyclingtoner. Unsere KI empfiehlt den passenden Toner basierend auf Ihren Anforderungen und Ihrem Budget.',
    home_faqQ5: 'Wie läuft die MFP-Wartung ab?',
    home_faqA5:
      'Bei Miete sind monatliche Inspektionen, kostenloser Vor-Ort-Service und kostenloser Toner-/Trommelwechsel inklusive. Auch für gekaufte Geräte sind Wartungsverträge verfügbar.',

    // ── StorePage ──
    store_seoTitle: 'Shop | MFP · Drucker · Toner – Ilkwang Office',
    store_seoDesc: 'Digitaldruckmaschinen, große & kleine MFPs, Drucker, Toner & Verbrauchsmaterial an einem Ort. Miet- & Kaufpreisvergleich.',
    store_heroTitle: 'Shop',
    store_heroSub: 'Finden Sie das passende MFP, den Drucker oder Toner.',
    store_searchPlaceholder: 'Produktname, Marke oder Modell suchen',
    store_loading: 'Produkte werden geladen…',
    store_searchResults: 'Suchergebnisse',
    store_productUnit: ' Produkte',
    store_noResults: 'Keine Ergebnisse gefunden.',
    store_tryOther: 'Versuchen Sie ein anderes Stichwort.',
    store_shopByCategory: 'Nach Kategorie einkaufen',
    store_shopByCategorySub: 'Wählen Sie eine Kategorie zum Erkunden.',
    store_viewAll: 'Alle anzeigen',
    store_noProducts: 'Keine Produkte in dieser Kategorie.',
    store_sortLatest: 'Empfohlen',
    store_sortName: 'Name',
    store_sortPriceAsc: 'Preis: aufsteigend',
    store_sortPriceDesc: 'Preis: absteigend',
    store_sortRental: 'Miete: aufsteigend',
    store_saleRental: 'Miete',
    store_saleBoth: 'Kauf+Miete',
    store_salePurchase: 'Kauf',
    store_inquiry: 'Anfrage',
    store_details: 'Details',
    store_subAll: 'Alle',
    store_subToner: 'Toner',
    store_subDrum: 'Trommel',
    store_subDeveloper: 'Entwickler',
    store_subFuser: 'Fixiereinheit',
    store_subParts: 'Teile',
    store_subPaper: 'Papier',

    // ── ProductsPage ──
    products_seoTitle:
      'Alle MFPs & Kopierer | Miet- & Kaufpreisvergleich – Ilkwang Office',
    products_seoDesc:
      'Vergleichen Sie alle Samsung-, Canon-, Fuji-Xerox-, Kyocera- & Sindoh-MFPs und Kopierer. Farb-MFP, S/W-MFP, Drucker & Tonerpreisvergleich. Miete ab ₩30.000/Monat.',
    products_heading: 'Katalog',
    products_subtitle:
      'Klicken Sie auf ein Produkt, um Details anzuzeigen.',
    products_searchPlaceholder: 'Produkt suchen',
    products_loading: 'Wird geladen…',
    products_itemCount: 'Stk.',
    products_noResults: 'Keine Ergebnisse gefunden.',
    products_noResultsSub:
      'Versuchen Sie eine andere Kategorie oder ein anderes Stichwort.',
    products_all: 'Alle',
    products_digitalPress: 'Digitale Druckmaschine',
    products_largeMFP: 'Großes MFP',
    products_smallMFP: 'Kleines MFP',
    products_printer: 'Drucker',
    products_tonerSupplies: 'Toner & Verbrauchsmaterial',
    products_colorCopier: 'Farb-MFP',
    products_monoCopier: 'S/W-MFP',
    products_copierRental: 'MFP-Miete',
    products_specialEquip: 'Spezialgeräte',
    products_copierSales: 'MFP-Verkauf',
    products_sktecMall: 'Shop',
    products_ikofficesRental: 'Miete',
    products_saleRental: 'Verkauf + Miete',
    products_sale: 'Verkauf',
    products_rental: 'Miete',
    products_monthly: '/Monat',
    products_won: '₩',
    products_wonTilde: '₩~',
    products_priceInquiry: 'Preis anfragen',
    products_prev: 'Zurück',
    products_next: 'Weiter',

    // ── SearchPage ──
    search_seoTitle:
      'KI-MFP-Suche | Kopierer & Toner finden – Ilkwang Office',
    search_seoDesc:
      'KI empfiehlt den optimalen MFP und Kopierer für Ihr Büro. Suche nach Modellname oder Tonernummer.',
    search_heading: 'KI-Suche',
    search_subtitle:
      'Stellen Sie der KI eine Frage oder suchen Sie nach Modellname. Empfohlene Produkte verlinken direkt zu unserem Shop oder Mietportal.',
    search_aiConsult: 'KI-Beratung',
    search_productSearch: 'Produktsuche',
    search_placeholder: 'Modell, Marke, Tonernummer suchen…',
    search_searching: 'Suche läuft…',
    search_searchBtn: 'Suchen',
    search_copiers: 'MFPs',
    search_count: 'Ergebnisse',
    search_tonerSupplies: 'Toner & Verbrauchsmaterial',
    search_noResults: 'Keine Ergebnisse gefunden',
    search_initialHint:
      'Suchen Sie nach MFP-Modellname oder Tonernummer.',
    search_exampleHint: 'z. B. "Samsung SL-X4225" oder "CLT-K808S"',
    search_shortcuts: 'Schnellzugriff',
    search_rentalInquiry: 'Mietanfrage',
    search_ownMall: 'Unser Shop',

    // ── ConsultationPage ──
    consult_seoTitle:
      'Beratung – Mietangebot · Live-Support · Internationale Anfragen | Ilkwang Office',
    consult_seoDesc:
      'MFP-, Drucker- & Toner-Mietangebote und Beratung. KakaoTalk, Live-Chat & Telefonberatung. Internationale Anfragen willkommen.',
    consult_heading: 'Beratung',
    consult_subtitle:
      'Mietangebote, Produktanfragen und Live-Support — alles an einem Ort.',
    consult_tabRental: 'Mietangebot',
    consult_tabGeneral: 'Allgemeine Anfrage',
    consult_tabLive: 'Live-Support',
    consult_tabGlobal: 'Internationale Anfrage',
    consult_calcTitle: 'Mietkosten-Rechner',
    consult_planSelect: 'Tarif wählen',
    consult_monthly: '/Monat',
    consult_won: '₩',
    consult_bwPages: '{n} S/W-Seiten',
    consult_colorPages: '{n} Farbseiten',
    consult_adjustPages: 'Seitenanzahl anpassen',
    consult_bwCount: 'S/W-Seiten',
    consult_colorCount: 'Farbseiten',
    consult_pages: 'Seiten',
    consult_default: 'Standard',
    consult_geoNotSupported:
      'Ihr Browser unterstützt keine Standortdienste.',
    consult_geoError: 'Standort konnte nicht ermittelt werden.',
    consult_uploadError:
      'Datei-Upload fehlgeschlagen. (Max. 10 MB; jpg/png/pdf/doc/hwp)',
    consult_nameRequired: 'Bitte geben Sie Ihren Namen ein.',
    consult_phoneRequired: 'Bitte geben Sie Ihre Telefonnummer ein.',
    consult_submitError: 'Anfrage konnte nicht gesendet werden.',
    consult_successTitle: 'Anfrage eingegangen',
    consult_successDesc:
      'Ein Mitarbeiter wird sich in Kürze bei Ihnen melden.',
    consult_quoteSummary: 'Angebotsübersicht',
    consult_monthlyRental: 'Monatliche Miete:',
    consult_autoQuoteNote:
      'Das Angebot wurde automatisch erstellt. Es wird nach Prüfung versendet.',
    consult_urgent: 'Dringend?',
    consult_callUs: 'Rufen Sie uns an.',
    consult_nationalRental: 'Landesweiter Mietshop',
    consult_goHome: 'Startseite',
    consult_selectProduct: 'Produkt wählen',
    consult_selectProductPlaceholder: 'Mietprodukt auswählen',
    consult_searchProductPlaceholder: 'Produktname, Marke suchen...',
    consult_inquiryProduct: 'Angefragtes Produkt',
    consult_autoFilled: 'Mitgliedsdaten wurden automatisch ausgefüllt.',
    consult_name: 'Name',
    consult_company: 'Unternehmen',
    consult_namePlaceholder: 'Max Mustermann',
    consult_companyPlaceholder: 'Firma GmbH',
    consult_phone: 'Telefon',
    consult_email: 'E-Mail',
    consult_installRegion: 'Installationsregion',
    consult_locating: 'Standort wird ermittelt…',
    consult_myLocation: 'Mein Standort',
    consult_additionalRequest: 'Zusätzliche Wünsche',
    consult_inquiryContent: 'Anfragedetails',
    consult_contentPlaceholder:
      'Bitte beschreiben Sie Ihre Anfrage.\n(Produktname, Menge, Installationsort, gewünschte Konditionen usw.)',
    consult_attachment: 'Anhang',
    consult_uploading: 'Wird hochgeladen…',
    consult_uploadPrompt:
      'Klicken Sie, um eine Datei anzuhängen (Bild, PDF, Dokument)',
    consult_remove: 'Entfernen',
    consult_estimatedMonthly: 'Geschätzte Monatsmiete (inkl. MwSt.)',
    consult_submitting: 'Wird gesendet…',
    consult_requestQuote: 'Angebot anfordern',
    consult_sendInquiry: 'Anfrage senden',
    consult_responseNote:
      'Wir melden uns innerhalb von 1 Werktag bei Ihnen.',
    consult_contentRequired: 'Bitte geben Sie Ihre Anfrage ein.',
    consult_generalTitle: 'Allgemeine Anfrage',
    consult_generalDesc:
      'Stellen Sie uns alle Fragen rund um MFPs, Drucker, Toner und Bürogeräte. Unsere Fachberater helfen Ihnen gerne weiter.',
    consult_sampleService: 'Musterdruck-Service',
    consult_sampleDesc:
      'Hängen Sie ein Bild an — wir drucken ein Muster auf einem echten MFP und senden es Ihnen per Post.',
    consult_inquiryType: 'Anfragetyp',
    consult_typePurchase: 'Kaufanfrage',
    consult_typeToner: 'Toner / Verbrauchsmaterial',
    consult_typeService: 'Service & Wartung',
    consult_typeOther: 'Sonstiges',
    consult_generalPlaceholder:
      'Beschreiben Sie Ihre Frage in eigenen Worten.',
    consult_liveIntro:
      'Wählen Sie den schnellsten und bequemsten Kontaktweg.',
    consult_recommended: 'Empfohlen',
    consult_kakaoTitle: 'KakaoTalk-Chat',
    consult_kakaoDesc: 'Schnellste Antwortzeit',
    consult_kakaoCta: 'KakaoTalk öffnen >',
    consult_liveChatTitle: 'Live-Chat',
    consult_liveChatDescLogin: 'Sofort mit einem Berater chatten',
    consult_liveChatDescNoLogin: 'Anmeldung erforderlich',
    consult_liveChatCtaLogin: 'Chat starten >',
    consult_liveChatCtaNoLogin: 'Anmeldung nötig',
    consult_phoneTitle: 'Telefonberatung',
    consult_businessHours: 'Mo–Fr 10:00–18:00',
    consult_chatHeader: '1:1 Live-Chat',
    consult_chatGreeting: 'Hallo! Hier ist Ilkwang Office.',
    consult_chatSubtext: 'Wie können wir Ihnen helfen?',
    consult_adminLabel: 'Berater',
    consult_chatPlaceholder: 'Nachricht eingeben…',
    consult_allFieldsRequired:
      'Bitte füllen Sie alle Pflichtfelder aus.',
    consult_phoneConsult: 'Telefonberatung',
    consult_consultHours: 'Beratungszeiten',

    // ── LoginPage ──
    login_error: 'Anmeldung fehlgeschlagen',
    login_heading: 'Anmeldung bei Ilkwang Office',
    login_subtitle: 'Melden Sie sich an, um Beratungsverläufe zu speichern, Angebote zu erstellen und Anfragen schneller zu senden',
    login_email: 'E-Mail',
    login_password: 'Passwort',
    login_pwPlaceholder: 'Mindestens 6 Zeichen',
    login_submitting: 'Anmeldung…',
    login_emailLogin: 'Mit E-Mail anmelden',
    login_noAccount: 'Noch kein Konto?',
    login_signup: 'Registrieren',

    // ── SignupPage ──
    signup_pwError: 'Passwort muss mindestens 6 Zeichen lang sein',
    signup_error: 'Registrierung fehlgeschlagen',
    signup_heading: 'Registrierung',
    signup_subtitle: 'Erstellen Sie ein Konto, um Angebote zu verwalten, Beratungen zu speichern und Anfragen schneller zu senden',
    signup_name: 'Name *',
    signup_namePlaceholder: 'Max Mustermann',
    signup_email: 'E-Mail *',
    signup_password: 'Passwort *',
    signup_pwPlaceholder: 'Mindestens 6 Zeichen',
    signup_company: 'Unternehmen',
    signup_companyPlaceholder: '(Optional) Firmenname',
    signup_phone: 'Telefon',
    signup_phonePlaceholder: '(Optional) 010-1234-5678',
    signup_submitting: 'Registrierung…',
    signup_emailSignup: 'Mit E-Mail registrieren',
    signup_hasAccount: 'Haben Sie bereits ein Konto?',
    signup_login: 'Anmelden',

    // ── CartPage ──
    cart_product: 'Produkt',
    cart_heading: 'Warenkorb',
    cart_loginRequired: 'Bitte melden Sie sich an, um fortzufahren',
    cart_loginBtn: 'Anmelden',
    cart_empty: 'Ihr Warenkorb ist leer',
    cart_emptySub: 'Fügen Sie interessante Produkte hinzu',
    cart_browse: 'Produkte durchsuchen',
    cart_sktec: 'Unser Shop',
    cart_rental: 'Miete',
    cart_copier: 'MFP',
    cart_toner: 'Toner',
    cart_won: 'KRW',
    cart_remove: 'Entfernen',
    cart_orderSummary: 'Bestellübersicht',
    cart_itemCount: 'Artikel',
    cart_count: 'Stk.',
    cart_totalQty: 'Gesamtmenge',
    cart_estimatedTotal: 'Geschätzter Betrag',
    cart_checkout: 'Bestellen',
    cart_inquiryBtn: 'Angebot anfordern',
    cart_phoneNote: 'Telefonberatung: Ilkwang Office – Bürogeräte-Experten',

    // ── WishlistPage ──
    wish_product: 'Produkt',
    wish_heading: 'Merkliste',
    wish_loginRequired: 'Bitte melden Sie sich an, um fortzufahren',
    wish_loginBtn: 'Anmelden',
    wish_empty: 'Ihre Merkliste ist leer',
    wish_emptySub: 'Tippen Sie auf ♥ bei Produkten, die Ihnen gefallen',
    wish_browse: 'Produkte durchsuchen',
    wish_sktec: 'Unser Shop',
    wish_rental: 'Miete',
    wish_copier: 'MFP',
    wish_toner: 'Toner',
    wish_won: 'KRW',
    wish_added: 'Gespeichert',
    wish_addToCart: 'In den Warenkorb',

    // ── ComparePage ──
    compare_product: 'Produkt',
    compare_specType: 'Typ',
    compare_specPrice: 'Preis',
    compare_specBrand: 'Marke',
    compare_specColor: 'Farbe / S/W',
    compare_specSpeed: 'Druckgeschwindigkeit',
    compare_specVolume: 'Monatsvolumen',
    compare_specPaper: 'Papierformat',
    compare_specDuplex: 'Duplexdruck',
    compare_specScan: 'Scannen',
    compare_specFax: 'Fax',
    compare_specNetwork: 'Netzwerk',
    compare_specDesc: 'Beschreibung',
    compare_sktec: 'Unser Shop',
    compare_rental: 'Miete',
    compare_copier: 'MFP',
    compare_toner: 'Toner',
    compare_won: 'KRW',
    compare_addProduct: 'Produkt hinzufügen',
    compare_searchPlaceholder: 'Nach Produktname oder Marke suchen…',
    compare_noSearchResults: 'Keine Ergebnisse',
    compare_loginRequired: 'Anmeldung erforderlich',
    compare_addedToCart: 'Zum Warenkorb hinzugefügt',
    compare_addedToWishlist: 'Zur Merkliste hinzugefügt',
    compare_removedFromWishlist: 'Von der Merkliste entfernt',
    compare_heading: 'Produktvergleich',
    compare_subtitle: 'Vergleichen Sie Spezifikationen auf einen Blick.',
    compare_comparing: ' Produkte verglichen',
    compare_clearAll: 'Alles löschen',
    compare_priceInquiry: 'Preisanfrage',
    compare_cart: 'Warenkorb',
    compare_detail: 'Details ansehen',
    compare_emptyTitle: 'Wählen Sie Produkte zum Vergleichen',
    compare_emptyDesc: 'Klicken Sie oben auf „Produkt hinzufügen" oder nutzen Sie die Vergleichsfunktion in der Produktliste.',
    compare_browseProd: 'Produkte durchsuchen',

    // ── CheckoutPage ──
    checkout_product: 'Produkt',
    checkout_heading: 'Bestellung aufgeben',
    checkout_loginRequired: 'Anmeldung erforderlich',
    checkout_loginBtn: 'Anmelden',
    checkout_emptyCart: 'Ihr Warenkorb ist leer',
    checkout_browse: 'Produkte durchsuchen',
    checkout_validation: 'Bitte geben Sie Empfänger, Telefonnummer und Lieferadresse an.',
    checkout_error: 'Bei der Bestellung ist ein Fehler aufgetreten.',
    checkout_delivery: 'Lieferinformationen',
    checkout_recipient: 'Empfänger *',
    checkout_recipientPh: 'Name',
    checkout_phone: 'Telefon *',
    checkout_company: 'Unternehmen',
    checkout_companyPh: 'Firma (optional)',
    checkout_zip: 'PLZ',
    checkout_address: 'Lieferadresse *',
    checkout_addressPh: 'Adresse',
    checkout_detailAddr: 'Adresszusatz',
    checkout_detailAddrPh: 'Gebäude / Einheit',
    checkout_memo: 'Lieferhinweis',
    checkout_memoPh: 'Besondere Hinweise (optional)',
    checkout_payMethod: 'Zahlungsmethode',
    checkout_bankTransfer: 'Banküberweisung',
    checkout_bankInfo: 'Woori Bank 1005-xxx-xxxxxx',
    checkout_cardPay: 'Kartenzahlung',
    checkout_cardDesc: 'Nach telefonischer Beratung',
    checkout_postPay: 'Zahlung auf Rechnung',
    checkout_postPayDesc: 'Rechnung nach Lieferung',
    checkout_orderItems: 'Bestellpositionen',
    checkout_qty: 'Menge:',
    checkout_won: 'KRW',
    checkout_itemCount: 'Artikel',
    checkout_count: 'Stk.',
    checkout_shipping: 'Versand',
    checkout_free: 'Kostenlos',
    checkout_total: 'Gesamtbetrag',
    checkout_quoteGuide: 'Angebot auf Anfrage',
    checkout_processing: 'Bestellung wird verarbeitet…',
    checkout_placeOrder: 'Bestellung aufgeben',
    checkout_backToCart: '← Zurück zum Warenkorb',

    // ── OrderConfirmPage ──
    order_seoTitle: 'Bestellung bestätigt',
    order_notFound: 'Bestellinformationen nicht gefunden',
    order_browse: 'Produkte durchsuchen',
    order_success: 'Ihre Bestellung wurde aufgegeben',
    order_successSub: 'Ein Mitarbeiter wird sich in Kürze bei Ihnen melden',
    order_orderNo: 'Bestellnr.',
    order_amount: 'Betrag',
    order_won: 'KRW',
    order_guideTitle: 'Bestellvorgang',
    order_step1: 'Bestellung eingegangen',
    order_step1Desc: 'Ihre Bestellung wurde erfolgreich aufgenommen',
    order_step2: 'Bestätigung',
    order_step2Desc: 'Ein Mitarbeiter prüft Ihre Bestellung',
    order_step3: 'Vorbereitung',
    order_step3Desc: 'Produkte werden vorbereitet und geprüft',
    order_step4: 'Lieferung / Installation',
    order_step4Desc: 'Liefer- oder Installationstermin wird vereinbart',
    order_viewHistory: 'Bestellverlauf ansehen',
    order_continueShopping: 'Weiter einkaufen',

    // ── SitemapPage ──
    sitemap_seoTitle: 'Seitenübersicht – Ilkwang Office | MFP-Miete deutschlandweit',
    sitemap_seoDesc: 'Seitenübersicht von Ilkwang Office. Alle Seiten: regionale MFP-Miete, Produktshop, Angebotsanfragen u. v. m.',
    sitemap_heading: 'Seitenübersicht',
    sitemap_subtitle: 'Alle Seiten von Ilkwang Office auf einen Blick',
    sitemap_shopping: 'Shop',
    sitemap_allProducts: 'Alle Produkte',
    sitemap_productSearch: 'Produktsuche',
    sitemap_cartLink: 'Warenkorb',
    sitemap_wishlistLink: 'Merkliste',
    sitemap_compareLink: 'Vergleichen',
    sitemap_rentalSection: 'Miete',
    sitemap_nationalRental: 'Landesweite Miete',
    sitemap_rentalConsult: 'Mietberatung',
    sitemap_support: 'Support',
    sitemap_quoteInquiry: 'Angebotsanfrage',
    sitemap_phoneConsult: 'Telefonberatung 1600-7542',
    sitemap_account: 'Konto',
    sitemap_loginLink: 'Anmelden',
    sitemap_signupLink: 'Registrieren',
    sitemap_mypage: 'Mein Bereich',
    sitemap_regionalTitle: 'Regionale Mietangebote',
    sitemap_regionalDesc: 'MFP-Miete in {count} Regionen landesweit verfügbar',
    sitemap_districtCount: ' Regionen',
    sitemap_viewAll: 'Alle anzeigen →',
    sitemap_ctaTitle: 'Nicht gefunden, was Sie suchen?',
    sitemap_ctaSub: 'Unser Spezialist hilft Ihnen gerne weiter',
    sitemap_ctaBtn: 'Kontakt aufnehmen',

    // ── ProductCard ──
    card_wishlist: 'Merkliste',
    card_cart: 'Warenkorb',
    card_compare: 'Vergleichen',
    card_black: 'Schwarz',
    card_cyan: 'Cyan',
    card_magenta: 'Magenta',
    card_yellow: 'Gelb',
    card_set: 'Set',
    card_genuine: 'Original',
    card_compatible: 'Kompatibel',
    card_remanufactured: 'Wiederaufbereitet',
    card_yield: 'Ergiebigkeit',
    card_pages: 'Seiten',
    card_won: 'KRW',
    card_purchase: 'Kaufen',
    card_color: 'Farbe',
    card_mono: 'S/W',
    card_detail: 'Details',
    card_rentalBtn: 'Miete',

    // ── AiChat ──
    ai_errorMsg: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.\n\nDirekte Anfrage: Ilkwang Office 1600-7542',
    ai_q1: 'Empfehlen Sie ein Farb-MFP für ein 10-Personen-Büro',
    ai_q2: 'Miete vs. Kauf vergleichen',
    ai_q3: 'Wirtschaftlichstes S/W-MFP?',
    ai_q4: 'Preise für kompatible Toner',
    ai_header: 'KI-Assistent',
    ai_subtitle: 'Fragen Sie alles über MFPs, Drucker und Toner',
    ai_emptyTitle: 'Wie kann ich Ihnen helfen?',
    ai_emptyDesc: 'MFP-Empfehlungen, Toner-Kompatibilitätssuche, Preisvergleiche u. v. m.',
    ai_recCopier: 'Empfohlene MFPs',
    ai_recToner: 'Empfohlene Toner',
    ai_inputPlaceholder: 'Nachricht eingeben…',

    // ── InlineAiChat ──
    inlineAi_error: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
    inlineAi_q1: 'Mietkonditionen für dieses Produkt',
    inlineAi_q2: 'Ähnliche Modelle in dieser Preisklasse',
    inlineAi_q3: 'Preise für kompatible Toner',
    inlineAi_q4: 'Farb-MFP für ein 10-Personen-Büro',
    inlineAi_q5: 'Miete vs. Kauf',
    inlineAi_q6: 'Günstiges S/W-MFP',
    inlineAi_emptyText: 'Fragen Sie einfach',
    inlineAi_placeholder: 'Nachricht eingeben…',
    inlineAi_product: 'Produkt',

    // ── InlineInquiryForm ──
    inqForm_rental: 'Miete',
    inqForm_rentalMsg: 'Anfrage zur Miete.',
    inqForm_error: 'Fehler beim Senden. Bitte versuchen Sie es erneut.',
    inqForm_successTitle: 'Anfrage gesendet',
    inqForm_successDesc: 'Wir melden uns in Kürze bei Ihnen.',
    inqForm_name: 'Name *',
    inqForm_company: 'Unternehmen',
    inqForm_phone: 'Telefon *',
    inqForm_email: 'E-Mail',
    inqForm_inquiryType: 'Anfragetyp',
    inqForm_purchase: 'Kauf',
    inqForm_tonerSupplies: 'Toner & Verbrauchsmaterial',
    inqForm_maintenance: 'Wartung',
    inqForm_other: 'Sonstiges',
    inqForm_content: 'Nachricht',
    inqForm_submitting: 'Wird gesendet…',
    inqForm_submitBtn: 'Anfrage senden',
    inqForm_monthly: '/Monat',
    inqForm_won: 'KRW',

    // ── Footer ──
    footer_desc1: 'MFP, Drucker, Toner & Verbrauchsmaterial',
    footer_desc2: 'Miete · Verkauf · Wartung',
    footer_hours: 'Mo–Fr 10:00–18:00 Uhr',
    footer_lunch: 'Mittagspause 12:00–13:00 Uhr',
    footer_holidays: 'Wochenende & Feiertage geschlossen',
    footer_quickLinks: 'Schnellzugriff',
    footer_rentalLink: 'Mietanfrage',
    footer_mallLink: 'Online-Shop',
    footer_servicesTitle: 'Dienste',
    footer_svcAi: 'KI-MFP-Empfehlung',
    footer_svcSearch: 'Toner-Kompatibilitätssuche',
    footer_svcCompare: 'Original- vs. Kompatibel-Preisvergleich',
    footer_svcConsult: 'Mietangebots-Beratung',

    // ── Common ──
    common_won: 'KRW',
    common_count: 'Stk.',
    common_monthly: '/Monat',
    common_pages: 'Seiten',
    common_rental: 'Miete',
    common_sale: 'Verkauf',
    common_copier: 'MFP',
    common_toner: 'Toner',
    common_sktec: 'Unser Shop',
    common_priceInquiry: 'Preisanfrage',
    common_color: 'Farbe',
    common_mono: 'S/W',
    common_supported: 'Unterstützt',
    common_notSupported: 'Nicht unterstützt',
    common_goTo: 'Weiter >',

    // ── ProductDetailPage ──
    detail_reviewError: 'Bewertung konnte nicht eingereicht werden',
    detail_loading: 'Wird geladen...',
    detail_notFound: 'Produkt nicht gefunden.',
    detail_backToStore: '← Zurück zum Shop',
    detail_copier: 'MFP',
    detail_rental: 'Miete',
    detail_priceInquiry: 'Preisanfrage',
    detail_ilkwangOffice: 'Ilkwang Office',
    detail_sktec: 'Unser Shop',
    detail_sale: 'Verkauf',
    detail_seoul: 'Seoul',
    detail_overview: 'Übersicht',
    detail_specs: 'Technische Daten',
    detail_reviews: 'Bewertungen',
    detail_store: 'Shop',
    detail_freeDelivery: 'Landesweiter Versand',
    detail_expertConsult: 'Expertenberatung',
    detail_genuineWarranty: 'Originalgarantie',
    detail_monthlyRental: 'Monatliche Miete',
    detail_wonMonth: 'KRW/Monat',
    detail_salePrice: 'Verkaufspreis',
    detail_price: 'Preis',
    detail_won: 'KRW',
    detail_category: 'Kategorie:',
    detail_contract: 'Vertragslaufzeit:',
    detail_brand: 'Marke',
    detail_model: 'Modell',
    detail_categorySpec: 'Kategorie',
    detail_bwSpeed: 'S/W-Geschwindigkeit',
    detail_colorSpeed: 'Farbgeschwindigkeit',
    detail_paperSize: 'Papierformat',
    detail_fax: 'Fax',
    detail_supported: 'Unterstützt',
    detail_notSupported: 'Nicht unterstützt',
    detail_duplex: 'Duplexdruck',
    detail_monthlyVolume: 'Empf. monatliches Druckvolumen',
    detail_contractPeriod: 'Vertragslaufzeit',
    detail_addedToCart: '✓ Im Warenkorb',
    detail_addToCart: 'In den Warenkorb',
    detail_loginToCart: 'Anmelden, um in den Warenkorb zu legen',
    detail_rentalInquiry: 'Mietanfrage',
    detail_addedToWishlist: 'Zur Merkliste hinzugefügt',
    detail_addToWishlist: 'Zur Merkliste',
    detail_aiConsult: 'KI-Beratung',
    detail_phoneConsult: 'Anrufen: 1600-7542',
    detail_helpText: 'Lassen Sie sich bei der Produktauswahl beraten.',
    detail_chatNow: 'Jetzt chatten',
    detail_orCall: 'Oder rufen Sie 1600-7542 an.',
    detail_tabDetail: 'Produktdetails',
    detail_tabDelivery: 'Versandinfo',
    detail_tabReturn: 'Rückgabe & Umtausch',
    detail_tabReview: 'Bewertungen',
    detail_noDetail: 'Keine Produktdetails verfügbar.',
    detail_productImages: 'Produktbilder',
    detail_deliveryGuide: 'Versandhinweise',
    detail_deliveryMethod: 'Versandart: Paketdienst / Direktlieferung (bei großen MFP)',
    detail_deliveryArea: 'Liefergebiet: Landesweit (außer abgelegene Inseln)',
    detail_deliveryTime: 'Lieferzeit: Paketdienst 2–3 Tage / Installation von Großgeräten nach Vereinbarung',
    detail_deliveryFee: 'Versandkosten: Kostenlos (Aufpreis für abgelegene Gebiete möglich)',
    detail_deliveryInquiry: 'Fragen zum Versand:',
    detail_returnGuide: 'Rückgabe & Umtausch',
    detail_returnPeriod: 'Rückgabe-/Umtauschfrist',
    detail_returnPeriodDesc: 'Rückgabe/Umtausch innerhalb von 7 Tagen nach Erhalt möglich',
    detail_returnExclude: 'Ausgeschlossene Fälle',
    detail_returnExclude1: 'Beschädigte Verpackung oder Produkt durch den Kunden',
    detail_returnExclude2: 'Gebrauchter Toner oder Verbrauchsmaterial',
    detail_returnExclude3: 'Sonderanfertigungen',
    detail_returnExclude4: 'Mehr als 7 Tage nach Erhalt',
    detail_returnCost: 'Rückgabe-/Umtauschkosten',
    detail_returnCostDesc: 'Kostenlos bei Defekt/Falschlieferung; sonst Hin- und Rückversand auf Kundenkosten',
    detail_returnInquiry: 'Fragen zu Rückgabe/Umtausch:',
    detail_reviewCount: ' Bewertungen',
    detail_noReviews: 'Noch keine Bewertungen vorhanden.',
    detail_reviewer: 'Käufer',
    detail_writeReview: 'Bewertung schreiben',
    detail_rating: 'Bewertung',
    detail_reviewTitlePh: 'Titel der Bewertung (optional)',
    detail_reviewContentPh: 'Teilen Sie Ihre Erfahrung mit diesem Produkt...',
    detail_submittingReview: 'Wird eingereicht...',
    detail_submitReview: 'Bewertung absenden',
    detail_ctaTitle: 'Brauchen Sie eine Lösung?',
    detail_ctaDesc: 'Entwickeln Sie mit den Experten von Ilkwang Office die optimale Lösung.',
    detail_ctaBtn: 'Expertenberatung',
    detail_aiConsultPanel: 'KI-Beratung',
    detail_rentalPanel: 'Mietanfrage',

    // ── CopierDetailPage ──
    copier_loading: 'Wird geladen...',
    copier_notFound: 'Produkt nicht gefunden',
    copier_backToList: '← Zurück zur Produktliste',
    copier_seoSuffix: 'MFP-Details - Ilkwang Office',
    copier_seoDesc: 'Detaillierte MFP-Informationen. Spezifikationen, Preise, Mietbedingungen, kompatible Toner. Vergleichen Sie MFPs bei Ilkwang Office.',
    copier_catalog: 'Produktkatalog',
    copier_color: 'Farbe',
    copier_mono: 'S/W',
    copier_speed: 'Druckgeschwindigkeit',
    copier_paperSize: 'Papierformat',
    copier_monthlyVolume: 'Empf. monatliches Druckvolumen',
    copier_priceRange: 'Preisklasse',
    copier_addedToCart: '✓ Hinzugefügt',
    copier_cart: 'Warenkorb',
    copier_wishlistOn: '♥ Gemerkt',
    copier_wishlistOff: '♡ Merken',
    copier_compare: '⚖️ Vergleichen',
    copier_buyAtMall: 'In unserem Shop kaufen',
    copier_rentalInquiry: '📞 Mietanfrage',
    copier_askAi: '🤖 KI fragen',
    copier_compatToner: '🔵 Kompatibler Toner / Verbrauchsmaterial',
    copier_tonerCount: 'Sorten',
    copier_priceCompare: '💰 Original vs. kompatibel: Preisvergleich',
    copier_thToner: 'Toner',
    copier_thColor: 'Farbe',
    copier_thGenuine: 'Originalpreis',
    copier_thCompatible: 'Kompatibler Preis',
    copier_thSaving: 'Ersparnis',
    copier_thYield: 'Ergiebigkeit',
    copier_black: 'Schwarz',
    copier_cyan: 'Cyan',
    copier_magenta: 'Magenta',
    copier_yellow: 'Gelb',
    copier_set: 'Set',
    copier_won: 'KRW',
    copier_pages: 'Seiten',
    copier_noToner: 'Keine kompatiblen Tonerinformationen verfügbar. Kontaktieren Sie Ilkwang Office (1600-7542).',
    copier_aiPanel: 'KI-Beratung',
    // ── RegionalRentalPage ──
    rental_locationTitle: 'Standortbasierte Empfehlungen',
    rental_locationDesc: 'Teilen Sie Ihren Standort, um Kopierer-Mietempfehlungen in Ihrer Nähe zu erhalten.',
    rental_later: 'Später',
    rental_allowLocation: 'Standort erlauben',
    rental_myLocation: 'Mein Standort',
    rental_all: 'Alle',
    rental_copierRental: 'Kopierer-Miete',
    rental_regionCopierRental: 'Regionale Kopierer-Miete',
    rental_nationwideCopierRental: 'Deutschlandweite Kopierer-Miete nach Region',
    rental_districtDesc: 'Kopierer- & Druckermiete in der Region. Kostenlose Installation, regelmäßige Wartung & Toner-Support.',
    rental_regionDesc: 'Kopierer-Mietservice in der gesamten Region. Wählen Sie einen Bezirk.',
    rental_nationwideDesc: 'Kopierer-Miete deutschlandweit. Wählen Sie ein Bundesland zum Starten.',
    rental_nationwide: 'Deutschlandweit',
    rental_districts: 'Bezirke',
    rental_products: 'Produkte',
    rental_selectRegion: 'Region wählen',
    rental_findByLocation: 'Nach Standort suchen',
    rental_searchPlaceholder: 'Kopierer suchen...',
    rental_region: 'Region',
    rental_filterAll: 'Alle',
    rental_filterColor: 'Farbe',
    rental_filterMono: 'S/W',
    rental_brandAll: 'Alle Marken',
    rental_categoryAll: 'Alle Kategorien',
    rental_sortDefault: 'Sortierung: Standard',
    rental_sortPriceAsc: 'Preis: aufsteigend',
    rental_sortPriceDesc: 'Preis: absteigend',
    rental_sortName: 'Nach Name',
    rental_reset: 'Zurücksetzen',
    rental_rentalProducts: 'Mietprodukte',
    rental_count: '',
    rental_quoteInquiry: 'Angebotsanfrage',
    rental_noProductsYet: 'Noch keine Produkte in dieser Region registriert',
    rental_selectDistrict: 'Bitte wählen Sie einen Bezirk',
    rental_requestQuoteDesc: 'Wenn Sie einen Kopierer in dieser Region benötigen, fordern Sie ein Angebot an. Unsere Spezialisten beraten Sie zum besten Mietplan.',
    rental_selectRegionHint: 'Wählen Sie links eine Region, um verfügbare Mietprodukte anzuzeigen.',
    rental_requestQuote: 'Angebot anfordern',
    rental_freeInstall: 'Kostenlose Installation',
    rental_freeInstallDesc: 'Kostenlose Lieferung & Installation deutschlandweit',
    rental_regularCheck: 'Regelmäßige Wartung',
    rental_regularCheckDesc: 'Monatlicher kostenloser Wartungsservice',
    rental_freeToner: 'Kostenloser Toner',
    rental_freeTonerDesc: 'Kostenlose Lieferung von Verbrauchsmaterialien',
    rental_badge_rental: 'Miete',
    rental_badge_both: 'Kauf+Miete',
    rental_monthly: 'Mo.',
    rental_won: 'KRW',
    rental_priceInquiry: 'Preis auf Anfrage',
    rental_detail: 'Details →',
    rental_copierConsult: 'Kopierer-Mietberatung',
    rental_ctaDesc: 'Fordern Sie jetzt ein Angebot an. Kostenlose Installation, regelmäßige Wartung & kostenloser Toner.',
    rental_freeQuoteRequest: 'Kostenloses Angebot anfordern',
    // ── CustomerERPPage ──
    erp_home: 'Start',
    erp_aiConsult: 'KI-Beratung',
    erp_usageAnalysis: 'Nutzungsanalyse',
    erp_quoteManage: 'Angebotsverwaltung',
    erp_inquiryManage: 'Anfragenverwaltung',
    erp_cart: 'Warenkorb',
    erp_wishlist: 'Wunschliste',
    erp_orderHistory: 'Bestellverlauf',
    erp_purchaseManage: 'Einkaufsverwaltung',
    erp_chatHistory: 'Chat-Verlauf',
    erp_myInfo: 'Meine Daten',
    erp_reviewLounge: 'Bewertungs-Lounge',
    erp_tripManage: 'Dienstreisen',
    erp_tripDesc: 'Routen planen mit Start, Zwischenstopps und Ziel',
    erp_statusDraft: 'Entwurf',
    erp_statusSubmitted: 'Eingereicht',
    erp_statusReviewed: 'In Prüfung',
    erp_statusSent: 'Versendet',
    erp_typeRental: 'Miete',
    erp_typePurchase: 'Kauf',
    erp_typeToner: 'Toner',
    erp_typeEtc: 'Sonstiges',
    erp_aiConsultDesc: 'Fragen Sie die KI alles',
    erp_usageDesc: 'Berichtfoto → KI-Autoerkennung',
    erp_quickInquiry: 'Schnellanfrage',
    erp_quickInquiryDesc: 'In 1 Minute erledigt',
    erp_writeQuote: 'Angebot erstellen',
    erp_writeQuoteDesc: 'Individuelles Angebot erhalten',
    erp_bulkPurchase: 'Großeinkauf',
    erp_bulkPurchaseDesc: 'Für Firmeneinkäufer',
    erp_nationalRental: 'Bundesweite Miete',
    erp_nationalRentalDesc: 'Lokale Miete suchen',
    erp_compare: 'Produkte vergleichen',
    erp_compareDesc: 'Kopierer-Vergleichsanalyse',
    erp_productSearch: 'Produktsuche',
    erp_productSearchDesc: 'KI-personalisierte Empfehlung',
    erp_wishlistDesc: 'Gespeicherte Produkte ansehen',
    erp_sitemap: 'Sitemap',
    erp_sitemapDesc: 'Alle Menüs auf einen Blick',
    erp_allProducts: 'Alle Produkte',
    erp_aiSearch: 'KI-Suche',
    erp_myPage: 's Meine Seite',
    erp_seoDesc: 'Ilkwang Office Kunden-ERP – Angebote, Anfragen, KI-Beratung, Einkaufsverwaltung',
    erp_hello: 'Hallo',
    erp_honorific: '',
    erp_goHome: 'Startseite',
    erp_logout: 'Abmelden',
    erp_siteShortcuts: 'Schnellzugriff',
    erp_more: 'Mehr',
    erp_quotes: 'Angebote',
    erp_inquiryHistory: 'Anfragenverlauf',
    erp_shortcuts: 'Schnellzugriff',
    erp_recentQuotes: 'Neueste Angebote',
    erp_viewAll: 'Alle anzeigen →',
    erp_recentInquiries: 'Neueste Anfragen',
    erp_tipText: '💡 Wussten Sie schon?',
    erp_tipDesc: 'Lassen Sie sich von der KI den besten Kopierer empfehlen und erstellen Sie sofort ein Angebot.',
    erp_tipBtnAi: 'KI-Chat starten',
    erp_aiDesc: 'Der KI-Assistent empfiehlt die besten Kopierer und Toner',
    erp_newChat: 'Neuer Chat',
    erp_prevChats: 'Vorherige Chats',
    erp_aiAsk: 'KI-Assistenten fragen',
    erp_aiHint: 'Fragen Sie nach Kopierer-Empfehlungen, Toner-Kompatibilität, Preisvergleichen usw.',
    erp_suggestOffice: 'Empfehlen Sie einen Kopierer für mein Büro',
    erp_suggestCompare: 'Farbkopierer vergleichen',
    erp_suggestToner: 'Kompatible Toner finden',
    erp_suggestSmall: 'Beste Produkte für ein kleines Büro?',
    erp_recCopier: 'Empfohlene Kopierer',
    erp_recToner: 'Empfohlene Toner',
    erp_msgPlaceholder: 'Nachricht eingeben...',
    erp_chatError: 'Entschuldigung, ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
    erp_quoteManageDesc: 'Angebote erstellen und verwalten',
    erp_newQuote: 'Neues Angebot',
    erp_noQuotes: 'Noch keine Angebote',
    erp_noQuotesHint: 'Erstellen Sie ein neues Angebot',
    erp_createQuote: 'Angebot erstellen',
    erp_submit: 'Einreichen',
    erp_delete: 'Löschen',
    erp_adminNote: 'Admin-Notiz:',
    erp_items: 'Positionen',
    erp_backToQuotes: '← Angebotsliste',
    erp_newQuoteTitle: 'Neues Angebot erstellen',
    erp_quoteTitle: 'Angebotstitel',
    erp_companyName: 'Firmenname',
    erp_addItem: 'Position hinzufügen',
    erp_productModel: 'Produkt / Modellname',
    erp_quantity: 'Menge',
    erp_addMore: '+ Hinzufügen',
    erp_productNameCol: 'Produkt',
    erp_typeCol: 'Typ',
    erp_additionalNotes: 'Zusätzliche Anmerkungen (optional)',
    erp_saveQuote: 'Angebot speichern',
    erp_inquiryManageDesc: 'Anfragen senden und Antworten prüfen',
    erp_autoFillInfo: 'Infos automatisch ausgefüllt',
    erp_rentalInquiry: 'Mietanfrage',
    erp_purchaseInquiry: 'Kaufanfrage',
    erp_tonerInquiry: 'Toneranfrage',
    erp_etcInquiry: 'Sonstige Anfrage',
    erp_sendInquiry: 'Anfrage senden',
    erp_noInquiries: 'Noch keine Anfragen',
    erp_adminReply: 'Admin-Antwort',
    erp_inquiryPlaceholder: 'Anfrage eingeben...',
    erp_answered: 'Beantwortet',
    erp_processing: 'In Bearbeitung',
    erp_received: 'Eingegangen',
    erp_emptyCart: 'Ihr Warenkorb ist leer',
    erp_emptyCartHint: 'Fügen Sie Produkte hinzu, die Ihnen gefallen',
    erp_browseProducts: 'Produkte durchstöbern →',
    erp_copier: 'Kopierer',
    erp_toner: 'Toner',
    erp_inHouse: 'Intern',
    erp_requestQuoteInquiry: 'Angebot anfragen',
    erp_goToCart: 'Zum Warenkorb →',
    erp_product: 'Produkt',
    erp_won: 'KRW',
    erp_cartInquiry: 'Schnellanfrage',
    erp_saved: 'Auf Wunschliste gespeichert',
    erp_emptyWishlist: 'Ihre Wunschliste ist leer',
    erp_emptyWishlistHint: 'Tippen Sie auf das Herz bei Produkten zum Speichern',
    erp_viewDetail: 'Details ansehen',
    erp_copierAnalysis: 'Kopierer-Nutzungsanalyse',
    erp_copierAnalysisDesc: 'KI analysiert Ihre Kopierer-Berichte automatisch',
    erp_uploadReport: 'Bericht hochladen',
    erp_uploadReportDesc: 'Laden Sie ein Foto Ihres Kopierer-Berichts hoch',
    erp_clientName: 'Kundenname',
    erp_clientExample: 'z.B.: Ilkwang Office',
    erp_selectOtherFile: 'Andere Datei wählen',
    erp_startAnalysis: 'Analyse starten',
    erp_aiAnalyzing: 'KI analysiert...',
    erp_analysisResult: 'Analyseergebnis',
    erp_close: 'Schließen',
    erp_modelName: 'Modell',
    erp_reportDate: 'Berichtsdatum',
    erp_totalPages: 'Gesamtseiten',
    erp_color: 'Farbe',
    erp_bw: 'S/W',
    erp_scan: 'Scan',
    erp_fax: 'Fax',
    erp_copy: 'Kopie',
    erp_printPages: 'Druck',
    erp_tonerRemaining: 'Toner-Restbestand',
    erp_usageByUser: 'Nutzung nach Benutzer',
    erp_user: 'Benutzer',
    erp_total: 'Gesamt',
    erp_extraInfo: 'Zusatzinfo',
    erp_analysisHistory: 'Analyseverlauf',
    erp_countUnit: '',
    erp_noReports: 'Noch kein Analyseverlauf',
    erp_unknownModel: 'Unbekannt',
    erp_client: 'Kunde',
    erp_totalPrefix: 'Gesamt',
    erp_sheets: 'Blatt',
    erp_orderHistoryDesc: 'Überprüfen Sie Ihren Bestellverlauf',
    erp_noOrders: 'Noch keine Bestellungen',
    erp_noOrdersHint: 'Ihre Bestellungen erscheinen hier',
    erp_orderPending: 'Ausstehend',
    erp_orderConfirmed: 'Bestätigt',
    erp_orderProcessing: 'In Bearbeitung',
    erp_orderShipping: 'Im Versand',
    erp_orderDelivered: 'Geliefert',
    erp_orderCancelled: 'Storniert',
    erp_orderRefunded: 'Erstattet',
    erp_qtyLabel: 'Menge',
    erp_cancelOrder: 'Bestellung stornieren',
    erp_purchaseManageDesc: 'Großbestellungen und Mietanfragen verwalten',
    erp_bulkInquiry: 'Großbestellung/Mietanfrage',
    erp_bulkInquiryDesc: 'Geben Sie Ihre Geräteanforderungen ein',
    erp_equipment: 'Gerät',
    erp_productReq: 'Produkt/Spezifikationen',
    erp_productReqExample: 'z.B.: Farbkopierer A3',
    erp_installLocation: 'Installationsort',
    erp_installExample: 'z.B.: Berlin Mitte',
    erp_addEquipment: '+ Gerät hinzufügen',
    erp_sendBulkInquiry: 'Großanfrage senden',
    erp_corporateGuide: 'Firmeneinkaufs-Leitfaden',
    erp_corpFeat1Title: 'Expertenberatung',
    erp_corpFeat1Desc: 'Maßgeschneiderte Beratung für Ihre Firmengröße',
    erp_corpFeat2Title: 'Mengenrabatt',
    erp_corpFeat2Desc: 'Sonderrabatte ab 10 Einheiten',
    erp_corpFeat3Title: 'Einheitliche Verwaltung',
    erp_corpFeat3Desc: 'Unternehmensweite Geräteverwaltung',
    erp_corpFeat4Title: 'Prioritätsservice',
    erp_corpFeat4Desc: 'Prioritärer technischer Support für Firmen',
    erp_corpFeat5Title: 'Monatsberichte',
    erp_corpFeat5Desc: 'Monatliche Nutzungsberichte',
    erp_dedicatedConsult: 'Persönlicher Berater',
    erp_dedicatedConsultDesc: 'Firmenkunden erhalten einen persönlichen Berater',
    erp_makeInquiry: 'Anfrage stellen',
    erp_individualBuyer: 'Einzelkäufer',
    erp_aiRec: 'KI-Empfehlung',
    erp_rentalQuote: 'Mietangebot',
    erp_clickToSelect: 'Klicken zum Auswählen',
    erp_aiChatHistory: 'KI-Chat-Verlauf',
    erp_aiChatHistoryDesc: 'Vorherige KI-Beratungen ansehen',
    erp_noChatHistory: 'Noch kein KI-Chat-Verlauf',
    erp_startAiChat: 'KI-Chat starten',
    erp_messagesCount: ' Nachrichten',
    erp_editProfileDesc: 'Profildaten bearbeiten',
    erp_name: 'Name',
    erp_company: 'Firma',
    erp_phone: 'Telefon',
    erp_email: 'E-Mail',
    erp_editProfile: 'Profil bearbeiten',
    erp_accountInfo: 'Kontoinformationen',
    erp_accountType: 'Kontotyp',
    erp_local: 'Lokal',
    erp_accountLabel: 'Konto',
    erp_loginLabel: 'Anmeldung',
    erp_role: 'Rolle',
    erp_roleAdmin: 'Administrator',
    erp_roleMember: 'Mitglied',
    erp_deleteAccount: 'Konto löschen',
    erp_deleteAccountDesc: 'Das Löschen des Kontos entfernt alle Daten dauerhaft.',
    erp_deleteAccountRequest: 'Kontolöschung beantragen',
    erp_deleteAccountConfirm: 'Sind Sie sicher? Diese Aktion kann nicht rückgängig gemacht werden.',
    erp_deleteNow: 'Jetzt löschen',
    erp_cancel: 'Abbrechen',
    erp_requestDelete: 'Löschung beantragen',
    erp_deleteAccountAlerted: 'Kontolöschung wurde beantragt. Der Admin wird sie bearbeiten.',
    erp_errorOccurred: 'Ein Fehler ist aufgetreten',
    erp_myReviewLounge: 'Meine Bewertungs-Lounge',
    erp_communityDesc: 'Community-Aktivität prüfen',
    erp_myTonerPoints: 'Meine Toner-Punkte',
    erp_myBadge: 'Mein Abzeichen',
    erp_goToReviewLounge: 'Zur Bewertungs-Lounge →',
    erp_myPosts: 'Meine Beiträge',
    erp_myComments: 'Meine Kommentare',
    erp_pointHistory: 'Punkteverlauf',
    erp_noMyPosts: 'Noch keine Beiträge',
    erp_noMyComments: 'Noch keine Kommentare',
    erp_totalPoints: 'Gesamtpunkte',
    erp_badgeLevel: 'Abzeichenstufe',
    erp_maxDiscount: 'Max. Rabatt',
    erp_typeLabel: 'Typ',
    erp_pointLabel: 'Punkte',
    erp_reason: 'Grund',
    erp_dateTime: 'Datum',
    erp_noPointHistory: 'Noch kein Punkteverlauf',
    erp_earn: 'Verdient',
    erp_spend: 'Ausgegeben',
    erp_rec: 'Empf.',
    erp_commentsLabel: 'Kommentare',
    erp_views: 'Aufrufe',
    erp_badgeA4: 'A4 Anfänger',
    erp_badgeInkjet: 'Inkjet Läufer',
    erp_badgeColorLaser: 'Farblaser Profi',
    erp_badgeMaster: 'Kopierer Meister',
    livechat_consult: 'Live-Chat',
    livechat_channelSelect: 'Kanal wählen',
    livechat_chat: 'Live-Chat',
    livechat_hours: 'Mo–Fr 09:00–18:00',
    livechat_howToConsult: 'Wie möchten Sie chatten?',
    livechat_kakaoChat: 'KakaoTalk Chat',
    livechat_kakaoDesc: 'Schnelle Antwort · Fotos senden',
    livechat_fastResponse: 'Schnell',
    livechat_siteChat: 'Site-Live-Chat',
    livechat_siteChatDesc: 'Nach Anmeldung chatten',
    livechat_aiAssistant: 'KI-Assistent',
    livechat_aiAssistantDesc: '24/7 automatische KI-Beratung',
    livechat_kakaoFastest: 'KakaoTalk ist am schnellsten!',
    livechat_customerCenter: 'Kundencenter',
    livechat_welcome: 'Fragen Sie uns alles!',
    livechat_askAnything: 'Hinterlassen Sie Ihre Fragen zu Kopierern, Tonern, Mieten usw.',
    livechat_fasterTip: 'Für schnellere Hilfe probieren Sie',
    livechat_kakaoLink: 'KakaoTalk Chat',
    livechat_fasterTipSuffix: '!',
    livechat_agent: 'Berater',
    livechat_inputPlaceholder: 'Nachricht eingeben...',
    livechat_chatClosed: 'Chat wurde beendet',
    filter_all: 'Alle',
  },
};

export default pageT;
